// disabled={localStorage.getItem("country") === "INDIA"}

import React, { useState, useRef, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import JsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Pagination,
  CircularProgress,
  Link,
  Avatar,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Skeleton,
  Switch,
  Tooltip,
} from '@mui/material';

import { styled } from '@mui/material/styles';
import { Icon } from '@iconify/react';
import moment from 'moment';
import { Helmet } from 'react-helmet-async';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// import { ToastContainer, toast } from 'react-toastify';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CustomCompleteWorksheet from '../components/customComplete/CustomCompleteWorksheet';
import CustomComplete from '../components/customComplete/CustomComplete';
import CustomCompleteWorksheets from '../components/customComplete/customCompleteWorksheets';
import MyCustomUploadAdapterPlugin from './customEditor/customEditor';

import Iconify from '../components/iconify';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Scrollbar from '../components/scrollbar/Scrollbar';
import countries from './countryJson/countryJson.json';
import PlacementTimeline from './PlacementTimeline';
import { Api, UploadFile } from '../webservices';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { md: '50%', xs: '95%' },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  border: '3px solid #3C6BA5',
  borderRadius: 3,
};

const style1 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { md: '50%', xs: '95%' },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  border: '2px solid #3C6BA5',
  borderRadius: 3,
};

const styleSkill = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '85%', sm: '75%' },
  bgcolor: 'background.paper',
  border: '3px solid #3C6BA5',
  boxShadow: 24,
  p: 3,
  borderRadius: 3,
};

function Placement() {
  const [tempList, setTempList] = useState([]);
  const [tableData2, settableData2] = useState([]);
  const [tableData3, setTableData3] = useState([]);

  const [tableDataPayment, settableDataPayment] = useState([]);
  const [benchPaymentData, setBenchPaymentData] = useState([]);

  const [modalOpen1, setModalOpen1] = useState(false);

  const handleOpenModal1 = () => {
    setModalOpen1(true);
  };
  const [cityy, setCityy] = useState('');
  const [value1, setValue1] = useState('');
  const [cityData, setcityData] = useState([]);
  const [cityandstate, setCityandstate] = useState();
  // console.log("cityandstate", cityandstate)
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("hhhhhhh=====>>>>",location );

  const [valuee, setValuee] = useState('rec');

  useEffect(() => {
    console.log('location==>>>', location.state?.valuee);

    handleTabChange(location.state?.valuee || 'rec');

    if (location.state?.valuee) {
      navigate(location.pathname, {
        //   replace: true,
        state: null,
      });
    }
  }, []);

  useEffect(() => {
    setTableData([]);
    getRecPlacement();
    getTemplList();
    // getBenchPlacement()
  }, []);

  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);

  const tableLabel = [
    { id: 1, label: 'Date' },
    { id: 2, label: 'Information' },
    { id: 3, label: 'Candidate Info' },
    { id: 4, label: 'Job Info' },
    { id: 5, label: 'Ownership' },
    { id: 6, label: 'Tenure' },
    { id: 7, label: 'Status' },
    { id: 8, label: 'Invoicing' },
  ];
  const tableLabelSecond = [
    { id: 1, label: 'Company Name' },
    { id: 2, label: 'Name' },
    { id: 3, label: 'Email ID' },
    { id: 4, label: 'Phone' },
    { id: 5, label: 'Payment' },
    { id: 6, label: 'Paid Till' },
    { id: 7, label: 'Pending' },
    { id: 8, label: 'Action' },
  ];
  const tableLabelThird = [
    { id: 1, label: 'Company Name' },
    { id: 2, label: 'Name' },
    { id: 3, label: 'Email ID' },
    { id: 4, label: 'Phone' },
    { id: 5, label: 'Timesheet' },
    { id: 6, label: 'Approved Till' },
    { id: 7, label: 'Pending' },
    { id: 8, label: 'Action' },
  ];

  const [loading, setLoading] = useState();

  const getRecPlacement = async (page) => {
    setTableData([]);
    setPages('');
    setTableCount('');
    setLoading('Loading...');
    const body = {
      status: 'placement',
      page: page || 1,
      limit: '35',
    };
    const token = localStorage.getItem('token');

    Api(`resume/getPlacementByStatus`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          console.log('Ravish bhardwaj =====>>', response);
          if (response.data.data?.length) {
            setTableData(response.data.data);
            setTableCount(response.data.count);
            const totalPage = Math?.ceil(response.data?.count / 35);
            setPages(totalPage);

            setLoading('');
          } else {
            setLoading('No data found');
            // toast.warn('No resumes submissions found!');
          }
        } else if (response.status === 204) {
          setLoading('No data found');
          // toast.warn('No resumes submissions found!');
        } else {
          // setLoading('Error occurred');
          // toast.warn(response.data.message);
        }
      })
      .catch((err) => {
        // setLoading('Error occurred');
        // toast.error('An error occurred: ' + err);
      });
  };

  const formatDate = (date) => {
    if (!date) return '-';

    const d = new Date(date);

    return d.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  const getRecPlacementWithCompany = (page) => {
    const token = localStorage.getItem('token');

    setTableCount('');
    setPages('');
    setLoading('Loading...');

    const body = {
      page: page || 1,
      limit: '35',
    };

    Api('resume/getRecPlacementWithCompany', 'POST', body, token)
      .then((response) => {
        console.log('heello code =====>>', response);
        if (response.status === 200) {
          if (response.data?.data?.length > 0) {
            settableData2(response.data.data);
            setTableCount(response.data.count);
            const totalPage = Math?.ceil(response.data?.count / 35);
            setPages(totalPage);
            setLoading('');
          } else {
            setLoading('No data found');
          }
        } else {
          setLoading('No data found');
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
      });
  };

  const getRecPlacementPaymentHis = (page) => {
    const token = localStorage.getItem('token');

    setTableCount('');
    setPages('');
    setLoading('Loading...');

    const body = {
      page: page || 1,
      limit: 35,
    };

    Api('resume/getRecPlacementPaymentHis', 'POST', body, token)
      .then((response) => {
        console.log('Payment History Response =====>>', response);

        if (response.status === 200) {
          console.log('===============>>>>>>>', response);

          if (response.data?.data?.length > 0) {
            settableDataPayment(response.data.data);
            setTableCount(response.data.count);

            const totalPage = Math.ceil(response.data.count / 35);
            setPages(totalPage);
            setLoading('');
          } else {
            setLoading('No data found');
          }
        } else {
          setLoading('No data found');
        }
      })
      .catch((err) => {
        // toast.error(err + "!");
        setLoading('No data found');
      });
  };

  const getBenchPlacementPaymentHis = (page) => {
    const token = localStorage.getItem('token');

    setTableCount('');
    setPages('');
    setLoading('Loading...');

    const body = {
      page: page || 1,
      limit: 35,
    };

    Api('bench/getBenchPlacementPaymentHis', 'POST', body, token)
      .then((response) => {
        console.log('Bench Payment History Response =====>>', response);

        if (response.status === 200) {
          console.log('===============>>>>>>>', response);

          if (response.data?.data?.length > 0) {
            setBenchPaymentData(response.data.data);
            setTableCount(response.data.count);
            const totalPage = Math?.ceil(response.data?.count / 35);
            setPages(totalPage);
            setLoading('');
          } else {
            setLoading('No data found');
          }
        } else {
          setLoading('No data found');
        }
      })
      .catch((err) => {
        // toast.error(err + "!");
      });
  };

  const getBenchPlacementWithCompany = (page) => {
    const token = localStorage.getItem('token');

    setTableCount('');
    setPages('');
    setLoading('Loading...');

    const body = {
      page: page || 1,
      limit: '35',
    };

    Api('bench/getBenchPlacementWithCompany', 'POST', body, token)
      .then((response) => {
        console.log('response ===>>>', response);

        if (response.status === 200) {
          if (response.data?.data?.length > 0) {
            setTableData3(response?.data?.data);
            setTableCount(response?.data?.count);

            const totalPage = Math.ceil(response.data?.count / 35);
            setPages(totalPage);

            setLoading('');
          } else {
            setLoading('No data found');
          }
        } else {
          setLoading('No data found');
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getBenchPlacement = async (page) => {
    // setTableData([])
    setTableData1([]);
    setTableCount('');
    setPages('');
    setLoading('Loading...');
    const body = {
      status: 'placement',
      placementFrom: 'bench',
      page: page || 1,
      limit: '35',
    };
    const token = localStorage.getItem('token');
    Api(`bench/getBenchPlacementDataByStatus`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data?.data?.length > 0) {
            setTableData1(response.data.data);
            setTableCount(response.data.count);
            const totalPage = Math?.ceil(response.data?.count / 35);
            setPages(totalPage);
            setLoading('');
          } else {
            // toast.warn(response.data.message, +'!');
            setLoading('No data found');
          }
        } else {
          // toast.warn(response.data.message, +'!');
          setLoading('No data found');
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const funclick = () => {
    getRecPlacement();
  };

  const handleTabChange = (Tab) => {
    // setPageNumber(1);
    // if (Tab === 'bench') {
    //   getBenchPlacement();
    // } else {
    //   getRecPlacement();
    // }
    // setValuee(Tab);

    setPageNumber(1);
    if (Tab === 'bench') {
      getBenchPlacement();
    } else if (Tab === 'TimeSheet') {
      getRecPlacementWithCompany();
    } else if (Tab === 'TimeSheet1') {
      getBenchPlacementWithCompany();
    } else if (Tab === 'PaymentHistory') {
      getRecPlacementPaymentHis();
    } else if (Tab === 'PaymentHistory1') {
      getBenchPlacementPaymentHis();
    } else {
      getRecPlacement();
    }

    setValuee(Tab);
  };

  // console.log("data", tableData1)
  const tablebg = 'rgba(82, 130, 190, 0.08)';

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '95%', sm: '70%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => {
    setCityStateStyling(true);
    setOpen2(true);
  };

  const handleClose2 = () => setOpen2(false);
  const [tab1, setTab1] = useState({
    placementFrom: '',
    commisionDate: '',
    endClientName: '',
    fullName: '',
    domain: '',
    implementationPartner: '',
    recruitorTeamInfo: '',
    recruitorName: '',
    ManagingTeamInfo: '',
    lead: '',
    Manager: '',
    head: '',
    accountManagerOwnership: '',
    contactName: '',
    additionalEmail: '',
    email: '',
    endClientPhoneNumber: '',
    address: '',
    payrollTaxState: '',
    billingType: '',
    billingFrequency: '',
    billingIntruction: '',
    overTimeBillRate: '',
    tenureWorked: '',
    expenses: '',
    hoursPerDay: '',
    currency: '',
    perDiem: '',
    vendorName: '',
    vendorFee: '',
    comment: '',
    endReason: '',
    duration: '',
    country: localStorage.getItem('country'),
    status: '',
    salary: '',
    annualBonus: '',
    candidateId: '',
    placementStatus: '',
    // "startStatus":"",
    placementInfoBoX1: {} || '',
    projectInfoBox2: {} || '',
    projectInfoBox1: {} || '',
    voiceInfoBox3: {} || '',
    candidateContactNo: '',

    invoiceInformation: '',
    positionName: '',
    city: '',
    state: '',
    stateCode: '',
    employmentType: '',
    jobType: '',
    taxTerm: '',
    joiningBonus: '',
    relocationAssistance: '',
    additionals: '',
    billRate: '',
    payRate: '',
    overTimeExpence: '',
    candidateName: '',
    accountManager: '',
    startDate: '',
    endDate: '',
    placementTenture: '',
    guranttePeriod: '',
    notes: '',
    amount: '',
    feeType: '',
    projectType: '',
    percentage: '',
    annualSalary: '',
    // "chargeType": "hourly" || ""
    chargeType: 'hourly',
    commisionAmount: '',
  });
  console.log('tab1==-=>', tab1);

  let currentKey = '';
  let currentValue = '';

  const handleKeyInputChange = (e) => {
    currentKey = e.target.value;
  };

  const handleValueInputChange = (e) => {
    currentValue = e.target.value;
  };

  const handleAddButtonClick = () => {
    if (currentKey && currentValue) {
      setTab1((prevState) => {
        const newPlacementInfoBoX1 = { ...prevState.placementInfoBoX1 };
        newPlacementInfoBoX1[currentKey] = currentValue;
        return {
          ...prevState,
          placementInfoBoX1: newPlacementInfoBoX1,
        };
      });
      currentKey = '';
      currentValue = '';
    }
  };

  const handleRemoveButtonClick = (keyToRemove) => {
    setTab1((prevState) => {
      const newPlacementInfoBoX1 = { ...prevState.placementInfoBoX1 };
      delete newPlacementInfoBoX1[keyToRemove];
      return {
        ...prevState,
        placementInfoBoX1: newPlacementInfoBoX1,
      };
    });
  };

  // console.log("placementInfoBoX1", tab1.placementInfoBoX1)
  // console.log("currentKey", currentKey)

  let currentKey1 = '';
  let currentValue1 = '';

  const handleKeyInputChange1 = (e) => {
    currentKey1 = e.target.value;
  };

  const handleValueInputChange1 = (e) => {
    currentValue1 = e.target.value;
  };

  const handleAddButtonClick1 = () => {
    if (currentKey1 && currentValue1) {
      setTab1((prevState) => {
        const newProjectInfoBox2 = { ...prevState.projectInfoBox2 };
        newProjectInfoBox2[currentKey1] = currentValue1;
        return {
          ...prevState,
          projectInfoBox2: newProjectInfoBox2,
        };
      });
      currentKey1 = '';
      currentValue1 = '';
    }
  };

  const handleRemoveButtonClick1 = (keyToRemove1) => {
    setTab1((prevState) => {
      const newProjectInfoBox2 = { ...prevState.projectInfoBox2 };
      delete newProjectInfoBox2[keyToRemove1];
      return {
        ...prevState,
        projectInfoBox2: newProjectInfoBox2,
      };
    });
  };

  let currentKey2 = '';
  let currentValue2 = '';

  const handleKeyInputChange2 = (e) => {
    currentKey2 = e.target.value;
  };

  const handleValueInputChange2 = (e) => {
    currentValue2 = e.target.value;
  };

  const handleAddButtonClick2 = () => {
    if (currentKey2 && currentValue2) {
      setTab1((prevState) => {
        const newVoiceInfoBox3 = { ...prevState.voiceInfoBox3 };
        newVoiceInfoBox3[currentKey2] = currentValue2;
        return {
          ...prevState,
          voiceInfoBox3: newVoiceInfoBox3,
        };
      });
      currentKey2 = '';
      currentValue2 = '';
    }
  };

  const handleRemoveButtonClick2 = (keyToRemove2) => {
    setTab1((prevState) => {
      const newVoiceInfoBox3 = { ...prevState.voiceInfoBox3 };
      delete newVoiceInfoBox3[keyToRemove2];
      return {
        ...prevState,
        voiceInfoBox3: newVoiceInfoBox3,
      };
    });
  };

  let currentKey11 = '';
  let currentValue11 = '';

  const handleKeyInputChange11 = (e) => {
    currentKey11 = e.target.value;
  };

  const handleValueInputChange11 = (e) => {
    currentValue11 = e.target.value;
  };

  const handleAddButtonClick11 = () => {
    if (currentKey11 && currentValue11) {
      setTab1((prevState) => {
        const newProjectInfoBox11 = { ...prevState.projectInfoBox1 };
        newProjectInfoBox11[currentKey11] = currentValue11;
        return {
          ...prevState,
          projectInfoBox1: newProjectInfoBox11,
        };
      });
      currentKey11 = '';
      currentValue1 = '';
    }
  };

  const handleRemoveButtonClick11 = (keyToRemove11) => {
    setTab1((prevState) => {
      const newProjectInfoBox11 = { ...prevState.projectInfoBox1 };
      delete newProjectInfoBox11[keyToRemove11];
      return {
        ...prevState,
        projectInfoBox1: newProjectInfoBox11,
      };
    });
  };

  const [loadingAdd, setLoadingAdd] = useState(false);

  const AddPlacement = (id) => {
    setLoadingAdd(true);
    // console.log("tab1.placementInfoBoX1", tab1.placementInfoBoX1)

    const body = {
      placementFrom: valuee === 'bench' ? 'manuallyFromBench' : 'manuallyFromRecruitor',
      placementId: tab1.placementId,
      endClientName: tab1.endClientName || '',
      domain: tab1.domain || '',
      implementationPartner: tab1.implementationPartner || '',
      recruitorTeamInfo: tab1.recruitorTeamInfo || '',
      recruitorName: tab1.recruitorName || '',
      ManagingTeamInfo: tab1.ManagingTeamInfo || '',
      lead: tab1.lead || '',
      Manager: tab1.Manager || '',
      head: tab1.head || '',
      accountManagerOwnership: tab1.accountManagerOwnership || '',
      contactName: tab1.contactName || '',
      additionalEmail: tab1.additionalEmail || '',
      email: tab1.email || '',
      endClientPhoneNumber: tab1.endClientPhoneNumber || '',
      address: tab1.address || '',
      payrollTaxState: tab1.payrollTaxState || '',
      billingType: tab1.billingType || '',
      billingFrequency: tab1.billingFrequency || '',
      billingIntruction: tab1.billingIntruction || '',
      overTimeBillRate: tab1.overTimeBillRate || '',
      tenureWorked: tab1.tenureWorked || '',
      expenses: tab1.expenses || '',
      hoursPerDay: tab1.hoursPerDay || '',
      currency: tab1.currency || '',
      perDiem: tab1.perDiem || '',
      vendorName: tab1.vendorName || '',
      vendorFee: tab1.vendorFee || '',
      comment: tab1.comment || '',
      endReason: tab1.endReason || '',
      duration: tab1.duration || '',
      placementInfoBoX1: tab1.placementInfoBoX1 || {},
      projectInfoBox2: tab1.projectInfoBox2 || {},
      projectInfoBox1: tab1.projectInfoBox1 || {},
      voiceInfoBox3: tab1.voiceInfoBox3 || {},
      invoiceInformation: tab1.invoiceInformation || '',
      positionName: tab1.positionName || '',
      clientCity: cityy || '',
      clientState: cityandstate?.state || '',
      clientStateCode: stateCode1,
      // "city": cityy || "",
      // "state": cityandstate?.state || "",
      // "stateCode": stateCode1,
      clientCountry: tab1?.country,
      employmentType: tab1.employmentType || '',
      jobType: tab1.jobType || '',
      taxTerm: tab1.taxTerm || '',
      joiningBonus: tab1.joiningBonus || '',
      relocationAssistance: tab1.relocationAssistance || '',
      additionals: tab1.additionals || '',
      billRate: tab1.billRate || '',
      payRate: tab1.payRate || '',
      overTimeExpence: tab1.overTimeExpence || '',
      candidateName: tab1.candidateName || '',
      accountManager: tab1.accountManager || '',
      startDate: tab1.startDate || '',
      endDate: tab1.endDate || '',
      placementTenture: tab1.placementTenture || '',
      guranttePeriod: tab1.guranttePeriod || '',
      notes: tab1.notes || '',
      amount: tab1.amount || '',
      feeType: tab1.feeType || '',
      projectType: tab1.projectType || '',
      fullName: tab1?.fullName || '',
      status: tab1.status || '',
      // "startStatus": tab1.startStatus || "",
      salary: tab1.annualSalary || '',
      annualBonus: tab1.annualBonus || '',
      candidateId: tab1.candidateId || '',
      placementStatus: tab1.placementStatus || '',
      chargeType: tab1?.chargeType || '',
      commisionDate: tab1?.commisionDate || '',
      commisionAmount: tab1?.commisionAmount,
      //  "_Id": id,
      resumeId: id,
      benchId: '',
    };

    const token = localStorage.getItem('token');
    Api(`resume/AddPlacement`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          setLoadingAdd(false);
          // console.log("response.data", response.data.result)
          if (valuee === 'bench') {
            getBenchPlacement();
          }
          getRecPlacement();

          toast.success(response.data.resmessage);
          handleClose2();
          setTab1({
            ...tab1,
            placementFrom: '',
            endClientName: '',
            fullName: '',
            domain: '',
            implementationPartner: '',
            recruitorTeamInfo: '',
            recruitorName: '',
            ManagingTeamInfo: '',
            lead: '',
            Manager: '',
            head: '',
            accountManagerOwnership: '',
            contactName: '',
            additionalEmail: '',
            email: '',
            endClientPhoneNumber: '',
            address: '',
            payrollTaxState: '',
            billingType: '',
            billingFrequency: '',
            billingIntruction: '',
            overTimeBillRate: '',
            tenureWorked: '',
            expenses: '',
            hoursPerDay: '',
            currency: '',
            perDiem: '',
            vendorName: '',
            candidateContactNo: '',
            vendorFee: '',
            comment: '',
            endReason: '',
            duration: '',
            country: localStorage.getItem('country'),
            status: '',
            salary: '',
            annualBonus: '',
            candidateId: '',
            placementStatus: '',

            placementInfoBoX1: {} || '',
            projectInfoBox2: {} || '',
            projectInfoBox1: {} || '',
            voiceInfoBox3: {} || '',

            invoiceInformation: '',
            positionName: '',
            city: '',
            state: '',
            stateCode: '',
            employmentType: '',
            jobType: '',
            taxTerm: '',
            joiningBonus: '',
            relocationAssistance: '',
            additionals: '',
            billRate: '',
            payRate: '',
            overTimeExpence: '',
            candidateName: '',
            accountManager: '',
            startDate: '',
            endDate: '',
            placementTenture: '',
            guranttePeriod: '',
            notes: '',
            amount: '',
            feeType: '',
            projectType: '',
            percentage: '',
            startStatus: '',
            annualSalary: '',
            chargeType: '',
            placementId: '',
            commisionAmount: '',
          });
          setCityy('');
          setCityandstate('');
        } else {
          // toast.warn(response.data.message, +'!');
          setLoadingAdd(false);
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const AddPlacement1 = (id) => {
    setLoadingAdd(true);
    // console.log("tab1.placementInfoBoX1", tab1.placementInfoBoX1)

    const body = {
      placementFrom: valuee === 'bench' ? 'manuallyFromBench' : 'manuallyFromRecruitor',
      placementId: tab1.placementId,
      endClientName: tab1.endClientName || '',
      domain: tab1.domain || '',
      implementationPartner: tab1.implementationPartner || '',
      recruitorTeamInfo: tab1.recruitorTeamInfo || '',
      recruitorName: tab1.recruitorName || '',
      ManagingTeamInfo: tab1.ManagingTeamInfo || '',
      lead: tab1.lead || '',
      Manager: tab1.Manager || '',
      head: tab1.head || '',
      accountManagerOwnership: tab1.accountManagerOwnership || '',
      contactName: tab1.contactName || '',
      additionalEmail: tab1.additionalEmail || '',
      email: tab1.email || '',
      endClientPhoneNumber: tab1.endClientPhoneNumber || '',
      address: tab1.address || '',
      payrollTaxState: tab1.payrollTaxState || '',
      billingType: tab1.billingType || '',
      billingFrequency: tab1.billingFrequency || '',
      billingIntruction: tab1.billingIntruction || '',
      overTimeBillRate: tab1.overTimeBillRate || '',
      tenureWorked: tab1.tenureWorked || '',
      expenses: tab1.expenses || '',
      hoursPerDay: tab1.hoursPerDay || '',
      currency: tab1.currency || '',
      perDiem: tab1.perDiem || '',
      vendorName: tab1.vendorName || '',
      vendorFee: tab1.vendorFee || '',
      comment: tab1.comment || '',
      endReason: tab1.endReason || '',
      duration: tab1.duration || '',
      placementInfoBoX1: tab1.placementInfoBoX1 || {},
      projectInfoBox2: tab1.projectInfoBox2 || {},
      projectInfoBox1: tab1.projectInfoBox1 || {},
      voiceInfoBox3: tab1.voiceInfoBox3 || {},
      invoiceInformation: tab1.invoiceInformation || '',
      positionName: tab1.positionName || '',
      clientCity: cityy || '',
      clientState: cityandstate?.state || '',
      clientStateCode: stateCode1,
      // "city": cityy || "",
      // "state": cityandstate?.state || "",
      // "stateCode": stateCode1,
      clientCountry: tab1?.country,
      employmentType: tab1.employmentType || '',
      jobType: tab1.jobType || '',
      taxTerm: tab1.taxTerm || '',
      joiningBonus: tab1.joiningBonus || '',
      relocationAssistance: tab1.relocationAssistance || '',
      additionals: tab1.additionals || '',
      billRate: tab1.billRate || '',
      payRate: tab1.payRate || '',
      overTimeExpence: tab1.overTimeExpence || '',
      candidateName: tab1.candidateName || '',
      accountManager: tab1.accountManager || '',
      startDate: tab1.startDate || '',
      endDate: tab1.endDate || '',
      placementTenture: tab1.placementTenture || '',
      guranttePeriod: tab1.guranttePeriod || '',
      notes: tab1.notes || '',
      amount: tab1.amount || '',
      feeType: tab1.feeType || '',
      projectType: tab1.projectType || '',
      fullName: tab1?.fullName || '',
      status: tab1.status || '',
      // "startStatus": tab1.startStatus || "",
      salary: tab1.annualSalary || '',
      annualBonus: tab1.annualBonus || '',
      candidateId: tab1.candidateId || '',
      placementStatus: tab1.placementStatus || '',
      chargeType: tab1?.chargeType || '',
      commisionDate: tab1?.commisionDate || '',
      commisionAmount: tab1.commisionAmount,
      //  "_Id": id,
      resumeId: '',
      benchId: id,
    };

    const token = localStorage.getItem('token');
    Api(`resume/AddPlacement`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          setLoadingAdd(false);
          // console.log("response.data", response.data.result)
          if (valuee === 'bench') {
            getBenchPlacement();
          }
          getRecPlacement();

          toast.success(response.data.resmessage);
          handleClose2();
          setTab1({
            ...tab1,
            placementFrom: '',
            endClientName: '',
            fullName: '',
            domain: '',
            implementationPartner: '',
            recruitorTeamInfo: '',
            recruitorName: '',
            ManagingTeamInfo: '',
            lead: '',
            Manager: '',
            head: '',
            accountManagerOwnership: '',
            contactName: '',
            additionalEmail: '',
            email: '',
            endClientPhoneNumber: '',
            address: '',
            payrollTaxState: '',
            billingType: '',
            billingFrequency: '',
            billingIntruction: '',
            overTimeBillRate: '',
            tenureWorked: '',
            expenses: '',
            hoursPerDay: '',
            currency: '',
            perDiem: '',
            vendorName: '',
            candidateContactNo: '',
            vendorFee: '',
            comment: '',
            endReason: '',
            duration: '',
            country: localStorage.getItem('country'),
            status: '',
            salary: '',
            annualBonus: '',
            candidateId: '',
            placementStatus: '',
            placementInfoBoX1: {} || '',
            projectInfoBox2: {} || '',
            projectInfoBox1: {} || '',
            voiceInfoBox3: {} || '',

            invoiceInformation: '',
            positionName: '',
            city: '',
            state: '',
            stateCode: '',
            employmentType: '',
            jobType: '',
            taxTerm: '',
            joiningBonus: '',
            relocationAssistance: '',
            additionals: '',
            billRate: '',
            payRate: '',
            overTimeExpence: '',
            candidateName: '',
            accountManager: '',
            startDate: '',
            endDate: '',
            placementTenture: '',
            guranttePeriod: '',
            notes: '',
            amount: '',
            feeType: '',
            projectType: '',
            percentage: '',
            startStatus: '',
            annualSalary: '',
            chargeType: '',
            placementId: '',
            commisionDate: '',
            commisionAmount: '',
          });
          setCityy('');
          setCityandstate('');
        } else {
          // toast.warn(response.data.message, +'!');
          setLoadingAdd(false);
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const AddPlacementCv = () => {
    if (valuee === 'bench') {
      addcv1();
    } else {
      addcv();
    }
  };

  const addcv1 = async (e) => {
    if (!tab1.email) {
      toast.error('Email is required');
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(tab1.email)) {
      toast.error('Invalid email');
      return;
    }

    if (!tab1.fullName) {
      toast.error('Candidate name is required');
      return;
    }

    if (!tab1.positionName) {
      toast.error('Job title is required');
      return;
    }

    const token = localStorage.getItem('token');

    const body = {
      newCV: '',
      email: tab1.email,
      fullName: tab1.fullName,
      jobTitle: tab1.positionName,
      phone: tab1.candidateContactNo,
      currentCompany: '',
      skill: '',
      visaType: '',
      taxTerm: '',
      chargeType: tab1?.chargeType,
      expectedCompensation: '',
      cityOrZipcode: cityy || '',
      state: cityandstate?.state,
      linkedinUrl: '',
      reallocate: '',
      zipcode: '',
      // stateCode: value.scode,
      stateCode: stateCode1,
      resumeUrl: '',
      jobId: '',
      note: '',
      status: 'prospect',
      userStatus: 'active',
      //   userStatus: 'active',
      country: tab1?.country,
    };

    Api(`bench/addNewBenchProspect`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          AddPlacement1(response.data.result._id);
        } else {
          console.log('');
        }
      })
      .catch((err) => {
        // console.log('===========', err);
      });
  };

  const addcv = async (e) => {
    if (!tab1.email) {
      toast.error('Email is required');
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(tab1.email)) {
      toast.error('Invalid email');
      return;
    }

    if (!tab1.fullName) {
      toast.error('Candidate name is required');
      return;
    }

    if (!tab1.positionName) {
      toast.error('positionName is required');
      return;
    }
    const token = localStorage.getItem('token');
    const body = {
      newCV: '',
      email: tab1.email,
      fullName: tab1.fullName,
      jobTitle: tab1.positionName,
      phone: tab1.candidateContactNo,
      currentCompany: '',
      skill: '',
      visaType: '',
      taxTerm: '',
      chargeType: tab1?.chargeType,
      expectedCompensation: '',
      cityOrZipcode: cityy || '',
      state: cityandstate?.state,
      linkedinUrl: '',
      reallocate: '',
      zipcode: '',
      // stateCode: value.scode,
      stateCode: stateCode1,
      resumeUrl: '',
      jobId: '',
      note: '',
      status: 'prospect',
      userStatus: '',
      country: tab1?.country,
    };
    // console.log('=====create_resume==========>>>>>>>', finallst);
    Api(`resume/create_resume`, 'POST', body, token)
      .then((response) => {
        // console.log('=====create_resume==========>>>>>>>', response);
        // setLoadingAdd(false)
        if (response.status === 200) {
          console.log('===>', response.data.result._id);
          AddPlacement(response.data.result._id);
        } else {
          // toast.warn(response.data.message, +'!');
          console.log('');
        }
      })
      .catch((err) => {
        // console.log('===========', err);
      });
  };

  const [value, setValue] = useState('placement');

  const handleTabPlace = (Tab) => {
    // console.log("tab", Tab)
    setValue(Tab);
  };

  const childFuc = (e) => {
    setCityy(e);
    if (e.length >= 3) {
      getCity(e);
    } else if (e.length === 0) {
      setCityy(e);
      setcityData([]);
      setCityandstate();
    }
  };

  const [stateCode1, setStateCode1] = useState('');
  const fullVal = (val) => {
    // console.log(val);
    setStateCode1(val?.stateCode);
    setCityandstate(val);
    setCityy(val.city);
    setValue1({ ...value1, zip: val?.zip || val?.postal });
  };

  const [err, setErr] = useState(false);
  const [helperText, setHelperText] = useState('');
  const getCity = async (val) => {
    setHelperText('');
    setErr(false);
    setcityData([]);
    const token = localStorage.getItem('token');
    const body = {
      country: tab1.country,
      query: val,
    };
    Api(`resume/get_city_states`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          // console.log('=========status 200======>>>>>>>', response);
          if (response.data.code === 200) {
            // console.log('city========', JSON.stringify(response.data));
            setcityData(response.data.data);
          } else {
            // toast.error(response.data.message)
            setHelperText('No cities found for the given city name.');
            setErr(true);
            // toast.error(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

  const [cityStateStyling, setCityStateStyling] = useState(false);

  const handleDateChange = (date, field) => {
    const formattedDate = dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
    setTab1((prevRec) => ({
      ...prevRec,
      [field]: formattedDate,
    }));
    // console.log("formattedDate====>>>>", formattedDate);
  };

  const [selectedDropdownValue, setSelectedDropdownValue] = useState('rec');
  const handleChangeDrop = (event) => {
    // console.log("event", event)
    const selectedTab = event.target.value;
    setSelectedDropdownValue(selectedTab);
  };

  const Funcc = () => {
    const selectedTab = selectedDropdownValue;
    if (selectedTab === 'rec') {
      handleTabChange(selectedTab);
    } else if (selectedTab === 'bench') {
      handleTabChange(selectedTab);
    }
  };

  const [tableCount, setTableCount] = useState('');

  const [pages, setPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const handlePage = (event, value) => {
    //  alert(value);
    setPageNumber(value);

    if (valuee === 'bench') {
      getBenchPlacement(value);
    } else if (valuee === 'TimeSheet') {
      getRecPlacementWithCompany(value);
    } else if (valuee === 'TimeSheet1') {
      getBenchPlacementWithCompany(value);
    } else if (valuee === 'PaymentHistory') {
      getRecPlacementPaymentHis(value);
    } else if (valuee === 'PaymentHistory1') {
      getBenchPlacementPaymentHis(value);
    } else {
      getRecPlacement(value);
    }
    // console.log("value", value)
  };

  const [searchResult, setSearchResult] = React.useState();
  const [tableShow, setTableShow] = useState(false);
  let newToken = 'withouttoken';

  const searchDataFun = (data) => {
    // console.log("data=========>>>>>>", data);
    setTableCount(data?.length);
    setTableShow(true);
    if (data?.noData === 'noData') {
      setLoading('No data found');
      if (valuee === 'bench') {
        setTableData1([]);
      } else {
        setTableData([]);
      }
    } else {
      setSearchResult(data?.length);
      if (valuee === 'bench') {
        setTableData1(data);
      } else {
        setTableData(data);
      }
    }
  };

  const resetDataFun = () => {
    // openJobBench()
    // setTableShow(false)
    setTableShow(false);

    if (valuee === 'bench') {
      getBenchPlacement(value);
    } else {
      getRecPlacement(value);
    }
  };

  // const getActiveLabels = () => {

  //   if (valuee === "TimeSheet") {
  //      return tableLabelThird;
  //   } else if (valuee === "PaymentHistory") {
  //      return tableLabelSecond;
  //   } else if(valuee==="TimeSheet1"){
  //         return tableLabelThird
  //   }else if(valuee==="PaymentHistory1")
  //     {
  //         return tableLabelSecond;
  //     }

  //   return tableLabel
  // };

  const getActiveLabels = () => {
    if (valuee === 'TimeSheet') {
      return tableLabelThird;
    }

    if (valuee === 'PaymentHistory') {
      return tableLabelSecond;
    }

    if (valuee === 'TimeSheet1') {
      return tableLabelThird;
    }

    if (valuee === 'PaymentHistory1') {
      return tableLabelSecond;
    }

    return tableLabel;
  };

  const handleNavigatePayment = (placementId, invoiceType) => {

    navigate(`/payment-history/${placementId}/${invoiceType}`, { state: { "valuee": valuee } });
  };

  const getTemplList = () => {
    const token = localStorage.getItem('token');

    Api('email/getEmailTemplateList', 'GET', '', token) 
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            console.log('heeloo  what case  case ');
          } else {
            console.log('heeloo ');
          }
        }
        setTempList(response.data.result);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const AddCandidatePlacement = (
    candidateId,
    candidateName,
    companyName,
    email,
    endClientName,
    jobTitle,
    phone,
    placementId,
    reportingManagerEmail,
    reportingManagerName,
    reportingManagerNumber,
    value
  ) => {
    const body = {
      candidateId: placementId,
      candidateName,
      companyName,
      email,
      endClientName,
      jobTitle,
      phone,
      placementId,
      reportingManagerEmail,
      reportingManagerName,
      reportingManagerNumber,
      clickedButton: value,
    };

    const token = localStorage.getItem('token');

    Api('timeSheet/send-timesheet-link', 'POST', body, token).then((Response) => {
      console.log('jjj====>>>>', Response);
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          const baseUrl = window.location.origin;
          const WeekTable = 'WeekTable';
          const token = Response.data.token;
          if (value === 'btn1') {
            SendEmail(
              'Timesheet Submission Link',
              `<p>Hope you are doing well.</p>
            <p>
                  Please find below the link to fill in your timesheet. 
                  We request you to complete and submit the timesheet within 72 hours of receiving 
                  this email to ensure timely processing.
                  </p>

                <p>
            Link:
                  <a href="${baseUrl}/${WeekTable}/${token}" target="_blank">click here </a>
                   </p>

                <p>
             If you have any questions or face any issues
             while filling out the sheet,
              please feel free to reach out. I’ll be happy to assist.
                  </p>
                  <p>Thank you for your cooperation.</p>
`,
              candidateName,
              email
            );
          } else {
            SendEmail(
              'Timesheet Approval Request',
              `<p>Hope you are doing well.</p>
            <p>
                  Please find the link below to review  and approve the submitted timesheet.
                 We would appreciate it if you could kindly review and approve the same
                    within 72 hours to help us proceed with timely processing.
                  </p>

                <p>
            Link:
                  <a href="${baseUrl}/${WeekTable}/${token}" target="_blank">click here </a>
                   </p>

                <p>
                  In case you have any questions, require clarification, or notice any
               discrepancies, please feel free to let me know. I’ll be happy to coordinate
                and assist.
                  </p>
                  <p>Thank you for your time and support.</p>
`,
              reportingManagerName,
              reportingManagerEmail
            );
          }

          newToken = Response.data.token;

          //    window.open(`/WeekTable/${newToken}`, "_blank");
        } else {
          toast.warn(Response.data.message);
        }
      } else {
        toast.warn('Error!');
      }
    });
  };

  const SendEmail = (sub, body, name, email) => {
    const mailPayload = {
      autoMailer: false,
      base64File: '',
      bccEmail: [],
      candidateId: '',
      ccEmail: [],
      date: new Date(),
      emailBody: body,
      fileName: '',
      fileType: '',
      hours: 0,
      mailFrom: '',
      minute: 0,
      name: name.split(' ')[0].charAt(0).toUpperCase() + name.split(' ')[0].slice(1),
      recipientEmail: email,
      subject: sub,
    };

    const token1 = localStorage.getItem('token');

    Api('email/mail/instant', 'POST', mailPayload, token1)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            toast.success(response.data.message);
          } else {
            console.log('g');
          }
        } else {
            toast.warn(response.data.message);

        }
      })
      .catch((error) => {
        console.error('Error sending email:', error);
      });
  };

  const filter = createFilterOptions();
  const [openHistoryEmail, setOpenHistoryEmail] = useState(false);
  const [emailHistory, setEmailHistory] = useState('');
  const [bccEmail, setBccEmail] = useState([]);
  const [ccEmail, setCcEmail] = useState([]);
  const [openEmail, setOpenEmail] = useState(false);
  const [greeting, setGreeting] = useState('');
  const [subject, setSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [nameofClientandCondidate, setnameofClientandCondidate] = useState('');

  const handleOpenHistoryEmail = () => {
    setGreeting('');
    setSubject('');
    setEmailBody('');
    setOpenHistoryEmail(true);
  };
  const handleCloseHistoryEmail = () => {
    setOpenHistoryEmail(false);
  };

  const ClientHistory = (client, name) => {
    handleOpenHistoryEmail();
    setEmailHistory(client);
    setnameofClientandCondidate(name);
  };
  const CandidateHistory = (candidate, name) => {
    handleOpenHistoryEmail();
    setEmailHistory(candidate);
    setnameofClientandCondidate(name);
  };

  const handleTemplateSelect = (item) => {
    if (item && item.template && item.template.length > 0) {
      setGreeting(item.template[0].greeting);
      setSubject(item.template[0].subject);
      setEmailBody(item.template[0].emailBody);
    }
  };

  const SendEmail1 = () => {
    const mailPayload = {
      autoMailer: false,
      base64File: '',
      bccEmail: [],
      candidateId: '',
      ccEmail: [],
      date: new Date(),
      "emailBody": emailBody,
      fileName: '',
      fileType: '',
      hours: 0,
      mailFrom: '',
      minute: 0,
      name:
        nameofClientandCondidate?.split(' ')[0]?.charAt(0)?.toUpperCase() +
          nameofClientandCondidate?.split(' ')[0].slice(1) || ' ',
      recipientEmail: emailHistory,
      "subject": subject,
    };

    const token1 = localStorage.getItem('token');

    Api('email/mail/instant', 'POST', mailPayload, token1)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            toast.success(response.data.message);
            setnameofClientandCondidate('');
            handleCloseHistoryEmail();
          } else {
            console.log('g');
          }
        } else {
            handleCloseHistoryEmail();
             toast.warn(response.data.message);
          console.log('');
        }
      })
      .catch((error) => {
        console.error('Error sending email:', error);
      });
  };

  return (
    <>
      <Helmet>
        <title> Placement | Foxearch </title>
      </Helmet>

      <Search
        searchData={searchDataFun}
        func={resetDataFun}
        resetSearch={() => setSearchResult('')}
        placementFrom={valuee === 'bench' ? 'bench' : 'recruitor'}
      />
      {/* {toggleButton && (
            <Button color="custom" variant="contained" size="small"
              style={{ marginLeft: '275px', marginTop: "12px", position: "absolute" }}
              onClick={resetDataFun1}
            >
              Close
            </Button> 
    
          )} */}
      <ToastContainer />
      {/* <div>
        <div style={{ display: 'flex', alignItems: 'center', left: 115, right: 0 }}>
          <FormControl size="small" sx={{
            width: '25%',
            // borderRadius: '10px',
            border: "none",
            marginLeft: '4px',
            backgroundColor: "white",
            // border: '1px solid "#234268ff"', 
            // border: '1px solid #1E74B3',
            overflow: 'hidden',
            marginTop: -18,
          }}>
            <Select
              value={selectedDropdownValue}
              onChange={handleChangeDrop}
              size="small"
              className='dash_sr'
              sx={{
                borderRadius: '10px',
                border: '1px solid #1E74B3',
                '&:focus-visible': {
                  borderRadius: '10px',
                  border: '1px solid #1E74B3',
                },
              }}

              MenuProps={{
                disableScrollLock: true,
              }}
            >
              <MenuItem value='rec'>Recruitment</MenuItem>
              <MenuItem value='bench'>Bench</MenuItem>

            </Select>
          </FormControl>

          <Button color="custom" variant="contained" size="small"
            sx={{ ml: 1.6, mt: -18 }}
            onClick={Funcc}
          >
            Search
          </Button>
        </div>
      </div> */}
      <Stack direction="row" alignItems="flex-end" justifyContent="space-between">
        <Typography variant="h5" color={'text.secondary'}>
          Placements
        </Typography>

        <Stack direction="row" spacing={1}>
          <Button color="custom" variant="contained" size="small" sx={{}} onClick={handleOpen2}>
            Add New
          </Button>
        </Stack>
      </Stack>
      {tableShow && (
        <Typography sx={{ float: 'right', mt: 0.5 }} fontSize={'0.85rem'} color={'text.secondary'}>
          Total: {searchResult || '0'}
        </Typography>
      )}
      <Stack flexDirection={'row'} gap={2} mb={1}>
        <Stack
          sx={{
            flexDirection: 'row',
            gap: 2,
            cursor: 'pointer',
            alignItems: 'center',
            border: '1px solid #1E74B3',
            borderRadius: 2,
            padding: '1px',
          }}
        >
          <Stack
            sx={[
              { flexDirection: 'row', alignItems: 'center', gap: 0.7, paddingLeft: 0.5 },
              valuee === 'rec' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTabChange('rec')}
          >
            {/* <Iconify
          icon="subway:world"
          fontSize={13}
          color={valuee === 'company' ? '#CB4335' : 'text.textG'}
        /> */}
            <Iconify icon="gg:database" width="1.2rem" fontSize="0.95rem" />
            <Typography variant="tabs" color={valuee === 'rec' ? 'text.secondary' : 'text.textG'} fontSize="0.95rem">
              Recruitment
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', alignItems: 'center', gap: 0.7 },
              valuee === 'TimeSheet' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTabChange('TimeSheet')}
          >
            {/* <Iconify
          icon="subway:world"
          fontSize={13}
          color={valuee === 'company' ? '#CB4335' : 'text.textG'}
        /> */}

            <Iconify icon="fluent-mdl2:date-time" width="1.1rem" />

            <Typography
              variant="tabs"
              color={valuee === 'TimeSheet' ? 'text.secondary' : 'text.textG'}
              fontSize="0.95rem"
            >
              Timesheets
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', alignItems: 'center', paddingRight: 1, gap: 1 },
              valuee === 'PaymentHistory' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTabChange('PaymentHistory')}
          >
            {/* <Iconify
          icon="subway:world"
          fontSize={13}
          color={valuee === 'company' ? '#CB4335' : 'text.textG'}
        /> */}
            <Iconify icon="streamline-plump:dollar-coin-remix" width="1.1rem" />
            <Typography variant="tabs" color={valuee === 'PaymentHistory' ? 'text.secondary' : 'text.textG'}>
              Payment History
            </Typography>
          </Stack>
        </Stack>

        <Stack
          sx={{
            flexDirection: 'row',
            gap: 2,
            cursor: 'pointer',
            alignItems: 'center',
            border: '1px solid #1E74B3',
            borderRadius: 2,

            padding: '1px',
          }}
        >
          <Stack
            sx={[
              { flexDirection: 'row', ml: 0.5, alignItems: 'center', gap: 0.7 },
              valuee === 'bench' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTabChange('bench')}
          >
            <Iconify icon="gg:database" width="1.2rem" />
            <Typography variant="tabs" color={valuee === 'bench' ? 'text.secondary' : 'text.textG'} fontSize="0.95rem">
              Bench
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', alignItems: 'center', gap: 0.7 },
              valuee === 'TimeSheet1' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTabChange('TimeSheet1')}
          >
            {/* <Iconify
          icon="subway:world"
          fontSize={13}
          color={valuee === 'company' ? '#CB4335' : 'text.textG'}
        /> */}
            <Iconify icon="fluent-mdl2:date-time" width="1.1rem" />

            <Typography
              variant="tabs"
              color={valuee === 'TimeSheet1' ? 'text.secondary' : 'text.textG'}
              fontSize="0.95rem"
            >
              Timesheets
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', alignItems: 'center', paddingRight: 1, gap: 1 },
              valuee === 'PaymentHistory1' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTabChange('PaymentHistory1')}
          >
            {/* <Iconify
          icon="subway:world"
          fontSize={13}
          color={valuee === 'company' ? '#CB4335' : 'text.textG'}
        /> */}
            <Iconify icon="streamline-plump:dollar-coin-remix" width="1.1rem" />
            <Typography variant="tabs" color={valuee === 'PaymentHistory1' ? 'text.secondary' : 'text.textG'}>
              Payment History
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'text.secondary' }}>
              {/* {tableLabel.map((item) => {
                return (
                    <TableCell sx={{ p: 1, py: 0.5, color: 'white' }} key={item.id}>
                           {item.label} 
                    </TableCell>  
                ); 
                  })} */}

              {getActiveLabels().map((item) => (
                <TableCell sx={{ p: 1, py: 0.5, color: 'white' }} key={item.id}>
                  {item.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {valuee === 'rec' ? (
              (Array.isArray(tableData) && tableData)?.map((row, index) => (
                <ManagementRow
                  index={index}
                  key={row?._id}
                  data={row}
                  fun={funclick}
                  tempList={tempList}
                  loading={loading}
                  valuee={valuee}
                  handleOpen2={handleOpen2}
                  handleClose2={handleClose2}
                  open2={open2}
                />
              ))
            ) : valuee === 'TimeSheet' ? (
              <>
                {tableData2?.map((item, index) => (
                  <TableRow
                    key={index}
                    sx={[
                      {
                        background: index % 2 === 0 ? 'text.background' : tablebg,
                        '&:last-child td, &:last-child th': { border: 0 },
                        '&:hover': { boxShadow: 5 },
                      },
                    ]}
                  >
                    <TableCell>
                      <Typography sx={{}}>{item.companyName ? item.companyName : '-'}</Typography>
                      <Typography sx={{}}>{item.endClientName ? item.endClientName : '-'}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography sx={{ fontWeight: 'bold', cursor: 'pointer' }} color={'text.secondary'}>
                        {/* {item.candidateName ? item.candidateName + "- "  : "-"}{item.placementID || "-"} */}
                        {/* {item.candidateName ? item.candidateName + "- " : ""}{item.placementID || "-"} */}
                        {item.candidateName ? `${item.candidateName} - ` : '- '}
                        {item.placementID || '-'}
                      </Typography>

                      <Typography sx={{ fontWeight: 'bold', cursor: 'pointer' }} color={'text.secondary'}>
                        {item.reportingManagerName ? item.reportingManagerName : '-'}
                      </Typography>
                    </TableCell>

                    <TableCell>
                      <Typography sx={{}}>{item.email ? item.email : '-'}</Typography>
                      <Typography sx={{}}>{item.reportingManagerEmail ? item.reportingManagerEmail : '-'}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography sx={{}}>{item.phone ? item.phone : '-'}</Typography>
                      <Typography sx={{}}>{item.reportingManagerNumber ? item.reportingManagerNumber : '-'}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography
                        sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={() => {
                          newToken = 'withouttoken';
                          const params = new URLSearchParams({
                            candidateName: item.candidateName,
                            companyName: item.companyName,
                            email: item.email,
                            endClientName: item.endClientName || '',
                            jobTitle: item.jobTitle,
                            phone: item.phone,
                            placementId: item.placementId,
                            reportingManagerEmail: item.reportingManagerEmail || '',
                            reportingManagerName: item.reportingManagerName || '',
                            reportingManagerNumber: item.reportingManagerNumber || '',
                            clickedButton: 'btn2',
                          });

                          //  navigate(`/WeekTable?${params.toString()}`);

                          const url = `/WeekTable/${newToken}?${params.toString()}`;
                          window.open(url, '_blank'); //
                        }}
                      >
                        Timesheet
                      </Typography>
                      {/* <Typography>
                      {item.placementID || "-"}
                    </Typography> */}
                    </TableCell>

                    <TableCell>
                      <Typography>{formatDate(item.approvedFrom)}</Typography>

                      <Typography>{formatDate(item.approvedTill)}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography sx={{}}>{item.pendingWeeksFrom ? `${item.pendingWeeksFrom} Weeks` : '-'}</Typography>
                      <Typography sx={{}}>{item.pendingWeeksTill ? `${item.pendingWeeksTill} Weeks` : '-'}</Typography>
                    </TableCell>

                    <TableCell>
                      <div>
                        <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                          <Iconify icon="ic:baseline-email" fontSize={10} />
                          <Typography
                            sx={{}}
                            onClick={() => {
                              AddCandidatePlacement(
                                item.candidateId,
                                item.candidateName,
                                item.companyName,
                                item.email,
                                item.endClientName,
                                item.jobTitle,
                                item.phone,
                                item.placementId,
                                item.reportingManagerEmail,
                                item.reportingManagerName,
                                item.reportingManagerNumber,
                                'btn1'
                              );
                            }}
                          >
                            {' '}
                            send link{' '}
                          </Typography>
                        </Stack>
                      </div>

                      {/* 

                    <div>
                      <Button variant="text" size="small" onClick={() => {
                  
                      }}>Send Link</Button>
                    </div> */}

                      <box>
                        <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                          <Iconify icon="ic:baseline-email" fontSize={10} />
                          <typography
                            onClick={() => {
                              AddCandidatePlacement(
                                item.candidateId,
                                item.candidateName,
                                item.companyName,
                                item.email,
                                item.endClientName,
                                item.jobTitle,
                                item.phone,
                                item.placementId,
                                item.reportingManagerEmail,
                                item.reportingManagerName,
                                item.reportingManagerNumber,
                                'btn2'
                              );
                            }}
                          >
                            send link
                          </typography>
                        </Stack>
                        {/* <Button variant="text" size="small" onClick={() => {

                        AddCandidatePlacement(
                          item.candidateId,
                          item.candidateName,
                          item.companyName,
                          item.email,
                          item.endClientName,
                          item.jobTitle,
                          item.phone,
                          item.placementId,
                          item.reportingManagerEmail,
                          item.reportingManagerName,
                          item.reportingManagerNumber,
                          "btn2"
                        )
                      }}>Send Link</Button> */}
                      </box>
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : valuee === 'TimeSheet1' ? (
              <>
                {tableData3?.map((item, index) => (
                  <TableRow
                    key={index}
                    sx={[
                      {
                        background: index % 2 === 0 ? 'text.background' : tablebg,
                        '&:last-child td, &:last-child th': { border: 0 },
                        '&:hover': { boxShadow: 5 },
                      },
                    ]}
                  >
                    <TableCell>
                      <Typography sx={{}}>{item.companyName ? item.companyName : '-'}</Typography>
                      <Typography sx={{}}>{item.endClientName ? item.endClientName : '-'}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography sx={{ fontWeight: 'bold', cursor: 'pointer' }} color={'text.secondary'}>
                        {/* {item.candidateName ? item.candidateName : "-"} - {item.placementID || "-"} */}
                        {item.candidateName ? `${item.candidateName} - ` : '- '}
                        {item.placementID || '-'}
                      </Typography>
                      <Typography sx={{ fontWeight: 'bold', cursor: 'pointer' }} color={'text.secondary'}>
                        {item.reportingManagerName ? item.reportingManagerName : '-'}
                      </Typography>
                    </TableCell>

                    <TableCell>
                      <Typography sx={{}}>{item.email ? item.email : '-'}</Typography>
                      <Typography sx={{}}>{item.reportingManagerEmail ? item.reportingManagerEmail : '-'}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography sx={{}}>{item.phone ? item.phone : '-'}</Typography>
                      <Typography sx={{}}>{item.reportingManagerNumber ? item.reportingManagerNumber : '-'}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography
                        sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={() => {
                          newToken = 'withouttoken';
                          const params = new URLSearchParams({
                            candidateName: item.candidateName,
                            companyName: item.companyName,
                            email: item.email,
                            endClientName: item.endClientName || '',
                            jobTitle: item.jobTitle,
                            phone: item.phone,
                            placementId: item.placementId,
                            reportingManagerEmail: item.reportingManagerEmail || '',
                            reportingManagerName: item.reportingManagerName || '',
                            reportingManagerNumber: item.reportingManagerNumber || '',
                            clickedButton: 'btn2',
                          });

                          //  navigate(`/WeekTable?${params.toString()}`);

                          //   const url = `/WeekTable/${newToken}${params.toString()}`;
                          const url = `/WeekTable/${newToken}?${params.toString()}`;
                          window.open(url, '_blank'); //
                        }}
                      >
                        Timesheet
                      </Typography>
                    </TableCell>

                    <TableCell>
                      <Typography>{formatDate(item.approvedFrom)}</Typography>

                      <Typography>{formatDate(item.approvedTill)}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography sx={{}}>{item.pendingWeeksFrom ? `${item.pendingWeeksFrom} Weeks` : '-'}</Typography>
                      <Typography sx={{}}>{item.pendingWeeksTill ? `${item.pendingWeeksTill} Weeks` : '-'}</Typography>
                    </TableCell>

                    <TableCell>
                      {/* <div>
                     <Button variant="text" size="small"  onClick={() => {
          const params = new URLSearchParams({
            candidateName: item.candidateName,
            companyName: item.companyName,
            email: item.email,
            endClientName: item.endClientName || "",
            jobTitle: item.jobTitle,
            phone: item.phone,
            placementId: item.placementId,
            reportingManagerEmail: item.reportingManagerEmail || "",
            reportingManagerName: item.reportingManagerName || "",
            reportingManagerNumber: item.reportingManagerNumber || "",
            clickedButton: "btn1",
          });
            const url = `/WeekTable?${params.toString()}`;
                             window.open(url, "_blank");   
        }}>Send Link</Button>
                </div> 
                
                <box>
                     <Button variant="text" size="small"  onClick={() => {


          const params = new URLSearchParams({
            candidateName: item.candidateName,
            companyName: item.companyName,
            email: item.email,
            endClientName: item.endClientName || "",
            jobTitle: item.jobTitle,
            phone: item.phone,
            placementId: item.placementId,
            reportingManagerEmail: item.reportingManagerEmail || "",
            reportingManagerName: item.reportingManagerName || "",
            reportingManagerNumber: item.reportingManagerNumber || "",
            clickedButton: "btn2",
          });

   


               const url = `/WeekTable?${params.toString()}`;
               window.open(url, "_blank");   
        }}>Send Link</Button> 
                </box> */}

                      <div>
                        <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                          <Iconify icon="ic:baseline-email" fontSize={10} />
                          <Typography
                            sx={{}}
                            onClick={() => {
                              AddCandidatePlacement(
                                item.candidateId,
                                item.candidateName,
                                item.companyName,
                                item.email,
                                item.endClientName,
                                item.jobTitle,
                                item.phone,
                                item.placementId,
                                item.reportingManagerEmail,
                                item.reportingManagerName,
                                item.reportingManagerNumber,
                                'btn1'
                              );
                            }}
                          >
                            {' '}
                            send link{' '}
                          </Typography>
                        </Stack>

                        {/* 

                      <box>
                        <Button variant="text" size="small" onClick={() => {
                          AddCandidatePlacement(
                            item.candidateId,
                            item.candidateName,
                            item.companyName,
                            item.email,
                            item.endClientName,
                            item.jobTitle,
                            item.phone,
                            item.placementId,
                            item.reportingManagerEmail,
                            item.reportingManagerName,
                            item.reportingManagerNumber,
                            "btn1"
                          )






                        }}>Send Link</Button>
                      </box> */}
                      </div>

                      <box>
                        <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                          <Iconify icon="ic:baseline-email" fontSize={10} />
                          <typography
                            onClick={() => {
                              AddCandidatePlacement(
                                item.candidateId,
                                item.candidateName,
                                item.companyName,
                                item.email,
                                item.endClientName,
                                item.jobTitle,
                                item.phone,
                                item.placementId,
                                item.reportingManagerEmail,
                                item.reportingManagerName,
                                item.reportingManagerNumber,
                                'btn2'
                              );
                            }}
                          >
                            send link
                          </typography>
                        </Stack>

                        {/* <Button variant="text" size="small" onClick={() => {
                        AddCandidatePlacement(
                          item.candidateId,
                          item.candidateName,
                          item.companyName,
                          item.email,
                          item.endClientName,
                          item.jobTitle,
                          item.phone,
                          item.placementId,
                          item.reportingManagerEmail,
                          item.reportingManagerName,
                          item.reportingManagerNumber,
                          "btn2"
                        )
                      }}>Send Link</Button> */}
                      </box>
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : valuee === 'PaymentHistory' ? (
              <>
                {tableDataPayment?.map((item, index) => (
                  <TableRow
                    key={index}
                    sx={[
                      {
                        background: index % 2 === 0 ? 'text.background' : tablebg,
                        '&:last-child td, &:last-child th': { border: 0 },
                        '&:hover': { boxShadow: 5 },
                      },
                    ]}
                  >
                    {/* Company */}
                    <TableCell>
                      <Typography>{item.companyName ? item.companyName : '-'}</Typography>
                      <Typography>{item.endClientName ? item.endClientName : '-'}</Typography>

                      {/* <Typography sx={{}}>
                             {item.companyName ? item.companyName : "-"}
                 </Typography>
                <Typography sx={{}}>
                            {item.endClientName ? item.endClientName : "-"}
               </Typography> */}
                    </TableCell>

                    {/* Candidate Name */}
                    <TableCell>
                      <Typography sx={{ fontWeight: 'bold', cursor: 'pointer' }} color={'text.secondary'}>
                        {/* {item.candidateName ? item.candidateName : "-"} - {item.placementID || "-"} */}
                        {item.candidateName ? `${item.candidateName} - ` : '- '}
                        {item.placementID || '-'}
                      </Typography>

                      <Typography>{item.reportingManagerName ? item.reportingManagerName : '-'}</Typography>
                    </TableCell>

                    {/* Email */}
                    <TableCell>
                      <Typography>{item.email ? item.email : '-'}</Typography>
                      <Typography>{item.reportingManagerEmail ? item.reportingManagerEmail : '-'}</Typography>
                    </TableCell>

                    {/* Phone */}
                    <TableCell>
                      <Typography>{item.phone ? item.phone : '-'}</Typography>
                      <Typography>{item.reportingManagerNumber ? item.reportingManagerNumber : '-'}</Typography>
                    </TableCell>

                    {/* Payment Type */}
                    <TableCell>
                      <Typography
                        sx={{ cursor: 'pointer', color: '#3C6BA5' }}
                        onClick={() => handleNavigatePayment(item.placementId, 'candidate')}
                      >
                        Payment
                      </Typography>
                      <Typography
                        sx={{ cursor: 'pointer', color: '#3C6BA5' }}
                        onClick={() => handleNavigatePayment(item.placementId, 'client')}
                      >
                        Payment
                      </Typography>
                    </TableCell>

                    {/* Date */}
                    <TableCell>
                      <Typography>{item.candidateTillDate ? formatDate(item.candidateTillDate) : '-'}</Typography>
                      <Typography>{item.clientTillDate ? formatDate(item.clientTillDate) : '-'}</Typography>
                    </TableCell>

                    {/* Duration */}
                    <TableCell>
                      <Typography>
                        {item.candidatePendingWeeks ? `${item.candidatePendingWeeks} Weeks` : '-'}
                      </Typography>

                      <Typography> {item.clientPendingWeeks ? `${item.clientPendingWeeks} Weeks` : '-'}</Typography>
                    </TableCell>

                    <TableCell>
                      <div>
                        <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                          <Iconify icon="ic:baseline-email" fontSize={10} />
                          <Typography
                            sx={{}}
                            onClick={() => {
                              CandidateHistory(item.email, item.candidateName);
                            }}
                          >
                            {' '}
                            Email{' '}
                          </Typography>
                        </Stack>
                      </div>

                      <box>
                        <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                          <Iconify icon="ic:baseline-email" fontSize={10} />
                          <typography
                            onClick={() => {
                              ClientHistory(item.reportingManagerEmail, item.reportingManagerName);
                            }}
                          >
                            Email
                          </typography>
                        </Stack>
                        {/* <Button variant="text" size="small" onClick={() => {

                        AddCandidatePlacement(
                          item.candidateId,
                          item.candidateName,
                          item.companyName,
                          item.email,
                          item.endClientName,
                          item.jobTitle,
                          item.phone,
                          item.placementId,
                          item.reportingManagerEmail,
                          item.reportingManagerName,
                          item.reportingManagerNumber,
                          "btn2"
                        )
                      }}>Send Link</Button> */}
                      </box>
                    </TableCell>

                    {/* 
                  <TableCell>
                    <Typography>{item.email1 ? item.email : "-"}</Typography>
                    <Typography>{item.email1 ? item.email : "-"}</Typography>
                  </TableCell> */}
                  </TableRow>
                ))}
              </>
            ) : valuee === 'PaymentHistory1' ? (
              <>
                {benchPaymentData?.map((item, index) => (
                  <TableRow
                    key={index}
                    sx={[
                      {
                        background: index % 2 === 0 ? 'text.background' : tablebg,
                        '&:last-child td, &:last-child th': { border: 0 },
                        '&:hover': { boxShadow: 5 },
                      },
                    ]}
                  >
                    {/* Company */}
                    <TableCell>
                      <Typography>{item.companyName ? item.companyName : '-'}</Typography>
                      <Typography>{item.endClientName ? item.endClientName : '-'}</Typography>
                    </TableCell>

                    {/* Candidate Name */}
                    <TableCell>
                      {/* <Typography style={{ fontWeight: "bold" }}>
                    {item.candidateName ? item.candidateName : "_"}
                  </Typography> */}

                      <Typography sx={{ fontWeight: 'bold', cursor: 'pointer' }} color={'text.secondary'}>
                        {/* {item.candidateName ? item.candidateName : "-"} -{item.placementID || "-"} */}
                        {item.candidateName ? `${item.candidateName} - ` : '- '}
                        {item.placementID || '-'}
                      </Typography>

                      <Typography>{item.reportingManagerName ? item.reportingManagerName : '-'}</Typography>
                    </TableCell>

                    {/* Email */}
                    <TableCell>
                      <Typography>{item.email ? item.email : '-'}</Typography>
                      <Typography>{item.reportingManagerEmail ? item.reportingManagerEmail : '-'}</Typography>
                    </TableCell>

                    {/* Phone */}
                    <TableCell>
                      <Typography>{item.phone ? item.phone : '-'}</Typography>
                      <Typography>{item.reportingManagerNumber ? item.reportingManagerNumber : '-'}</Typography>
                    </TableCell>

                    {/* Payment Type */}
                    <TableCell>
                      <Typography
                        sx={{ cursor: 'pointer', color: '#3C6BA5' }}
                        onClick={() => handleNavigatePayment(item.placementId, 'candidate')}
                      >
                        Payment
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ cursor: 'pointer', color: '#3C6BA5' }}
                        onClick={() => handleNavigatePayment(item.placementId, 'client')}
                      >
                        Payment
                      </Typography>
                    </TableCell>

                    {/* Date */}
                    <TableCell>
                      <Typography>{item.candidateTillDate ? formatDate(item.candidateTillDate) : '-'}</Typography>
                      <Typography>{item.clientTillDate ? formatDate(item.clientTillDate) : '-'}</Typography>
                    </TableCell>

                    {/* Duration */}
                    <TableCell>
                      <Typography>
                        {' '}
                        {item.candidatePendingWeeks ? `${item.candidatePendingWeeks} Weeks` : '-'}
                      </Typography>
                      <Typography> {item.clientPendingWeeks ? `${item.clientPendingWeeks} Weeks` : '-'}</Typography>
                      {/* <Typography>{item.candidatePendingWeeks ? item.candidatePendingWeeks : "-"}</Typography>
                  <Typography>{item.clientPendingWeeks ? item.clientPendingWeeks : "-"}</Typography> */}
                    </TableCell>

                    {/* Mode */}

                    <TableCell>
                      <div>
                        <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                          <Iconify icon="ic:baseline-email" fontSize={10} />
                          <Typography
                            sx={{}}
                            onClick={() => {
                              CandidateHistory(item.email, item.candidateName);
                            }}
                          >
                            {' '}
                            Email{' '}
                          </Typography>
                        </Stack>
                      </div>

                      <box>
                        <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                          <Iconify icon="ic:baseline-email" fontSize={10} />
                          <typography
                            onClick={() => {
                              ClientHistory(item.reportingManagerEmail, item.reportingManagerName);
                            }}
                          >
                            Email
                          </typography>
                        </Stack>
                        {/* <Button variant="text" size="small" onClick={() => {

                        AddCandidatePlacement(
                          item.candidateId,
                          item.candidateName,
                          item.companyName,
                          item.email,
                          item.endClientName,
                          item.jobTitle,
                          item.phone,
                          item.placementId,
                          item.reportingManagerEmail,
                          item.reportingManagerName,
                          item.reportingManagerNumber,
                          "btn2"
                        )
                      }}>Send Link</Button> */}
                      </box>
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : (
              (Array.isArray(tableData1) && tableData1)?.map((row1, index) => (
                <ManagementRow
                  index={index}
                  key={row1?._id}
                  data1={row1}
                  loading={loading}
                  getBenchPlacement={getBenchPlacement}
                  valuee={valuee}
                  handleOpen2={handleOpen2}
                  tempList={tempList}
                  handleClose2={handleClose2}
                  open2={open2}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {tableCount > 35 ? (
        <Stack
          spacing={2}
          sx={{
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 2,
          }}
        >
          <Button
            variant="outlined"
            sx={{
              minWidth: 16,
              height: 32,
              borderRadius: '5px',
              mt: 2,
              ml: 0.5,
              cursor: 'pointer',
            }}
            onClick={() => setPageNumber((prev) => Math.max(prev - 1, 1))}
          >
            {'<'}
          </Button>

          <Pagination
            variant="outlined"
            shape="rounded"
            color="secondary"
            hideNextButton
            hidePrevButton
            count={pages}
            page={pageNumber}
            onChange={handlePage}
            sx={{ cursor: 'pointer', mb: pageNumber !== 1 ? -4 : -2 }}
          />

          <Button
            variant="outlined"
            sx={{
              minWidth: 16,
              height: 32,
              borderRadius: '5px',
              mr: 1,
              mt: -2,
              cursor: 'pointer',
            }}
            onClick={() => setPageNumber((prev) => Math.min(prev + 1, pages))}
          >
            {'>'}
          </Button>
        </Stack>
      ) : null}
      {/* 
      {loading !== "" && (
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>{loading}</Typography>
        </Stack>
      )} */}

      {loading === 'Loading...' ? (
        <Stack>
          {Array.from({ length: 15 })?.map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              sx={{
                height: 80,
                width: '100%',
                backgroundColor: index % 2 === 0 ? 'text.background' : tablebg,
              }}
            />
          ))}
        </Stack>
      ) : (
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>{loading}</Typography>
        </Stack>
      )}

      <Modal open={open2} onClose={handleClose2} style={{ borderRadius: 10 }}>
        <Box sx={styleSkill}>
          <Typography variant="h6" color={'#3C6BA5'} textAlign={'center'} sx={{ mt: -1.7 }}>
            Add New
          </Typography>

          <Stack sx={{ width: '100%', alignItems: 'flex-end', mt: -4 }}>
            <Button
              color="custom"
              variant="contained"
              size="small"
              sx={{}}
              disabled={loadingAdd}
              onClick={() => {
                //  AddPlacement()
                AddPlacementCv();
              }}
            >
              {/* Save */}
              {loadingAdd ? <CircularProgress size={21} /> : 'Save'}
            </Button>
          </Stack>

          <Divider sx={{ mt: 1, mb: 1 }} />

          {/* <Stack flexDirection={'row'} justifyContent={'space-between'} mb={1}>

            <Stack sx={{ flexDirection: 'row', gap: 2, cursor: 'pointer', alignItems: 'center' }}>

              <Stack
                sx={[
                  { flexDirection: 'row', ml: 1, alignItems: 'center' },
                  value === 'placement' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('placement')}
              >
                <Iconify sx={{ mr: 0.6 }}
                  icon="icon-park-outline:agreement"
                  // fontSize={10}
                  width="0.9rem"
                  color={value === 'placement' ? 'green' : 'text.textG'}
                />
                <Typography variant="tabs" color={'text.secondary'} >
                  Placement Information
                </Typography>
              </Stack>

              <Stack
                sx={[
                  { flexDirection: 'row', ml: 4, alignItems: 'center' },
                  value === 'project' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('project')}
              >
                <Iconify sx={{ mr: 0.5 }}
                  icon="gridicons:multiple-users"
                  // fontSize={13}
                  width="1rem"
                  color={value === 'project' ? 'green' : 'text.textG'}
                />
                <Typography variant="tabs" color={'text.secondary'} sx={{}}>
                  Project Information / Recruiting Team
                </Typography>
              </Stack>

              <Stack
                sx={[
                  { flexDirection: 'row', ml: 4, alignItems: 'center' },
                  value === 'invoice' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('invoice')}
              >
                <Iconify sx={{ mr: 0.5 }}
                  icon="hugeicons:invoice-03"
                  // fontSize={13}
                  width="0.9rem"

                  color={value === 'invoice' ? 'green' : 'text.textG'}
                />
                <Typography variant="tabs" color={'text.secondary'} sx={{}}>
                  Invoicing Details
                </Typography>
              </Stack>

            </Stack>

          </Stack> */}

          <Stack flexDirection="row" justifyContent="space-between" mb={1}>
            <Stack sx={{ flexDirection: 'row', gap: 2, cursor: 'pointer', alignItems: 'center' }}>
              <Stack
                sx={[
                  { flexDirection: 'row', ml: 1, alignItems: 'center' },
                  value === 'placement' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('placement')}
              >
                <Iconify
                  sx={{ mr: 0.6 }}
                  icon="icon-park-outline:agreement"
                  width="0.9rem"
                  color={value === 'placement' ? 'green' : 'text.textG'}
                />
                <Typography variant="tabs" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' } }}>
                  Placement Information
                </Typography>
              </Stack>

              <Stack
                sx={[
                  { flexDirection: 'row', ml: 4, alignItems: 'center' },
                  value === 'project' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('project')}
              >
                <Iconify
                  sx={{ mr: 0.5 }}
                  icon="gridicons:multiple-users"
                  width="1rem"
                  color={value === 'project' ? 'green' : 'text.textG'}
                />
                <Typography variant="tabs" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' } }}>
                  Project Information / Recruiting Team
                </Typography>
              </Stack>

              <Stack
                sx={[
                  { flexDirection: 'row', ml: 4, alignItems: 'center' },
                  value === 'invoice' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('invoice')}
              >
                <Iconify
                  sx={{ mr: 0.5 }}
                  icon="hugeicons:invoice-03"
                  width="0.9rem"
                  color={value === 'invoice' ? 'green' : 'text.textG'}
                />
                <Typography variant="tabs" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' } }}>
                  Invoicing Details
                </Typography>
              </Stack>
            </Stack>
          </Stack>

          <Divider sx={{ mt: 2 }} />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            {/* {loading !== "" && (
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>{loading}</Typography>
        </Stack>
      )} */}
            {value === 'placement' ? (
              <Stack container sx={{ gap: 2, flexDirection: 'row', width: '100%' }}>
                <Stack sx={{ backgroundColor: 'text.background', borderRadius: 3, width: '100%' }}>
                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Placement ID
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.placementId}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, placementId: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Status
                      </Typography>

                      <FormControl size="small" sx={{ width: '100%' }}>
                        <InputLabel>Status</InputLabel>
                        <Select
                          value={tab1?.status || ''}
                          label="Status"
                          onChange={(e) => setTab1({ ...tab1, status: e.target.value })}
                        >
                          {/* <MenuItem value="active">Active</MenuItem>
                            <MenuItem value="closed">Closed</MenuItem> */}

                          <MenuItem value="placement">Placement</MenuItem>
                          <MenuItem value="project ended">Project Ended</MenuItem>
                          <MenuItem value="Job Quit">Quit</MenuItem>
                          <MenuItem value="terminated">Terminated</MenuItem>
                        </Select>
                      </FormControl>
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Candidate Name
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.fullName}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, fullName: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Candidate ID
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.candidateId}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, candidateId: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Candidate Email
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.email}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, email: e.target.value })}
                      />
                    </Stack>

                    {/* <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: { xs: '100%', sm: '50%' } }}>
                                       <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: { xs: '100%', sm: '50%' } }}>
                                       <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>Condidate contact </Typography>
                                                <TextField
                              size="small"
                              value={tab1?.email}
                              sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                              onChange={(e) => setTab1({ ...tab1, email: e.target.value })}
                            />


                             </Stack>


                                      
                        </Stack> */}

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Candidate contactNo
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.candidateContactNo}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, candidateContactNo: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        End Client Name
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.endClientName}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, endClientName: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Position Name
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.positionName}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, positionName: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />
                  <Stack
                    sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2, mt: 0.4, mb: 0.3 }}
                  >
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Country
                      </Typography>

                      <FormControl size="small" sx={{ width: '100%' }}>
                        <InputLabel id="demo-simple-select-label">Country</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={tab1?.country}
                          label="Country"
                          onChange={(e) => setTab1({ ...tab1, country: e.target.value })}
                        >
                          {/* <MenuItem value="USA">USA</MenuItem>
                            <MenuItem value="CANADA">CANADA</MenuItem>
                             <MenuItem value={'INDIA'}>INDIA</MenuItem>; */}
                          {countries?.map((item) => (
                            <MenuItem key={item.id} value={item.country}>
                              {item.country}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Stack>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        City
                      </Typography>

                      <CustomCompleteWorksheets
                        placeholder={'City & Pincode'}
                        option={cityData}
                        propVal={cityy}
                        childFuc={childFuc}
                        fullVal={fullVal}
                        fetch={'state'}
                        cityStateStyling1={cityStateStyling}
                        err={err}
                        helperText={helperText}
                      />
                    </Stack>
                  </Stack>
                  {/* <FormControl> */}
                  {cityandstate ? (
                    <Stack
                      sx={{
                        ml: '64%',
                        mb: 0.5,
                        flexDirection: 'row',
                      }}
                    >
                      <Typography color={'text.textG'} variant="body">
                        {cityandstate?.state}
                        {cityandstate?.state ? ',' : ''}
                      </Typography>
                      <Typography color={'text.textG'} variant="body" sx={{ ml: 1 }}>
                        {cityandstate?.stateCode || cityandstate?.zipCode || cityandstate?.zipcode}
                      </Typography>
                    </Stack>
                  ) : null}

                  {/* </FormControl> */}

                  <Divider sx={{ mb: 0.5 }} />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Job Type
                      </Typography>

                      <Select
                        size="small"
                        value={tab1?.jobType}
                        sx={{ width: '100%' }}
                        onChange={(e) => setTab1({ ...tab1, jobType: e.target.value })}
                      >
                        <MenuItem value="onsite">Onsite</MenuItem>
                        <MenuItem value="hybrid">Hybrid</MenuItem>
                        <MenuItem value="remote">Remote</MenuItem>
                      </Select>
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Tax Term
                      </Typography>

                      <Select
                        size="small"
                        value={tab1?.taxTerm}
                        sx={{ width: '100%' }}
                        onChange={(e) => setTab1({ ...tab1, taxTerm: e.target.value })}
                      >
                        <MenuItem value="w2">W2</MenuItem>
                        <MenuItem value="1099">1099</MenuItem>
                        <MenuItem value="cth">CTH</MenuItem>
                      </Select>
                    </Stack>
                  </Stack>
                  <Divider sx={{ mt: 0.5 }} />
                  <Stack
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      width: { xs: '100%', sm: '50%' },
                    }}
                  >
                    <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                      Compensation Type
                    </Typography>

                    <Select
                      size="small"
                      sx={{ width: '100%' }}
                      value={tab1.chargeType}
                      onChange={(e) => setTab1({ ...tab1, chargeType: e.target.value })}
                    >
                      {/* 
                        <MenuItem value="hourly">hourly</MenuItem>
                        <MenuItem value="Annually">Annually</MenuItem> */}

                      <MenuItem value={'hourly'}>Per hour Rate </MenuItem>
                      <MenuItem value={'Annually'}>Annual Compensation</MenuItem>
                    </Select>
                  </Stack>

                  <Divider sx={{ mt: 0.5 }} />
                  {tab1.chargeType === 'Annually' && (
                    <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                          Salary / Rate
                        </Typography>

                        <TextField
                          size="small"
                          value={tab1?.annualSalary}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start" sx={{ color: 'black' }}>
                                {localStorage.getItem('country') === 'INDIA'
                                  ? '₹'
                                  : localStorage.getItem('country') === 'UK'
                                  ? '£'
                                  : '$'}
                              </InputAdornment>
                            ),
                            // endAdornment: <InputAdornment position="end" sx={{ color: "black" }}>
                            //   <FormControl variant="standard" size="small">
                            //     <Select
                            //       value={tab1.chargeType}
                            //       onChange={(e) => setTab1({ ...tab1, chargeType: e.target.value })}
                            //       sx={{ color: 'black', width: '70px' }}
                            //     >
                            //       <MenuItem value="hourly">P/h</MenuItem>
                            //       <MenuItem value="Annually">{tab1?.country === "INDIA" ? 'Lac' : 'K'}</MenuItem>
                            //     </Select>
                            //   </FormControl>
                            // </InputAdornment>,
                            endAdornment: (
                              <InputAdornment position="end" sx={{ color: 'black' }}>
                                {localStorage.getItem('country') === 'INDIA' ? 'Lac' : 'K'}
                              </InputAdornment>
                            ),
                          }}
                          onChange={(e) => setTab1({ ...tab1, annualSalary: e.target.value })}
                        />
                      </Stack>
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                          {' '}
                          Commision Date
                        </Typography>
                        <FormControl fullWidth size="small" sx={{ width: '100%' }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Date"
                              slotProps={{
                                textField: {
                                  size: 'small',
                                  sx: { width: '100%', background: 'text.background' },
                                },
                              }}
                              value={tab1.commisionDate ? dayjs(tab1.commisionDate) : null}
                              onChange={(date) => handleDateChange(date, 'commisionDate')}
                            />
                          </LocalizationProvider>
                        </FormControl>
                      </Stack>
                    </Stack>
                  )}

                  <Divider />
                  {tab1.chargeType === 'Annually' && (
                    <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                          Commision Amount{' '}
                        </Typography>

                        <TextField
                          size="small"
                          value={tab1?.commisionAmount}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, commisionAmount: e.target.value })}
                        />
                      </Stack>
                    </Stack>
                  )}

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Joining Bonus
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.joiningBonus}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, joiningBonus: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />
                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Relocation Assistance
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.relocationAssistance}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, relocationAssistance: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Annual Bonus
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.annualBonus}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, annualBonus: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />

                  {tab1.chargeType === 'hourly' && (
                    <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                          Billing(Salary/Rate)
                        </Typography>
                        {/* <TextField
                          size="small"
                          value={tab1?.billRate}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, billRate: e.target.value })}
                        />  */}
                        <TextField
                          size="small"
                          value={tab1?.billRate}
                          InputProps={{
                            // startAdornment: <InputAdornment position="start" sx={{ color: "black" }}> {tab1?.country === "INDIA" ? "₹" : tab1?.country === "UK" ? "£" : "$"}</InputAdornment>,
                            startAdornment: (
                              <InputAdornment position="start">
                                {localStorage.getItem('country') === 'INDIA'
                                  ? '₹'
                                  : localStorage.getItem('country') === 'UK'
                                  ? '£'
                                  : '$'}
                              </InputAdornment>
                            ),
                            // endAdornment: <InputAdornment position="end" sx={{ color: "black" }}>
                            //   <FormControl variant="standard" size="small">
                            //     <Select
                            //       value={tab1.chargeType}
                            //       onChange={(e) => setTab1({ ...tab1, chargeType: e.target.value })}
                            //       sx={{ color: 'black', width: '70px' }}
                            //     >
                            //       <MenuItem value="hourly">P/h</MenuItem>
                            //       <MenuItem value="Annually">K</MenuItem>
                            //     </Select>
                            //   </FormControl>
                            // </InputAdornment>,
                            endAdornment: (
                              <InputAdornment position="end" sx={{ color: 'black' }}>
                                P/H
                              </InputAdornment>
                            ),
                          }}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, billRate: e.target.value })}
                        />
                      </Stack>

                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                          Pay Rate
                        </Typography>

                        {/* <TextField
                          size="small"
                          value={tab1?.payRate}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, payRate: e.target.value })}
                        /> */}

                        <TextField
                          size="small"
                          value={tab1?.payRate}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                {localStorage.getItem('country') === 'INDIA'
                                  ? '₹'
                                  : localStorage.getItem('country') === 'UK'
                                  ? '£'
                                  : '$'}
                              </InputAdornment>
                            ),
                            // startAdornment: <InputAdornment position="start" sx={{ color: "black" }}> {tab1?.country === "INDIA" ? "₹" : tab1?.country === "UK" ? "£" : "$"}</InputAdornment>,
                            // endAdornment: <InputAdornment position="end" sx={{ color: "black" }}>
                            //   <FormControl variant="standard" size="small">
                            //     <Select
                            //       value={tab1.chargeType}
                            //       onChange={(e) => setTab1({ ...tab1, chargeType: e.target.value })}
                            //       sx={{ color: 'black', width: '70px' }}
                            //     >
                            //       <MenuItem value="hourly">P/h</MenuItem>
                            //       <MenuItem value="Annually">K</MenuItem>
                            //     </Select>
                            //   </FormControl>
                            // </InputAdornment>,
                            endAdornment: (
                              <InputAdornment position="end" sx={{ color: 'black' }}>
                                P/H
                              </InputAdornment>
                            ),
                          }}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, payRate: e.target.value })}
                        />
                      </Stack>
                    </Stack>
                  )}
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Over Time Bill Rate
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.overTimeBillRate}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, overTimeBillRate: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Account Manager
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.accountManager}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, accountManager: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider sx={{ mb: 0.5 }} />

                  <Stack sx={{ width: '100%', gap: 2, px: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Start Date
                      </Typography>
                      <FormControl size="small" sx={{ width: '100%' }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Start Date"
                            slotProps={{
                              textField: {
                                size: 'small',
                                sx: { width: '100%', background: 'text.background' },
                              },
                            }}
                            value={tab1.startDate ? dayjs(tab1.startDate) : null}
                            onChange={(date) => handleDateChange(date, 'startDate')}
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        End Date
                      </Typography>
                      <FormControl fullWidth size="small" sx={{ width: '100%' }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="End Date"
                            slotProps={{
                              textField: {
                                size: 'small',
                                sx: { width: '100%', background: 'text.background' },
                              },
                            }}
                            value={tab1.endDate ? dayjs(tab1.endDate) : null}
                            onChange={(date) => handleDateChange(date, 'endDate')}
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </Stack>
                  </Stack>
                  <Divider sx={{ mt: 0.5 }} />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Placement Tenure
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.placementTenture}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, placementTenture: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Placement Status
                      </Typography>

                      <Select
                        size="small"
                        value={tab1?.placementStatus}
                        sx={{ width: '100%' }}
                        onChange={(e) => setTab1({ ...tab1, placementStatus: e.target.value })}
                      >
                        <MenuItem value="complete">Completed</MenuItem>
                        <MenuItem value="active">Active</MenuItem>
                      </Select>
                    </Stack>
                  </Stack>
                  <Divider sx={{ mb: 0.5 }} />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Guarantee Period
                      </Typography>

                      <Select
                        size="small"
                        value={tab1?.guranttePeriod}
                        sx={{ width: '100%' }}
                        onChange={(e) => setTab1({ ...tab1, guranttePeriod: e.target.value })}
                      >
                        <MenuItem value="30 Days">30 Days</MenuItem>
                        <MenuItem value="60 Days">60 Days</MenuItem>
                        <MenuItem value="90 Days">90 Days</MenuItem>
                        <MenuItem value="6 Months">6 Months</MenuItem>
                        <MenuItem value="1 Year">1 Year</MenuItem>
                      </Select>
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Employment Type
                      </Typography>

                      <Select
                        size="small"
                        value={tab1?.employmentType}
                        sx={{ width: '100%' }}
                        onChange={(e) => setTab1({ ...tab1, employmentType: e.target.value })}
                      >
                        <MenuItem value="fulltime">Full Time</MenuItem>
                        <MenuItem value="contract">Contract</MenuItem>
                        <MenuItem value="contractToHire">Contract To Hire</MenuItem>
                      </Select>
                    </Stack>
                  </Stack>
                  {valuee !== 'bench' && (
                    <>
                      <Divider sx={{ mt: 0.5 }} />

                      <Stack sx={{ flexDirection: 'row', px: 1, width: '100%', gap: 2 }}>
                        <Stack sx={{ display: 'flex', flexDirection: 'row', width: { xs: '99%', sm: '49%' }, mt: 0.5 }}>
                          <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                            Notes
                          </Typography>

                          <TextField
                            sx={{ width: '100%' }}
                            id="outlined-multiline-static"
                            label="Notes"
                            multiline
                            rows={4}
                            value={tab1.notes}
                            onChange={(e) => setTab1({ ...tab1, notes: e.target.value })}
                          />
                        </Stack>
                      </Stack>
                    </>
                  )}
                  <Divider sx={{ mt: 0.5 }} />
                  <Typography
                    fontWeight={500}
                    sx={{
                      color: 'text.secondary',
                      p: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    Additional
                  </Typography>
                  <Stack sx={{ width: '100%' }}>
                    <Stack sx={{}}>
                      <Grid container spacing={2}>
                        {Object?.entries(tab1?.placementInfoBoX1)?.map(([key, value]) => (
                          <Grid item xs={6} key={key}>
                            <Stack direction="row" sx={{ width: '100%', alignItems: 'center' }}>
                              <Typography sx={{ color: 'text.secondary', width: '120px', ml: 17 }}>{key}</Typography>
                              <Typography
                                sx={{
                                  color: 'text.primary',
                                  flexGrow: 1,
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  ml: 15,
                                }}
                              >
                                {value}
                              </Typography>
                              <Iconify
                                sx={{
                                  cursor: 'pointer',
                                  color: 'error.main',
                                  flexShrink: 0,
                                }}
                                icon="ph:x-circle-fill"
                                width="2rem"
                                onClick={() => handleRemoveButtonClick(key)}
                              />
                            </Stack>
                          </Grid>
                        ))}
                      </Grid>
                    </Stack>

                    <Stack sx={{ flexDirection: 'row', px: 1, width: '100%', gap: 2, alignItems: 'center' }}>
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 142, p: 1 }}>
                        Key
                      </Typography>
                      <TextField
                        size="small"
                        sx={{ py: 0.5, width: '45%', background: 'text.background' }}
                        onChange={handleKeyInputChange}
                        placeholder="Enter key"
                      />

                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 160, p: 1 }}>
                        Value
                      </Typography>
                      <TextField
                        size="small"
                        sx={{ py: 0.5, width: '38%', background: 'text.background' }}
                        onChange={handleValueInputChange}
                        placeholder="Enter value"
                      />

                      <Iconify
                        sx={{ cursor: 'pointer' }}
                        icon="ph:plus-fill"
                        width="3rem"
                        color="text.secondary"
                        onClick={handleAddButtonClick}
                      />
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            ) : value === 'project' ? (
              <Stack container sx={{ gap: 2, flexDirection: 'row', width: '100%' }}>
                <Stack sx={{ backgroundColor: 'text.background', borderRadius: 3, width: '100%' }}>
                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Implementation Partner
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.implementationPartner}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, implementationPartner: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Project Type
                      </Typography>

                      <Select
                        size="small"
                        value={tab1?.projectType}
                        sx={{ width: '100%' }}
                        onChange={(e) => setTab1({ ...tab1, projectType: e.target.value })}
                      >
                        <MenuItem value="msp">MSP</MenuItem>
                        <MenuItem value="directclient">Direct Client</MenuItem>
                        <MenuItem value="thirdpartystaffing">Third Party Staffing</MenuItem>
                      </Select>
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '99%', sm: '49%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Domain
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.domain}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, domain: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider sx={{}} />
                  <Typography
                    fontWeight={500}
                    sx={{
                      color: 'text.secondary',
                      p: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    Additional
                  </Typography>
                  {/* <Stack sx={{ flexDirection: 'row', px: 1, width: '100%', gap: 2 }}> */}

                  <Stack sx={{ width: '100%' }}>
                    <Stack sx={{}}>
                      <Grid container spacing={2}>
                        {Object?.entries(tab1?.projectInfoBox1)?.map(([key, value]) => (
                          <Grid item xs={6} key={key}>
                            <Stack direction="row" sx={{ width: '100%', alignItems: 'center' }}>
                              <Typography sx={{ color: 'text.secondary', width: '120px', ml: 17 }}>{key}</Typography>
                              <Typography
                                sx={{
                                  color: 'text.primary',
                                  flexGrow: 1,
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  ml: 15,
                                }}
                              >
                                {value}
                              </Typography>
                              <Iconify
                                sx={{
                                  cursor: 'pointer',
                                  color: 'error.main',
                                  flexShrink: 0,
                                }}
                                icon="ph:x-circle-fill"
                                width="2rem"
                                onClick={() => handleRemoveButtonClick11(key)}
                              />
                            </Stack>
                          </Grid>
                        ))}
                      </Grid>
                    </Stack>

                    <Stack sx={{ flexDirection: 'row', px: 1, width: '100%', gap: 2, alignItems: 'center' }}>
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 142, p: 1 }}>
                        Key
                      </Typography>
                      <TextField
                        size="small"
                        sx={{ py: 0.5, width: '45%', background: 'text.background' }}
                        onChange={handleKeyInputChange11}
                        placeholder="Enter key"
                      />

                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 160, p: 1 }}>
                        Value
                      </Typography>
                      <TextField
                        size="small"
                        sx={{ py: 0.5, width: '38%', background: 'text.background' }}
                        onChange={handleValueInputChange11}
                        placeholder="Enter value"
                      />

                      <Iconify
                        sx={{ cursor: 'pointer' }}
                        icon="ph:plus-fill"
                        width="3rem"
                        color="text.secondary"
                        onClick={handleAddButtonClick11}
                      />
                    </Stack>
                  </Stack>

                  {/* </Stack> */}
                  <Divider sx={{ mb: 5 }} />
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Recruiter Name
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.recruitorName}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, recruitorName: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Managing Team Info
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.ManagingTeamInfo}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, ManagingTeamInfo: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Lead
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.lead}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, lead: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Manager
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.Manager}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, Manager: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Head
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.head}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, head: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Account Manager Ownership
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.accountManagerOwnership}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, accountManagerOwnership: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />
                  <Typography
                    fontWeight={500}
                    sx={{
                      color: 'text.secondary',
                      p: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    Additional
                  </Typography>
                  <Stack sx={{ width: '100%' }}>
                    <Stack sx={{}}>
                      <Grid container spacing={2}>
                        {Object?.entries(tab1?.projectInfoBox2)?.map(([key, value]) => (
                          <Grid item xs={6} key={key}>
                            <Stack direction="row" sx={{ width: '100%', alignItems: 'center' }}>
                              <Typography sx={{ color: 'text.secondary', width: '120px', ml: 17 }}>{key}</Typography>
                              <Typography
                                sx={{
                                  color: 'text.primary',
                                  flexGrow: 1,
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  ml: 15,
                                }}
                              >
                                {value}
                              </Typography>
                              <Iconify
                                sx={{
                                  cursor: 'pointer',
                                  color: 'error.main',
                                  flexShrink: 0,
                                }}
                                icon="ph:x-circle-fill"
                                width="2rem"
                                onClick={() => handleRemoveButtonClick1(key)}
                              />
                            </Stack>
                          </Grid>
                        ))}
                      </Grid>
                    </Stack>
                    <Stack sx={{ width: '100%' }}>
                      <Stack sx={{ flexDirection: 'row', px: 1, width: '100%', gap: 2, alignItems: 'center' }}>
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 142, p: 1 }}>
                          Key
                        </Typography>
                        <TextField
                          size="small"
                          sx={{ py: 0.5, width: '45%', background: 'text.background' }}
                          onChange={handleKeyInputChange1}
                          placeholder="Enter key"
                        />

                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 160, p: 1 }}>
                          Value
                        </Typography>
                        <TextField
                          size="small"
                          sx={{ py: 0.5, width: '38%', background: 'text.background' }}
                          onChange={handleValueInputChange1}
                          placeholder="Enter value"
                        />

                        <Iconify
                          sx={{ cursor: 'pointer' }}
                          icon="ph:plus-fill"
                          width="3rem"
                          color="text.secondary"
                          onClick={handleAddButtonClick1}
                        />
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            ) : value === 'invoice' ? (
              <Stack container sx={{ gap: 2, flexDirection: 'row', width: '100%' }}>
                <Stack sx={{ backgroundColor: 'text.background', borderRadius: 3, width: '100%' }}>
                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Invoice Information
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.invoiceInformation}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, invoiceInformation: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Contact Name
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.contactName}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, contactName: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Email
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.email}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, email: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Additional Email
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.additionalEmail}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, additionalEmail: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        End Client Phone Number
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.endClientPhoneNumber}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, endClientPhoneNumber: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Address
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.address}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, address: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Payroll Tax State
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.payrollTaxState}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, payrollTaxState: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Billing Type
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.billingType}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, billingType: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Billing Frequency
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.billingFrequency}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, billingFrequency: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Billing Instruction
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.billingIntruction}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, billingIntruction: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Tenure Worked
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.tenureWorked}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, tenureWorked: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Expenses
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.expenses}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, expenses: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Hours Per Day
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.hoursPerDay}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, hoursPerDay: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Currency
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.currency}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, currency: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Vendor Name
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.vendorName}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, vendorName: e.target.value })}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Vendor Fee
                      </Typography>

                      <TextField
                        size="small"
                        value={tab1?.vendorFee}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, vendorFee: e.target.value })}
                      />
                    </Stack>
                  </Stack>
                  {/* <Divider /> */}
                  <Divider />
                  <Typography
                    fontWeight={500}
                    sx={{
                      color: 'text.secondary',
                      p: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    Additional
                  </Typography>
                  {/* <Stack sx={{ width: '100%'}}> */}

                  <Stack sx={{ width: '100%' }}>
                    <Stack sx={{}}>
                      <Grid container spacing={2}>
                        {Object?.entries(tab1?.voiceInfoBox3)?.map(([key, value]) => (
                          <Grid item xs={6} key={key}>
                            <Stack direction="row" sx={{ width: '100%', alignItems: 'center' }}>
                              <Typography sx={{ color: 'text.secondary', width: '120px', ml: 17 }}>{key}</Typography>
                              <Typography
                                sx={{
                                  color: 'text.primary',
                                  flexGrow: 1,
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  ml: 15,
                                }}
                              >
                                {value}
                              </Typography>
                              <Iconify
                                sx={{
                                  cursor: 'pointer',
                                  color: 'error.main',
                                  flexShrink: 0,
                                }}
                                icon="ph:x-circle-fill"
                                width="2rem"
                                onClick={() => handleRemoveButtonClick2(key)}
                              />
                            </Stack>
                          </Grid>
                        ))}
                      </Grid>
                    </Stack>
                    <Stack sx={{ flexDirection: 'row', px: 1, width: '100%', gap: 2, alignItems: 'center' }}>
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 142, p: 1 }}>
                        Key
                      </Typography>
                      <TextField
                        size="small"
                        sx={{ py: 0.5, width: '45%', background: 'text.background' }}
                        onChange={handleKeyInputChange2}
                        placeholder="Enter key"
                      />

                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 160, p: 1 }}>
                        Value
                      </Typography>
                      <TextField
                        size="small"
                        sx={{ py: 0.5, width: '38%', background: 'text.background' }}
                        onChange={handleValueInputChange2}
                        placeholder="Enter value"
                      />

                      <Iconify
                        sx={{ cursor: 'pointer' }}
                        icon="ph:plus-fill"
                        width="3rem"
                        color="text.secondary"
                        onClick={handleAddButtonClick2}
                      />
                    </Stack>
                  </Stack>

                  {/* </Stack> */}
                </Stack>
              </Stack>
            ) : null}

            {/* <Stack direction="row" spacing={1} sx={{ justifyContent: 'center', mt:2 }}>
  <Button color="custom" variant="contained" size="small" sx={{}}>
    Save
  </Button>
</Stack> */}
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={openHistoryEmail} onClose={() => handleCloseHistoryEmail()} style={{ borderRadius: 10 }}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95%', sm: '70%' },

            bgcolor: 'background.paper',
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
          }}
        >
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Send Email
          </Typography>
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <TextField
                  fullWidth
                  required
                  label="To"
                  variant="outlined"
                  size="small"
                  disabled
                  value={emailHistory}

                  //      onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>

              <Grid item xs={5.9}>
                <Autocomplete
                  size="small"
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setCcEmail([...newValue]);
                  }}
                  options={[{ title: '' }]}
                  getOptionLabel={(option) => option.title}
                  value={ccEmail.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;

                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="Cc" placeholder="Cc" size="small" />}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <Autocomplete
                  size="small"
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setBccEmail([...newValue]);
                  }}
                  options={[{ title: '' }]}
                  getOptionLabel={(option) => option.title}
                  value={bccEmail.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;

                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="BCc" placeholder="BCc" size="small" />}
                />
              </Grid>

              <Grid item xs={5} sx={{}}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel>Select Template</InputLabel>
                  <Select label="Select Template" onChange={(e) => handleTemplateSelect(e.target.value)}>
                    {tempList?.map((item) => (
                      <MenuItem key={item.id} value={item}>
                        {item.templateName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Typography
                //   onClick={() => navigate('/Email', { state: { undid: "undid", bodyDis: "" } })}

                sx={{
                  color: '#23A6F0',
                  fontWeight: 'bold',
                  fontSize: '17px',
                  marginLeft: '30px',
                  marginTop: '18px',
                  cursor: 'pointer',
                }}
              >
                Edit
              </Typography>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={11.8}>
                <TextField
                  label="Sub"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                />
              </Grid>
              <Grid item xs={11.8}>
                <Stack sx={{ flexDirection: 'row', gap: 1, alignItems: 'center' }}>
                  <Typography sx={{ textTransform: 'capitalize' }}>{greeting}</Typography>
                </Stack>
              </Grid>
              <Grid item xs={11.8}>
                <CKEditor
                  data={emailBody}
                  config={{
                    extraPlugins: [MyCustomUploadAdapterPlugin],
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();

                    setEmailBody(data);
                  }}
                  editor={ClassicEditor}
                />
              </Grid>
            </Grid>

            <Box
              sx={{
                //    border: "1px solid #3C6BA5",
                p: 2,
                borderRadius: 1,
                marginTop: 3,
              }}
            >
              <Stack direction="row" justifyContent="center" spacing={1}>
                <Button color="custom" variant="contained" size="small" onClick={SendEmail1}>
                  send Email
                </Button>
              </Stack>
            </Box>
          </Scrollbar>
        </Box>
      </Modal>
    </>
  );
}

function ManagementRow({ data, fun, valuee, tempList, data1, getBenchPlacement, index }) {
  
  const [rate, setRate] = useState();
  const [totalHours, setTotalHours] = useState('');
  const [totalamount, setTotalAmount] = useState('');
  const [handleInputDisable, sethandleInputDisable] = useState(false);
  const [handleInputDisable2, sethandleInputDisable2] = useState(false);

  const [fromDate, setFromDate] = useState('');
  const [tillDate, setTillDate] = useState('');

  const [openNotesModal2, setOpenNotesModal2] = useState(false);

  const handleOpenNotesModal2 = () => setOpenNotesModal2(true);
  const handleCloseNotesModal2 = () => setOpenNotesModal2(false);

  const browseInputRef = useRef(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [atchedsecond, setatchedsecond] = useState('');
  const [fileURLsecond, setFileUrlSecond] = useState('');

  const openFileBrowser = () => {
    browseInputRef.current.click();
  };

  const onFileSelect = (e) => {
    const pickedFile = e.target.files[0];
    if (pickedFile) {
      setUploadedFile(pickedFile);
      sendFileToServer(pickedFile);
    }
  };

  const sendFileToServer = async (pickedFile) => {
    setIsUploading(true);
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', pickedFile);
    formData.append('directoryName', 'timesheet');
    try {
      const response = await UploadFile('resume/upload_resume', formData, token);
      if (response.status === 200 && response.data.code === 200) {
        // const uploadedImageUrl = response.data.filePath;
        //  setUploadedImg(response.data.filePath)

        console.log('hello shyamlal sharma ji ==>>', response);
        setFileUrlSecond(response.data.filePath);
        setatchedsecond('attached');
        setIsUploading(false);
        setYear('');
        setMonth('');
        setFromWeek('');
        setToWeek('');

        //  setTotalHours(true)
        sethandleInputDisable(true);

        handleCloseModaltimesheet();
        //   setUploadedFile(null);

        //   setProfileImage(uploadedImageUrl);
        // UploadImage(uploadedImageUrl)
        //   setImagePreview(URL.createObjectURL(file));
      } else {
        toast.warn(response.data.status);
      }
    } catch (error) {
      // toast.warn('Error uploading the image!');
    } finally {
      setIsUploading(false);
    }
  };

  const [timeSheetMeta, setTimeSheetMeta] = useState({
    month: '',
    year: '',
    weekFrom: '',
    weekTill: '',
    candidateId: '',
    _id: '',
  });

  const pdfRef1 = useRef();

  //   const handleDownloadPDF = async () => {
  //   const element = pdfRef1.current;
  //   if (!element) return;

  //   //  Scrollbar container pakdo
  //   const scrollContainer = element.querySelector("[data-scrollbar]");

  //   //  Original styles save
  //   const original = {
  //     elOverflow: element.style.overflow,
  //     scMaxHeight: scrollContainer?.style.maxHeight,
  //     scOverflow: scrollContainer?.style.overflow,
  //   };

  //   //  TEMP styles (scroll remove)
  //   element.style.overflow = "visible";

  //   if (scrollContainer) {
  //     scrollContainer.style.maxHeight = "none";
  //     scrollContainer.style.overflow = "visible";
  //   }

  //   //  Horizontal scroll fix
  //   const horizontalBoxes = element.querySelectorAll("[style*='overflow-x']");
  //   horizontalBoxes.forEach((el) => {
  //     el.style.overflowX = "visible";
  //   });

  //   //  Wait
  //   await new Promise((res) => setTimeout(res, 300));

  //   //  Capture
  //   const canvas = await html2canvas(element, {
  //     scale: 2,
  //     useCORS: true,
  //     scrollY: -window.scrollY,
  //   });

  //   const imgData = canvas.toDataURL("image/png");

  //   //  LANDSCAPE PDF (MOST IMPORTANT LINE)
  //   const pdf = new JsPDF("l", "mm", "a4");

  //   const pdfWidth = pdf.internal.pageSize.getWidth();
  //   const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //   let heightLeft = pdfHeight;
  //   let position = 0;

  //   // 🔹 First page
  //   pdf.addImage(imgData, "PNG", 0, position, pdfWidth, pdfHeight);
  //   heightLeft -= pdf.internal.pageSize.getHeight();

  //   // 🔹 Extra pages
  //   while (heightLeft > 0) {
  //     position -= pdf.internal.pageSize.getHeight();
  //     pdf.addPage();
  //     pdf.addImage(imgData, "PNG", 0, position, pdfWidth, pdfHeight);
  //     heightLeft -= pdf.internal.pageSize.getHeight();
  //   }

  //   pdf.save("Timesheet.pdf");

  //   // 🔹 Styles restore
  //   element.style.overflow = original.elOverflow;
  //   if (scrollContainer) {
  //     scrollContainer.style.maxHeight = original.scMaxHeight;
  //     scrollContainer.style.overflow = original.scOverflow;
  //   }
  // };

  const handleDownloadPDF = async () => {
    const element = pdfRef1.current;
    if (!element) return;

    const scrollContainer = element.querySelector('[data-scrollbar]');

    const original = {
      elOverflow: element.style.overflow,
      elWidth: element.style.width,
      scMaxHeight: scrollContainer?.style.maxHeight,
      scOverflow: scrollContainer?.style.overflow,
    };

    element.style.overflow = 'visible';
    if (scrollContainer) {
      scrollContainer.style.maxHeight = 'none';
      scrollContainer.style.overflow = 'visible';
    }

    element.style.width = `${element.scrollWidth}px`;

    const horizontalBoxes = element.querySelectorAll("[style*='overflow-x']");
    horizontalBoxes.forEach((el) => {
      el.style.overflowX = 'visible';
    });

    await new Promise((res) => setTimeout(res, 300));

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      scrollY: -window.scrollY,
      windowWidth: element.scrollWidth,
    });

    const imgData = canvas.toDataURL('image/png');

    const pdf = new JsPDF('l', 'mm', 'a4');

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    let heightLeft = pdfHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
    heightLeft -= pdf.internal.pageSize.getHeight();

    while (heightLeft > 0) {
      position -= pdf.internal.pageSize.getHeight();
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
      heightLeft -= pdf.internal.pageSize.getHeight();
    }

    pdf.save('Timesheet.pdf');

    element.style.overflow = original.elOverflow;
    element.style.width = original.elWidth;

    if (scrollContainer) {
      scrollContainer.style.maxHeight = original.scMaxHeight;
      scrollContainer.style.overflow = original.scOverflow;
    }
  };

  const [timeSheet, setTimeSheet] = useState({
    // ---------- Placement Timeline ----------

    unofficialPOClientStatus: '', // yes / no / pending
    unofficialPOCandidateAcceptanceStatus: '', // yes / no / pending

    writtenOfferClientStatus: '', // offer_released / in_process / offer_cancelled / pending
    writtenOfferCandidateAcceptanceStatus: '', // accepted / pending / not_accepted

    backgroundChecksOverallStatus: '', // pending / in_process / completed / failed

    employmentCheckStatus: '', // completed / in_process / failed / pending
    securityCheckStatus: '', // completed / in_process / failed / pending
    workVisaIdCheckStatus: '', // completed / in_process / failed / pending
    drugTestStatus: '', // completed / in_process / failed / pending
    creditCheckStatus: '', // completed / in_process / failed / pending
    educationBackgroundCheckStatus: '', // completed / in_process / failed / pending
    securityClearanceStatus: '', // completed / in_process / failed / pending
    referencesCheckStatus: '', // completed / in_process / failed / pending

    otherBackgroundCheckName: '', // free text
    otherBackgroundCheckStatus: '', // completed / in_process / failed / pending

    backgroundCheckClientAcceptanceStatus: '', // completed / pending
    finalSOWStatus: '', // completed / pending

    actualStartDateStatus: '', // pending / allotted
    actualStartDate: null, // Date (if allotted)

    logisticsEquipmentStatus: '', // received / pending

    autoReminderEmailEnabled: false, // true / false
    autoReminderEmailTemplateStatus: '', // done / pending

    candidateStartStatus: '', // successfully_started / candidate_back_out / pending

    projectEnded: false, // true / false
    projectEndDate: null, // Date if true

    // ---------- Retention / Process Check ----------

    firstDay: {
      type: 'client', // candidate
      status: 'yes', // yes or pending
      addedBy: '',
      notes: '',
      feedback: '',
    },
    firstWeek: {
      type: 'client', // candidate
      status: 'yes', // yes or pending
      addedBy: '',
      notes: '',
      feedback: '',
    },
    firstMonth: {
      type: 'client', // candidate
      status: 'yes', // yes or pending
      addedBy: 'Project Manager',
      notes: 'Performance is good',
      feedback: 'Satisfied',
    },
    sixMonths: {
      type: 'client', // candidate
      status: 'yes', // yes or pending
      addedBy: '',
      notes: '',
      feedback: '',
    },
    firstYear: {
      type: 'client', // candidate
      status: 'yes', // yes or pending
      addedBy: '',
      notes: '',
      feedback: '',
    },
    // "firstDayClientStatus": "",           // yes / pending
    // "firstDayClientBy": "",                      // user name
    // "firstDayClientNotes": "",                   // notes

    // "firstDayCandidateStatus": "",        // yes / pending
    // "firstDayCandidateBy": "",
    // "firstDayCandidateNotes": "",

    // "firstWeekClientStatus": "",
    // "firstWeekClientBy": "",
    // "firstWeekClientNotes": "",

    // "firstWeekCandidateStatus": "",
    // "firstWeekCandidateBy": "",
    // "firstWeekCandidateNotes": "",

    // "firstMonthClientStatus": "",
    // "firstMonthClientBy": "",
    // "firstMonthClientNotes": "",

    // "firstMonthCandidateStatus": "",
    // "firstMonthCandidateBy": "",
    // "firstMonthCandidateNotes": "",

    // "sixMonthsClientStatus": "",
    // "sixMonthsClientBy": "",
    // "sixMonthsClientNotes": "",

    // "sixMonthsCandidateStatus": "",
    // "sixMonthsCandidateBy": "",
    // "sixMonthsCandidateNotes": "",

    // "firstYearClientStatus": "",
    // "firstYearClientBy": "",
    // "firstYearClientNotes": "",

    // "firstYearCandidateStatus": "",
    // "firstYearCandidateBy": "",
    // "firstYearCandidateNotes": "",

    // ---------- Feedback & Surveys ----------

    feedbackClientStatus: '', // yes / no / pending
    clientResponseStatus: '', // positive / negative
    feedbackClientSendSurvey: false, // true / false
    feedbackClientSurveyEmail: '',
    feedbackClientSurveyResultFile: '', // URL to file

    feedbackCandidateStatus: '', // yes / no / pending
    candidateResponseStatus: '', // positive / negative
    feedbackCandidateSendSurvey: false, // true / false
    feedbackCandidateSurveyEmail: '',
    feedbackCandidateSurveyResultFile: '',
  });

  const [modalOpentimesheet, setModalOpentimesheet] = useState(false);

  const [weeksData, setWeeksData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);

  const handleOpenModaltimesheet = () => {
    setModalOpentimesheet(true);
  };

  const handleCloseModaltimesheet = () => {
    setModalOpentimesheet(false);
  };

  const generateTimeOptions = () => {
    const options = [];
    for (let h = 0; h <= 24; h += 1) {
      for (let m = 0; m < 60; m += 15) {
        if (h === 24 && m > 0) break;
        const hour = h.toString().padStart(2, '0');
        const min = m.toString().padStart(2, '0');
        options.push(`${hour}:${min}`);
      }
    }
    return options;
  };
  const timeOptions = generateTimeOptions();

  const generateBreakOptions = () => {
    const options = [];

    for (let hour = 0; hour < 24; hour += 1) {
      for (let minute = 0; minute < 60; minute += 15) {
        const hh = hour.toString().padStart(2, '0');
        const mm = minute.toString().padStart(2, '0');
        options.push(`${hh}:${mm}`);
      }
    }
    return options;
  };
  const breakOptions = generateBreakOptions();

  const timeToMinutes = (time) => {
    if (!time) return 0;
    const [h, m] = time.split(':').map(Number);
    return h * 60 + m;
  };

  const minutesToTime = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h}:${m.toString().padStart(2, '0')}`;
  };

  const getWeekTotals = (days) => {
    let workingMin = 0;
    let overtimeMin = 0;
    let totalMin = 0;

    days.forEach((d) => {
      if (d.approvalStatus === 'Approved') {
        workingMin += timeToMinutes(d.workingHours);
        overtimeMin += timeToMinutes(d.overtime);
        totalMin += timeToMinutes(d.totalHours);
      }
      // workingMin += timeToMinutes(d.workingHours);
      // overtimeMin += timeToMinutes(d.overtime);
      // totalMin += timeToMinutes(d.totalHours);
    });

    return {
      working: minutesToTime(workingMin),
      overtime: minutesToTime(overtimeMin),
      total: minutesToTime(totalMin),
    };
  };

  const handleEditAll = () => {
    setIsEditMode(true);

    const updatedWeeks = weeksData.map((week) => ({
      ...week,
      days: week.days.map((day) => ({
        ...day,
        editMode: true,
      })),
    }));

    setWeeksData(updatedWeeks);
  };

  const handleSaveAll = async () => {
    const updatedWeeks = weeksData.map((week) => ({
      ...week,
      days: week.days.map((day) => ({
        ...day,
        editMode: false,
      })),
    }));
    const payload = {
      _id: timeSheetMeta._id,
      month: timeSheetMeta.month,
      year: timeSheetMeta.year,
      candidateId: timeSheetMeta.candidateId,
      weeks: updatedWeeks,
    };

    console.log('hello', updatedWeeks);

    Api('timeSheet/update-multiple-timeWork', 'POST', payload)
      .then((res) => {
        console.log('hello=====>>>>', res);
        if (res.status === 200 && res.data.code === 200) {
          //  setWeeksData(updatedWeeks);
          setIsEditMode(false);
          toast.success(res.data.message);
          handleDownloadPDF();
          handleApply();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch(() => {});
  };

  // const handleChangetime = (weekIndex, dayIndex, field, value) => {
  //    setWeeksData((prev) => {
  //     const updatedWeeks = [...prev.weeks];

  //     updatedWeeks[weekIndex] = {
  //       ...updatedWeeks[weekIndex],
  //       days: updatedWeeks[weekIndex].days.map((day, idx) =>
  //         idx === dayIndex
  //           ? {
  //               ...day,
  //               [field]: value,
  //             }
  //           : day
  //       ),
  //     };

  //     return {
  //       ...prev,
  //       weeks: updatedWeeks,
  //     };
  //   });
  // };

  // const handleChangetime = (weekIndex, dayIndex, field, value) => {
  //   setWeeksData((prev) =>
  //     prev.map((week, wi) =>
  //       wi === weekIndex
  //         ? {
  //           ...week,
  //           days: week.days.map((day, di) =>
  //             di === dayIndex
  //               ? {
  //                 ...day,
  //                 [field]: value,
  //               }
  //               : day
  //           ),
  //         }
  //         : week
  //     )
  //   );
  // };

  //   const handleChangetime = (weekIndex, dayIndex, field, value) => {
  //   setWeeksData((prev) =>
  //     prev.map((week, wi) =>
  //       wi === weekIndex
  //         ? {
  //             ...week,
  //             days: week.days.map((day, di) => {
  //               if (di !== dayIndex) return day;

  //               if (field === "timeIn" && day.timeOut) {
  //                 const inMin = timeToMinutes(value);
  //                 const outMin = timeToMinutes(day.timeOut);

  //                 if (outMin < inMin) {
  //                   return {
  //                     ...day,
  //                     timeOut: "",
  //                     timeIn: value,
  //                   };
  //                 }
  //               }

  //               return {
  //                 ...day,
  //                 [field]: value,
  //               };
  //             }),
  //           }
  //         : week
  //     )
  //   );
  // };

  const handleChangetime = (wIdx, dIdx, key, value) => {
    setWeeksData((prev) => {
      const copy = [...prev];
      const day = copy[wIdx].days[dIdx];

      if (key === 'timeIn') {
        if (day.timeOut) {
          const inMin = timeToMinutes(value);
          const outMin = timeToMinutes(day.timeOut);

          if (outMin < inMin) {
            day.timeOut = '';
          }
        }
      }

      day[key] = value;
      return copy;
    });
  };

  const getFilteredTimeOutOptions = (timeIn) => {
    if (!timeIn) return timeOptions;

    const inMinutes = timeToMinutes(timeIn);
    return timeOptions.filter((t) => timeToMinutes(t) >= inMinutes);
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [fileURL, setFileUrl] = useState('');
  const [atched, setatched] = useState('');

  const handleUploadClick11 = () => {
    if (!isInvoiceSaved) return;
    fileInputRef.current.click();
  };

  const handleFileChange55 = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setSelectedFile(file);
    uploadMulti(file);
  };

  const uploadMulti = async (file) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', file);
    formData.append('directoryName', 'invoice');
    try {
      const response = await UploadFile('resume/upload_resume', formData, token);
      if (response.status === 200 && response.data.code === 200) {
        // const uploadedImageUrl = response.data.filePath;
        //  setUploadedImg(response.data.filePath)

        console.log('hello shyamlal sharma ji ==>>', response);
        setFileUrl(response.data.filePath);
        setatched('attached');
        setInvoiceModalOpen(false);
        setInvoiceData({
          fromAddress: '',
          billedTo: '',
          invoiceDate: '',
          dueDate: '',
          invoiceNumber: '',
          bankName: '',
          accountHolder: '',
          accountNumber: '',
          accountType: '',
          routingNumber: '',
          beneficiaryName: '',
          description: '',
        });
        setYear('');
        setMonth('');
        setFromWeek('');
        setToWeek('');
        sethandleInputDisable2(true);
        //    setSelectedFile(null);

        //   setProfileImage(uploadedImageUrl);
        // UploadImage(uploadedImageUrl)
        //   setImagePreview(URL.createObjectURL(file));
      } else {
        //   toast.warn(response.data.status + '!');
      }
    } catch (error) {
      // toast.warn('Error uploading the image!');
    }
  };

  const pdfRef = useRef();
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);

  const [isInvoiceEdit, setIsInvoiceEdit] = useState(false);

  const [isInvoiceSaved, setIsInvoiceSaved] = useState(false);

  const [invoiceData, setInvoiceData] = useState({
    fromAddress: '',
    billedTo: '',
    invoiceDate: '',
    dueDate: '',
    invoiceNumber: '',
    bankName: '',
    accountHolder: '',
    accountNumber: '',
    accountType: '',
    routingNumber: '',
    beneficiaryName: '',
    description: '',
  });
  const [logoCompany, setLogoCompany] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData((prev) => ({ ...prev, [name]: value }));
  };

  // const handleEditSave = () => {

  //   if (isInvoiceEdit) {
  //           setIsInvoiceEdit(false);
  //           setIsInvoiceSaved(true);
  //   } else {
  //     setIsInvoiceEdit(true);
  //   }

  // };

  //  const handleUpload = async () => {
  //     if (pdfRef.current) {
  //             const canvas = await html2canvas(pdfRef.current, { scale: 2 });
  //              const imgData = canvas.toDataURL("image/png");

  //             const pdf = new jsPDF("p", "pt", "a4");
  //             const pdfWidth = pdf.internal.pageSize.getWidth();
  //             const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //             pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //             pdf.save(`Invoice_${invoiceData.invoiceNumber || "001"}.pdf`);
  //      // setInvoiceModalOpen(false); // Close modal
  //     }
  //   };
  const handleEditSave = async () => {
    if (isInvoiceEdit) {
      setIsInvoiceEdit(false);

      setTimeout(async () => {
        const success = await handleUpload();

        if (success) {
          setIsInvoiceSaved(true);
        } else {
          setIsInvoiceSaved(false);
          toast.error('no  generate PDF File . plz try again');
        }
      }, 300);
    } else {
      setIsInvoiceEdit(true);
    }
  };

  const handleUpload = async () => {
    try {
      if (!pdfRef.current) return false;

      const canvas = await html2canvas(pdfRef.current, { scale: 2 });
      const imgData = canvas.toDataURL('image/png');

      const pdf = new JsPDF('p', 'pt', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`Invoice_${invoiceData.invoiceNumber || '001'}.pdf`);

      return true;
    } catch (error) {
      console.error('PDF generation failed', error);
      return false;
    }
  };

  const [valuew, setValuew] = useState('');
  const [open1, setOpen1] = useState(false);
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');
  const [fromWeek, setFromWeek] = useState('');
  const [toWeek, setToWeek] = useState('');

  const [placementFrom, setPlacementFrom] = useState(''); // bench | recruiter
  // const [placementId, setPlacementId] = useState("");
  const [invoice, setInvoice] = useState(''); // client | candidate
  const [candidateId, setCandidateId] = useState('');
  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');

  function fun1(value) {
    if (!value || !value.includes(':')) return 0;

    const [hour, min] = value.split(':').map(Number);

    return hour + min / 60;
  }

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);
  const fromWeeks = [1, 2, 3, 4, 5];
  const toWeeks = fromWeek ? Array.from({ length: 5 - fromWeek + 1 }, (_, i) => fromWeek + i) : [];
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const handleApply = () => {
    const body = {
      "year": year,
      "month": month,
      weekFrom: fromWeek,
      weekTill: toWeek,

      placementFrom: placementFrom === 'rec' ? 'recruitor' : 'bench', // bench / recruiter
      placementId: candidateId,
      "invoice": invoice, // client / candidate
    };

    const token = localStorage.getItem('token');

    //    console.log("hello shyamlal sharma ji ",body);
    Api('timeSheet/searchTimeSheet', 'POST', body, token)
      .then((response) => {
        console.log('heelo shyamlalan. shgsyg=====>>>>>hjbdgugygbd db shsg ', response);
        console.log('====>');
        console.log(valuew);
        if (response.status === 200) {
          if (response.data.code === 200) {
            console.log('Success data:======>>>>', response.data.data);
            // setTimeSheetMeta({
            //              month: response.data.result.month,
            //              year: response.data.result.year,
            //              candidateId: response.data.result.candidateId,
            //              weekFrom:response.data.searchedData.weekFrom,
            //              weekTill:response.data.searchedData.weekTill,
            //            _id: response.data.result._id,
            //          });
            //       setRate(response?.data?.searchedData?.rate);
            //     setTotalHours(response.data.totals.totalHours);
            //     setTotalAmount((response?.data?.searchedData?.rate) * fun1(response.data.totals.totalHours));
            //     setFromDate(response.data.searchedData.fromDate);
            //     setTillDate(response.data.searchedData.tillDate);

            if (valuew === 'timesheet') {
              const updatedWeeks = response.data.result.weeks.map((week) => ({
                ...week,
                days: week.days.map((day) => ({
                  ...day,
                  editMode: false,
                })),
              }));
              setWeeksData(updatedWeeks);
              setTimeSheetMeta({
                month: response.data.result.month,
                year: response.data.result.year,
                candidateId: response.data.result.candidateId,
                weekFrom: response.data.searchedData.weekFrom,
                weekTill: response.data.searchedData.weekTill,
                _id: response.data.result._id,
              });
              handleOpenModaltimesheet();
              setOpen1(false);
              setTotalHours(response.data.totals.totalHours);
              // setMonth("");
              // setFromWeek("");
              // setToWeek("");
              // setYear("");
            } else {
              setTimeSheetMeta({
                month: response.data.result.month,
                year: response.data.result.year,
                candidateId: response.data.result.candidateId,
                weekFrom: response.data.searchedData.weekFrom,
                weekTill: response.data.searchedData.weekTill,
                _id: response.data.result._id,
              });

              setRate(response?.data?.searchedData?.rate);
              //  setTotalHours(response.data.totals.totalHours);

              setTotalAmount(response?.data?.searchedData?.rate * fun1(response.data.totals.totalHours));
              setLogoCompany(response?.data?.searchedData?.logo);

              setInvoiceModalOpen(true);
              setOpen1(false);
              //  if((valuew === "timesheet"))
              //  {
              //        setTotalHours(response.data.totals.totalHours);
              //  }
              setTotalHours(response.data.totals.totalHours);
              setFromDate(response.data.searchedData.fromDate);
              setTillDate(response.data.searchedData.tillDate);
            }
          } else {
            console.log('heelo ');
          }
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => {
        // console.log("API Error:", err);
        //  setHelperText("Something went wrong");
        //  setErr(true);
      });
  };

  const filter = createFilterOptions();
  const [bccEmail, setBccEmail] = useState([]);

  const [ccEmail, setCcEmail] = useState([]);
  const [openEmail, setOpenEmail] = useState(false);


  const [greeting, setGreeting] = useState('');
  const [subject, setSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');

  console.log("hello shyamlal sharma ji ===>>>", ccEmail)
  console.log("hello shyamlal sharma ji pathanpura wal e===>>", bccEmail)

 // email/send_bulk_mail
  // console.log("keelooojdbhjuc=====>>>>", emailBody);

  // const fileRef = useRef(null);

  const timeSheetRef = useRef(null);
  const invoiceRef = useRef(null);

  const [filetime, setFileTimeSheet] = useState(null);
  const [fileinvoice, setFileInvoice] = useState(null);

  // const handleUploadClick = () => {
  //   fileRef.current.click();
  // };

  const handleUploadTimeSheet = () => {
    timeSheetRef.current.click();
  };

  const handleUploadInvoice = () => {
    invoiceRef.current.click();
  };

  const handleFileChangeTimeSheet = (e) => {
    console.log('hello si r');
    const selectedFile = e.target.files[0];
    // setFileTimeSheet(selectedFile);
    uploadMulti2(selectedFile);
  };

  const handleFileChangeInvoice = (e) => {
    console.log('huuuu');
    const selectedFile = e.target.files[0];
    // setFileInvoice(selectedFile);
    uploadMulti3(selectedFile);
  };

  const uploadMulti2 = async (file) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', file);
    formData.append('directoryName', 'profile');
    try {
      const response = await UploadFile('resume/upload_resume', formData, token);
      if (response.status === 200 && response.data.code === 200) {
        setFileUrlSecond(response.data.filePath);
        setFileTimeSheet(file);
      } else {
        console.log('invaild');
      }
    } catch (error) {
      console.log('');
    }
  };

  const uploadMulti3 = async (file) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', file);
    formData.append('directoryName', 'profile');
    try {
      const response = await UploadFile('resume/upload_resume', formData, token);
      if (response.status === 200 && response.data.code === 200) {
        console.log('hello shyamlal sharma ji ==>>', response);
        setFileUrl(response.data.filePath);
        setFileInvoice(file);
      } else {
        console.log('');
      }
    } catch (error) {
      console.log('');
    }
  };

  const sendPlacedMail = async () => {
    const token = localStorage.getItem('token');
    if (!Number(totalamount)) {
      toast.error('Total Amount is required');
      return;
    }
    if (!totalHours) {
      toast.error('Total Hours is required ');
      return;
    }


    //  const [filetime, setFileTimeSheet] = useState(null);
    // const [fileinvoice, setFileInvoice] = useState(null);
const emailArraybcc = bccEmail.map(item => item.inputValue);

const emailArraycc =ccEmail.map(item=>item.inputValue)

  //     const [bccEmail, setBccEmail] = useState([]);

  // const [ccEmail, setCcEmail] = useState([]);

    const body = {
      "subject": subject,
      attachment: fileURL,
      fileName: selectedFile?.name || filetime.name,
      attachmentInvoice: fileURLsecond,
      fileNameInvoice: uploadedFile?.name || fileinvoice.name,
      others: [
        {
          name: fullName?.split(' ')[0].charAt(0).toUpperCase() + fullName.split(' ')[0].slice(1) || '',
          "email": email
        }
      ],
        "ccEmails":emailArraycc,
        "bccEmails":emailArraybcc,

      mailBody: emailBody,
      searchedData: {
        placementFrom: placementFrom === 'rec' ? 'recruitor' : 'bench',
        "invoice": invoice,
        yearN: timeSheetMeta.year || year,
        monthN: timeSheetMeta.month || month,
        weekF: timeSheetMeta.weekFrom || fromWeek,
        weekT: timeSheetMeta.weekTill || toWeek,
        "rate": rate,
        "totalHours": totalHours,
        amount: Number(totalamount),
        placementId: timeSheetMeta.candidateId || candidateId,
        "fromDate": fromDate,
        "tillDate": tillDate,
      },
    };
    console.log("hello sachin sharma what do u do ==>", body )

    try {
      const Response = await Api('timeSheet/sendMailPlaced', 'POST', body, token);

      //  console.log("heeloo hyyyey gvyf=====>>>> ", Response);

      if (Response.status === 200) {
        // if (Response.data.code === 200) {
        toast.success('Mail sent successfully!');
        setTotalHours('');
        setTotalAmount('');
        handleCloseEmail();
        setFileUrl('');
        setSelectedFile('');
        setFileUrlSecond('');
        setUploadedFile('');
        setTimeSheetMeta({
          month: '',
          year: '',
          weekFrom: '',
          weekTill: '',
          candidateId: '',
          _id: '',
        });
        // } else {
        //   toast.warn(`${Response.data.status || "Failed to send mail"}!`);
        // }

        if (valuew === 'invoiveManuval' || valuew === 'timeSheetManuval') {
          manuMannuallyTimeSheet(candidateId, fromWeek, toWeek, totalHours, year, month);
        }
      } else {
        toast.warn('Error sending mail!');
      }
    } catch (err) {
      console.error('Send mail failed', err);
      toast.error('Something went wrong!');
    }
  };

  function manuMannuallyTimeSheet(candidateId, fromWeek, toWeek, totalHours) {
    const payload = {
      "month": month,
      "year": year,
      "candidateId": candidateId,
      generatedBy: 'Mannually',
      totalHoursPerWeek: totalHours,
      weekFrom: fromWeek,
      weekTill: toWeek,
    };

    const token = localStorage.getItem('token');
    Api(`timeSheet/generateTimesheet`, 'POST', payload, token)
      .then((response) => {
        if (response.status === 200) {
          console.log('manuvalyCreated timeSheet ');
          // if (true) {
          //   console.log("hello");

          // } else {

          //   console.log("hello")

          // }
        } else {
          console.log('helllo');
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
      });
  }

  const handleOpenEmail = (value, candidateId, fullname, email, invoiceType) => {
    sethandleInputDisable(false);
    sethandleInputDisable2(false);
    setFileTimeSheet('');
    setFileInvoice('');
    setTotalHours('');
    setTotalAmount('');
    setatchedsecond('');
    setatched('');
    setUploadedFile('');
    setSelectedFile('');
    setYear('');
    setMonth('');
    setFromWeek('');
    setToWeek('');

    // setPlacementId(placementId);
    setPlacementFrom(value);
    setCandidateId(candidateId);
    setInvoice(invoiceType);
    setEmail(email);
    setFullName(fullname);
    setOpenEmail(true);
  };

  const handleCloseEmail = () => {
    setOpenEmail(false);
  };

  const handleTemplateSelect = (item) => {
    if (item && item.template && item.template.length > 0) {
      setGreeting(item.template[0].greeting);
      setSubject(item.template[0].subject);
      setEmailBody(item.template[0].emailBody);
    }
  };

  const [phoneCopy, setPhoneCopy] = useState(false);
  const [emailCopy, setEmailCopy] = useState(false);

  const styleSkill = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '85%', sm: '75%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const styleClients = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '60%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const [open, setOpen] = useState(false);
  // const openPlaceDetails = () => {
  //   // getPlacementDetails(id)
  //   setOpen(true);
  // };
  const closePlaceDetails = () => setOpen(false);

  const navigate = useNavigate();

  const optionsDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    // timeZone: 'UTC'
  };

  const tablebg = 'rgba(82, 130, 190, 0.08)';
  const [value, setValue] = useState('placement');

  const handleTabPlace = (Tab) => {
    setValue(Tab);
    if (Tab === 'Expenses') handleOpenExpenses();
  };

  const [placeDetails1, setPlaceDetails1] = useState('');
  const [inputValues, setInputValues] = useState('');
  const [inputValues11, setInputValues11] = useState('');
  const [inputValues1, setInputValues1] = useState('');
  const [inputValues2, setInputValues2] = useState('');

  const [loading, setLoading] = useState('');
  const [detailsId, setDetailsId] = useState('');

  const getPlacementDetails = (data) => {
    setDetailsId(data);
    setTab1({
      ...tab1,
      placementInfoBoX1: {},
      voiceInfoBox3: {},
      projectInfoBox2: {},
      projectInfoBox1: {},
    });
    setCityStateStyling(true);
    // setPlaceDetails([''])
    setLoading('Loading...');
    const body = {
      placementId: data?.placementId,
      placementFrom: valuee === 'bench' ? 'bench' : 'recruitor',

      [valuee === 'rec' ? 'resumeId' : 'benchId']: valuee === 'rec' ? data?.resumeId : data?.benchId,

      submissionId: data?.submissionId,
      // "resumeId":data?.resumeId
    };
    const token = localStorage.getItem('token');
    Api(`bench/getPlacementDetail`, 'POST', body, token)
      .then((response) => {
        console.log('hello shyamlal====>>>', response);
        if (response.status === 200) {
          // console.log("response.data", response.data.result)
          setPlaceDetails1(response.data?.result);
          const placeDetails = response.data?.result;
          // console.log("placeDetails.placementInfoBoX1",response.data?.result?.placementInfoBoX1)
          setInputValues(response.data?.result?.placementInfoBoX1);
          setInputValues11(response.data?.result?.projectInfoBox1);
          setInputValues1(response.data?.result?.projectInfoBox2);
          setInputValues2(response.data?.result?.voiceInfoBox3);

          setTab1({
            placementInfoBoX1: placeDetails?.placementInfoBoX1 ? placeDetails?.placementInfoBoX1 : {},
            projectInfoBox2: placeDetails?.projectInfoBox2 ? placeDetails?.projectInfoBox2 : {},
            voiceInfoBox3: placeDetails?.voiceInfoBox3 ? placeDetails?.voiceInfoBox3 : {},
            projectInfoBox1: placeDetails?.projectInfoBox1 ? placeDetails?.projectInfoBox1 : {},
            placementId: placeDetails?.placementId ? placeDetails?.placementId : '',
            status: placeDetails?.status ? placeDetails?.status : '',
            endClientName: placeDetails?.endClientName ? placeDetails?.endClientName : '',
            positionName: placeDetails?.positionName ? placeDetails?.positionName : '',
            reportingManagerName: placeDetails?.reportingManagerName,
            reportingManagerEmail: placeDetails?.reportingManagerEmail,
            reportingManagerNumber: placeDetails?.reportingManagerNumber,

            jobType: placeDetails?.jobType ? placeDetails?.jobType : '',
            taxTerm: placeDetails?.taxTerm ? placeDetails?.taxTerm : '',
            annualSalary: placeDetails?.annualSalary ? placeDetails?.annualSalary : '',
            joiningBonus: placeDetails?.joiningBonus ? placeDetails?.joiningBonus : '',
            relocationAssistance: placeDetails?.relocationAssistance ? placeDetails?.relocationAssistance : '',
            annualBonus: placeDetails?.annualBonus ? placeDetails?.annualBonus : '',
            billRate: placeDetails?.billRate ? placeDetails?.billRate : '',
            payRate: placeDetails?.payRate ? placeDetails?.payRate : '',
            overTimeBillRate: placeDetails?.overTimeBillRate ? placeDetails?.overTimeBillRate : '',
            fullName: placeDetails?.fullName ? placeDetails?.fullName : '',
            candidateId: placeDetails?.candidateId ? placeDetails?.candidateId : '',
            accountManager: placeDetails?.accountManager ? placeDetails?.accountManager : '',
            startDate: placeDetails?.startDate ? placeDetails?.startDate : '',
            endDate: placeDetails?.endDate ? placeDetails?.endDate : '',
            placementTenture: placeDetails?.placementTenture ? placeDetails?.placementTenture : '',
            placementStatus: placeDetails?.placementStatus ? placeDetails?.placementStatus : '',
            guranttePeriod: placeDetails?.guranttePeriod ? placeDetails?.guranttePeriod : '',
            // notes: placeDetails?.notes?.note ? placeDetails?.notes?.note : '',
            country: placeDetails?.country ? placeDetails?.country : localStorage.getItem('country'),
            employmentType: placeDetails?.employmentType ? placeDetails?.employmentType : '',

            implementationPartner: placeDetails?.implementationPartner ? placeDetails?.implementationPartner : '',
            projectType: placeDetails?.projectType ? placeDetails?.projectType : '',
            domain: placeDetails?.domain ? placeDetails?.domain : '',

            recruitorTeamInfo: placeDetails?.recruitorTeamInfo ? placeDetails?.recruitorTeamInfo : '',
            recruitorName: placeDetails?.recruitorName ? placeDetails?.recruitorName : '',
            ManagingTeamInfo: placeDetails?.ManagingTeamInfo ? placeDetails?.ManagingTeamInfo : '',
            lead: placeDetails?.lead ? placeDetails?.lead : '',
            Manager: placeDetails?.Manager ? placeDetails?.Manager : '',
            head: placeDetails?.head ? placeDetails?.head : '',
            accountManagerOwnership: placeDetails?.accountManagerOwnership ? placeDetails?.accountManagerOwnership : '',

            invoiceInformation: placeDetails?.invoiceInformation ? placeDetails?.invoiceInformation : '',
            contactName: placeDetails?.contactName ? placeDetails?.contactName : '',
            email: placeDetails?.email ? placeDetails?.email : '',
            additionalEmail: placeDetails?.additionalEmail ? placeDetails?.additionalEmail : '',
            endClientPhoneNumber: placeDetails?.endClientPhoneNumber ? placeDetails?.endClientPhoneNumber : '',
            address: placeDetails?.address ? placeDetails?.address : '',
            payrollTaxState: placeDetails?.payrollTaxState ? placeDetails?.payrollTaxState : '',
            billingType: placeDetails?.billingType ? placeDetails?.billingType : '',
            billingFrequency: placeDetails?.billingFrequency ? placeDetails?.billingFrequency : '',
            billingIntruction: placeDetails?.billingIntruction ? placeDetails?.billingIntruction : '',
            tenureWorked: placeDetails?.tenureWorked ? placeDetails?.tenureWorked : '',
            expenses: placeDetails?.expenses ? placeDetails?.expenses : '',
            hoursPerDay: placeDetails?.hoursPerDay ? placeDetails?.hoursPerDay : '',
            currency: placeDetails?.currency ? placeDetails?.currency : '',
            vendorName: placeDetails?.vendorName ? placeDetails?.vendorName : '',
            vendorFee: placeDetails?.vendorFee ? placeDetails?.vendorFee : '',
            comment: placeDetails?.comment ? placeDetails?.comment : '',
            duration: placeDetails?.duration ? placeDetails?.duration : '',
            perDiem: placeDetails?.perDiem ? placeDetails?.perDiem : '',
            endReason: placeDetails?.endReason ? placeDetails?.endReason : '',
            chargeType: placeDetails?.chargeType ? placeDetails?.chargeType : '',
            commisionDate: placeDetails?.commisionDate ? placeDetails?.commisionDate : '',
            commisionAmount: placeDetails?.commisionDate ? placeDetails?.commisionAmount : '',
             id:placeDetails?._id
          });
          setTimeSheet(placeDetails.timeline);

          setCityy(placeDetails?.clientCity ? placeDetails?.clientCity : '');
          setCityandstate(response.data?.result?.clientCity);
          // console.log("response.data", response.data.result)
          setStateCode1(placeDetails?.clientStateCode ? placeDetails?.clientStateCode : '');
          setLoading('');
          setOpen(true);
        } else {
          // toast.warn(response.data.message, +'!');
          setLoading('No data found');
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  // console.log("placeDetails", placeDetails._id)

  const [placeEdit, setPlaceEdit] = useState(true);
  const [edit, setEdit] = useState(false);

  const editSource = () => {
    setPlaceEdit(false);
    if (edit === false) {
      setEdit(true);
      // alert("true")
      setIsEditing(true);
    } else if (edit === true) {
      // alert("false")

      EditPlacement();
      EditTimeSheet();
      setEdit(false);
      setPlaceEdit(true);
    }
  };

  function EditTimeSheet() {
    const body = {
      placementId: placeDetails1._id,
      timeline: {
        unofficialPOClientStatus: timeSheet.unofficialPOClientStatus || '',
        unofficialPOCandidateAcceptanceStatus: timeSheet.unofficialPOCandidateAcceptanceStatus || '',

        writtenOfferClientStatus: timeSheet.writtenOfferClientStatus || '',
        writtenOfferCandidateAcceptanceStatus: timeSheet.writtenOfferCandidateAcceptanceStatus || '',

        backgroundChecksOverallStatus: timeSheet.backgroundChecksOverallStatus || '',

        employmentCheckStatus: timeSheet.employmentCheckStatus || '',
        securityCheckStatus: timeSheet.securityCheckStatus || '',
        workVisaIdCheckStatus: timeSheet.workVisaIdCheckStatus || '',
        drugTestStatus: timeSheet.drugTestStatus || '',
        creditCheckStatus: timeSheet.creditCheckStatus || '',
        educationBackgroundCheckStatus: timeSheet.educationBackgroundCheckStatus || '',
        securityClearanceStatus: timeSheet.securityClearanceStatus || '',
        referencesCheckStatus: timeSheet.referencesCheckStatus || '',

        otherBackgroundCheckName: '',
        otherBackgroundCheckStatus: '',

        backgroundCheckClientAcceptanceStatus: timeSheet.backgroundCheckClientAcceptanceStatus || '',
        finalSOWStatus: timeSheet.finalSOWStatus || '',

        actualStartDateStatus: timeSheet.actualStartDateStatus || '',
        actualStartDate: timeSheet.actualStartDate || null,

        logisticsEquipmentStatus: timeSheet.logisticsEquipmentStatus || '',

        autoReminderEmailEnabled: timeSheet.autoReminderEmailEnabled || false,
        autoReminderEmailTemplateStatus: '',

        candidateStartStatus: timeSheet.candidateStartStatus || '',

        projectEnded: false,
        projectEndDate: null,

        // ---------- Retention / Process Check ----------

        firstDay: {
          type: timeSheet.firstDay.type, // candidate
          status: timeSheet.firstDay.status, // yes or pending
          addedBy: '',
          notes: timeSheet.firstDay.notes,
          feedback: '',
        },
        firstWeek: {
          type: timeSheet.firstWeek.type, // candidate
          status: timeSheet.firstWeek.status, // yes or pending
          addedBy: '',
          notes: timeSheet.firstWeek.notes,
          feedback: '',
        },
        firstMonth: {
          type: timeSheet.firstMonth.type, // candidate
          status: timeSheet.firstMonth.status, // yes or pending
          addedBy: '',
          notes: timeSheet.firstMonth.notes,
          feedback: 'Satisfied',
        },
        sixMonths: {
          type: timeSheet.sixMonths.type, // candidate
          status: timeSheet.sixMonths.status, // yes or pending
          addedBy: '',
          notes: timeSheet.sixMonths.notes,
          feedback: '',
        },
        firstYear: {
          type: timeSheet.firstYear.type, // candidate
          status: timeSheet.firstYear.status, // yes or pending
          addedBy: '',
          notes: timeSheet.firstYear.notes,
          feedback: '',
        },

        // ---------- Feedback & Surveys ----------

        feedbackClientStatus: timeSheet.feedbackClientStatus || '', // yes / no / pending
        clientResponseStatus: timeSheet.clientResponseStatus || '', // positive / negative
        feedbackClientSendSurvey: false, // true / false
        feedbackClientSurveyEmail: '',
        feedbackClientSurveyResultFile: '', // URL to file

        feedbackCandidateStatus: timeSheet.feedbackCandidateStatus || '', // yes / no / pending
        candidateResponseStatus: '', // positive / negative
        feedbackCandidateSendSurvey: false, // true / false
        feedbackCandidateSurveyEmail: '',
        feedbackCandidateSurveyResultFile: '',
      },
    };

    const token = localStorage.getItem('token');
    Api(`resume/editTimeline`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (true) {
            console.log('hello');
          } else {
            console.log('hello');
          }
        } else {
          console.log('helllo');
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
      });
  }

  const [isEditing, setIsEditing] = useState(false);

  const handleClose = () => {
    if (isEditing) {
      handleOpenDeleteModal();
      return;
    }
    closePlaceDetails();
  };

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleOpenDeleteModal = () => {
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const closeMultiModal = () => {
    closePlaceDetails();
    handleCloseDeleteModal();
  };

  const [tab1, setTab1] = useState({
    placementFrom: '',
    endClientName: '',
    fullName: '',
    domain: '',
    implementationPartner: '',
    recruitorTeamInfo: '',
    recruitorName: '',
    ManagingTeamInfo: '',
    lead: '',
    Manager: '',
    head: '',
    accountManagerOwnership: '',
    contactName: '',
    additionalEmail: '',
    email: '',
    endClientPhoneNumber: '',
    address: '',
    payrollTaxState: '',
    billingType: '',
    billingFrequency: '',
    billingIntruction: '',

    reportingManagerName: '',
    reportingManagerEmail: '',
    reportingManagerNumber: '',

    overTimeBillRate: '',
    tenureWorked: '',
    expenses: '',
    hoursPerDay: '',
    currency: '',
    perDiem: '',
    vendorName: '',
    vendorFee: '',
    comment: '',
    endReason: '',
    duration: '',
    country: localStorage.getItem('country'),
    status: '',
    salary: '',
    annualBonus: '',
    candidateId: '',
    placementStatus: '',
    // "startStatus":"",

    placementInfoBoX1: {} || '',
    projectInfoBox2: {} || '',
    projectInfoBox1: {} || '',
    voiceInfoBox3: {} || '',

    invoiceInformation: '',
    positionName: '',
    city: '',
    state: '',
    stateCode: '',
    employmentType: '',
    jobType: '',
    taxTerm: '',
    joiningBonus: '',
    relocationAssistance: '',
    additionals: '',
    billRate: '',
    payRate: '',
    overTimeExpence: '',
    candidateName: '',
    accountManager: '',
    startDate: '',
    endDate: '',
    placementTenture: '',
    guranttePeriod: '',
    notes: '',
    amount: '',
    feeType: '',
    projectType: '',
    percentage: '',
    chargeType: '',
    commisionDate: '',
    commisionAmount: '',
    id:''
  });

  const [currentKey, setCurrentKey] = useState('');
  const [currentValue, setCurrentValue] = useState('');

  const handleKeyInputChange = (e) => {
    // currentKey = e.target.value;
    // console.log("currentKey", currentKey)
    setCurrentKey(e.target.value);
  };

  const handleValueInputChangeValue = (e) => {
    // currentValue = e.target.value;
    setCurrentValue(e.target.value);
    // console.log("currentValue", currentValue)
  };

  const handleValueInputChange = (key, event) => {
    const { value } = event.target;

    setInputValues((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  };

  // console.log("inputValues", inputValues)

  // console.log("currentValue", currentValue)
  // console.log("currentKey", currentKey)

  const handleAddButtonClick = () => {
    if (currentKey && currentValue) {
      setTab1((prevState) => {
        const newPlacementInfoBoX1 = { ...prevState.placementInfoBoX1 };
        newPlacementInfoBoX1[currentKey] = currentValue;
        return {
          ...prevState,
          placementInfoBoX1: newPlacementInfoBoX1,
        };
      });
      // currentKey = '';
      // currentValue=""
    }
  };

  // console.log("currentKey", currentKey)
  // console.log("currentValue", currentValue)

  const handleRemoveButtonClick = (keyToRemove) => {
    setTab1((prevState) => {
      const newPlacementInfoBoX1 = { ...prevState.placementInfoBoX1 };
      delete newPlacementInfoBoX1[keyToRemove];
      return {
        ...prevState,
        placementInfoBoX1: newPlacementInfoBoX1,
      };
    });
  };

  //   let currentKey11 = '';
  // let currentValue11 = '';

  const [currentKey11, setCurrentKey11] = useState('');
  const [currentValue11, setCurrentValue11] = useState('');

  const handleKeyInputChange11 = (e) => {
    setCurrentKey11(e.target.value);
    // currentKey11 = e.target.value;
  };

  const handleValueInputChangeValue11 = (e) => {
    // currentValue11 = e.target.value;
    setCurrentValue11(e.target.value);
  };

  const handleValueInputChange11 = (key, event) => {
    const { value } = event.target;

    setInputValues11((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  };

  const handleAddButtonClick11 = () => {
    if (currentKey11 && currentValue11) {
      setTab1((prevState) => {
        const newProjectInfoBox1 = { ...prevState.projectInfoBox1 };
        newProjectInfoBox1[currentKey11] = currentValue11;
        return {
          ...prevState,
          projectInfoBox1: newProjectInfoBox1,
        };
      });
      // currentKey11 = '';
      // currentValue11=""
    }
  };

  const handleRemoveButtonClick11 = (keyToRemove11) => {
    setTab1((prevState) => {
      const newProjectInfoBox1 = { ...prevState.projectInfoBox1 };
      delete newProjectInfoBox1[keyToRemove11];
      return {
        ...prevState,
        projectInfoBox1: newProjectInfoBox1,
      };
    });
  };

  // let currentKey1 = '';
  // let currentValue1 = '';

  const [currentKey1, setCurrentKey1] = useState('');
  const [currentValue1, setCurrentValue1] = useState('');

  const handleKeyInputChange1 = (e) => {
    // currentKey1 = e.target.value;
    setCurrentKey1(e.target.value);
  };

  const handleValueInputChangeValue1 = (e) => {
    // currentValue1 = e.target.value;
    setCurrentValue1(e.target.value);
  };

  const handleValueInputChange1 = (key, event) => {
    const { value } = event.target;

    setInputValues1((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  };

  const handleAddButtonClick1 = () => {
    if (currentKey1 && currentValue1) {
      setTab1((prevState) => {
        const newProjectInfoBox2 = { ...prevState.projectInfoBox2 };
        newProjectInfoBox2[currentKey1] = currentValue1;
        return {
          ...prevState,
          projectInfoBox2: newProjectInfoBox2,
        };
      });
      // currentKey1 = '';
      // currentValue1 =""
    }
  };

  const handleRemoveButtonClick1 = (keyToRemove1) => {
    setTab1((prevState) => {
      const newProjectInfoBox2 = { ...prevState.projectInfoBox2 };
      delete newProjectInfoBox2[keyToRemove1];
      return {
        ...prevState,
        projectInfoBox2: newProjectInfoBox2,
      };
    });
  };

  // let currentKey2 = '';
  // let currentValue2 = '';

  const [currentKey2, setCurrentKey2] = useState('');
  const [currentValue2, setCurrentValue2] = useState('');

  const handleKeyInputChange2 = (e) => {
    // currentKey2 = e.target.value;
    setCurrentKey2(e.target.value);
  };

  const handleValueInputChangeValue2 = (e) => {
    // currentValue11 = e.target.value;
    setCurrentValue2(e.target.value);
  };

  const handleValueInputChange2 = (key, event) => {
    const { value } = event.target;

    setInputValues2((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  };

  const handleAddButtonClick2 = () => {
    if (currentKey2 && currentValue2) {
      setTab1((prevState) => {
        const newVoiceInfoBox3 = { ...prevState.voiceInfoBox3 };
        newVoiceInfoBox3[currentKey2] = currentValue2;
        return {
          ...prevState,
          voiceInfoBox3: newVoiceInfoBox3,
        };
      });
      // currentKey2 = '';
      // currentValue2 =""
    }
  };

  const handleRemoveButtonClick2 = (keyToRemove2) => {
    setTab1((prevState) => {
      const newVoiceInfoBox3 = { ...prevState.voiceInfoBox3 };
      delete newVoiceInfoBox3[keyToRemove2];
      return {
        ...prevState,
        voiceInfoBox3: newVoiceInfoBox3,
      };
    });
  };

  const addAdditionalKeys = () => {
    // console.log("currentKey", currentKey)
    // console.log("currentValue", currentValue)
    const body = {
      placementId: detailsId?.placementId,
      from: valuee === 'bench' ? 'bench' : 'recruitor',
      placementInfoBoX1: { [currentKey]: currentValue },
      projectInfoBox2: { [currentKey1]: currentValue1 },
      projectInfoBox1: { [currentKey11]: currentValue11 },
      voiceInfoBox3: { [currentKey2]: currentValue2 },
    };

    const token = localStorage.getItem('token');
    Api(`resume/addAdditionalField`, 'POST', body, token)
      .then((response) => {
        // console.log('==========response=====>>>', response);
        if (response.status === 200) {
          toast.success(response.data.resmessage);
          setCurrentKey('');
          setCurrentValue('');
          // if(valuee === "bench"){
          //   getBenchPlacement()
          // } else {
          //   fun()
          // }
          getPlacementDetails(detailsId);
        }
        // setCurrentValue('')
        //     setCurrentKey('')
      })
      .catch((err) => {});
  };

  const [cityy, setCityy] = useState('');
  const [value1, setValue1] = useState('');
  const [cityData, setcityData] = useState([]);
  const [cityandstate, setCityandstate] = useState('');

  const childFuc = (e) => {
    setCityy(e);
    if (e.length >= 3) {
      getCity(e);
    } else if (e.length === 0) {
      setCityy(e);
      setcityData([]);
      setCityandstate({});
    }
  };

  const [stateCode1, setStateCode1] = useState('');
  const fullVal = (val) => {
    // console.log(val);
    setStateCode1(val.stateCode);
    setCityandstate(val);
    setCityy(val.city);
    setValue1({ ...value1, zip: val?.zip || val?.postal });
  };

  const [err, setErr] = useState(false);
  const [helperText, setHelperText] = useState('');
  const getCity = async (val) => {
    setHelperText('');
    setErr(false);
    setcityData([]);
    const token = localStorage.getItem('token');
    const body = {
      country: tab1.country,
      query: val,
    };
    Api(`resume/get_city_states`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          // console.log('=========status 200======>>>>>>>', response);
          if (response.data.code === 200) {
            // console.log('city========', JSON.stringify(response.data));
            setcityData(response.data.data);
          } else {
            // toast.error(response.data.message)
            setHelperText('No cities found for the given city name.');
            setErr(true);
            // toast.error(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

  const [cityStateStyling, setCityStateStyling] = useState(false);

  const [loadingEdit, setLoadingEdit] = useState(false);

  const EditPlacement = () => {
    setLoadingEdit(true);
    const body = {
      // [valuee === "rec" ? "submissionId" : "benchId"]: valuee === "rec" ? placeDetails1?.submissionId : placeDetails1?.benchId,

      [valuee === 'rec' ? 'resumeId' : 'benchId']: valuee === 'rec' ? placeDetails1?.resumeId : placeDetails1?.benchId,
      placement_id: placeDetails1?._id,
      placementFrom: valuee === 'bench' ? 'bench' : 'recruitor',
      status: tab1?.status,
      // "status": "placement",
      // "placementInfoBoX1": tab1.placementInfoBoX1 || "",
      placementInfoBoX1: inputValues || {},
      // "projectInfoBox2": tab1.projectInfoBox2 || "",
      // "projectInfoBox1": tab1.projectInfoBox1 || "",
      // "voiceInfoBox3": tab1.voiceInfoBox3 || "",
      projectInfoBox2: inputValues1 || {},
      projectInfoBox1: inputValues11 || {},
      voiceInfoBox3: inputValues2 || {},
      reportingManagerName: tab1.reportingManagerName || '',
      reportingManagerEmail: tab1.reportingManagerEmail || '',
      reportingManagerNumber: tab1.reportingManagerNumber || '',

      // "startStatus": tab1?.startStatus,
      placementId: tab1.placementId,
      endClientName: tab1.endClientName || '',
      domain: tab1.domain || '',
      implementationPartner: tab1.implementationPartner || '',
      recruitorTeamInfo: tab1.recruitorTeamInfo || '',
      recruitorName: tab1.recruitorName || '',
      ManagingTeamInfo: tab1.ManagingTeamInfo || '',
      lead: tab1.lead || '',
      Manager: tab1.Manager || '',
      head: tab1.head || '',
      accountManagerOwnership: tab1.accountManagerOwnership || '',
      contactName: tab1.contactName || '',
      additionalEmail: tab1.additionalEmail || '',
      email: tab1.email || '',
      endClientPhoneNumber: tab1.endClientPhoneNumber || '',
      address: tab1.address || '',
      payrollTaxState: tab1.payrollTaxState || '',
      billingType: tab1.billingType || '',
      billingFrequency: tab1.billingFrequency || '',
      billingIntruction: tab1.billingIntruction || '',
      overTimeBillRate: tab1.overTimeBillRate || '',
      tenureWorked: tab1.tenureWorked || '',
      expenses: tab1.expenses || '',
      hoursPerDay: tab1.hoursPerDay || '',
      currency: tab1.currency || '',
      perDiem: tab1.perDiem || '',
      vendorName: tab1.vendorName || '',
      vendorFee: tab1.vendorFee || '',
      comment: tab1.comment || '',
      endReason: tab1.endReason || '',
      duration: tab1.duration || '',
      // "placementInfoBoX1": tab1.placementInfoBoX1 || '',
      // "projectInfoBox2": tab1.projectInfoBox2 || '',
      // "projectInfoBox1": tab1.projectInfoBox1 || '',
      // "voiceInfoBox3": tab1.voiceInfoBox3 || '',
      invoiceInformation: tab1.invoiceInformation || '',
      positionName: tab1.positionName || '',
      // "city": cityy || "",
      // "state": cityandstate?.state || "",
      // "stateCode": stateCode1,
      clientCity: cityy || '',
      clientState: cityandstate?.state || '',
      clientStateCode: stateCode1,

      clientCountry: tab1?.country,
      employmentType: tab1.employmentType || '',
      jobType: tab1.jobType || '',
      taxTerm: tab1.taxTerm || '',
      joiningBonus: tab1.joiningBonus || '',
      relocationAssistance: tab1.relocationAssistance || '',
      additionals: tab1.additionals || '',
      billRate: tab1.billRate || '',
      payRate: tab1.payRate || '',
      overTimeExpence: tab1.overTimeExpence || '',
      candidateName: tab1.candidateName || '',
      accountManager: tab1.accountManager || '',
      startDate: tab1.startDate || '',
      endDate: tab1.endDate || '',
      placementTenture: tab1.placementTenture || '',
      guranttePeriod: tab1.guranttePeriod || '',
      notes: tab1.notes || '',
      amount: tab1.amount || '',
      feeType: tab1.feeType || '',
      projectType: tab1.projectType || '',
      fullName: tab1?.fullName || '',
      // "status": tab1.status || "new",
      salary: tab1.annualSalary || '',
      annualBonus: tab1.annualBonus || '',
      candidateId: tab1.candidateId || '',
      placementStatus: tab1.placementStatus || '',
      submissionId: tab1?.submissionId,
      // "resumeId":tab1?.resumeId
      chargeType: tab1?.chargeType,
      commisionDate: tab1?.commisionDate,
      commisionAmount: tab1?.commisionAmount,
      _id:tab1?.id,
    };

    const token = localStorage.getItem('token');
    Api(`resume/editPlacement`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          // console.log("response.data", response.data.result)
          toast.success(response.data.resmessage);
          if (valuee === 'bench') {
            getBenchPlacement();
          } else {
            fun();
            // placeDetails1.candidateName = tab1.candidateName;

            // data.candidateName = tab1.candidateName;
          }
          closePlaceDetails();
          setLoadingEdit(false);
        } else {
          // toast.warn(response.data.message, +'!');
          setLoadingEdit(false);
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  console.log('hell0=====>>>>', weeksData);

  const [openn, setOpenn] = useState(false);
  const [his, setHis] = useState([]);
  const handleOpenn = () => {
    setOpenn(true);
    // getHis();
  };

  const handleClosen = () => setOpenn(false);

  const getHis = (id) => {
    const body = {
      //  "bench_id":id,
      // "resume_id": id,
      // "from": valuee === "bench" ? "bench" : "recruitor",
      from: 'recruitor',
      placementId: data?.placementId,
    };
    const token = localStorage.getItem('token');
    Api(`resume/placementNotesDetail`, 'POST', body, token)
      .then((response) => {
        // console.log('==========get_history=====>>>', response);
        if (response.status === 200) {
          setHis(response.data.notesDetail);
          handleOpenn();
        }
      })
      .catch((err) => {});
  };

  const handleDateChange = (date, field) => {
    const formattedDate = dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
    setTab1((prevRec) => ({
      ...prevRec,
      [field]: formattedDate,
    }));
    // console.log("formattedDate====>>>>", formattedDate);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    p: 3,
    borderRadius: 2,
    boxShadow: 24,
  };

  const [open22, setOpen22] = useState(false);
  const [description1, setDescription] = useState('');
  const [amount1, setAmount] = useState('');

  // const [expenseList, setExpenseList] = useState([]);

  const [openExpenses, setOpenExpenses] = useState(false);



// ================= NEW STATES edit  =================
const [openEditExpense, setOpenEditExpense] = useState(false);

const [editDescription, setEditDescription] = useState('');
const [editAmount, setEditAmount] = useState('');

const [editExpenseId, setEditExpenseId] = useState('');
const [editPlacementId, setEditPlacementId] = useState('');

// ================= OPEN EDIT MODAL =================
const handleOpenEdit = (row) => {

  console.log("hello")
  setEditDescription(row?.description || '');
  setEditAmount(row?.amount || '');

  setEditExpenseId(row?._id);

  setEditPlacementId(
    valuee === 'rec' ? data?._id : data1?._id
  );

  setOpenEditExpense(true);
};

// ================= EDIT FUNCTION =================
const handleEditExpense = () => {
  if (!editDescription || editDescription.trim() === '') {
    toast.error('Please enter description');
    return;
  }

  if (!editAmount || editAmount.toString().trim() === '') {
    toast.error('Please enter amount');
    return;
  }

  if (Number.isNaN(Number(editAmount))) {
    toast.error('Amount must be a valid number');
    return;
  }

  const body = {
    placementId: editPlacementId,
    expenseId: editExpenseId,
    expense: {
      description: editDescription.trim(),
      amount: editAmount,
    },
  };

  const token = localStorage.getItem('token');

  Api(`resume/editExpense`, 'POST', body, token)
    .then((response) => {

      console.log("hello shyamlal sharma ji ", response)
      if (response.status === 200) {
        toast.success(response.data.message);

        setOpenEditExpense(false);

        setEditDescription('');
        setEditAmount('');

        if (valuee === 'rec') {
          setdataExpensive(response?.data?.data?.expensesList);
        } else {
          setdataExpensive2(response?.data?.data?.expensesList);
        }
      }
    })
    .catch((err) => {
      console.error('Edit expense error:', err);
      toast.error('Something went wrong!');
    });
};

// ================= DELETE FUNCTION =================
const handleDeleteExpense = (expenseId) => {
  const body = {
    placementId: valuee === 'rec' ? data?._id : data1?._id,
    "expenseId": expenseId,
  };

  const token = localStorage.getItem('token');

  Api(`resume/deleteExpense`, 'POST', body, token)
    .then((response) => {
       console.log("hello shyamlal sharma ji ", response)
      if (response.status === 200) {
        toast.success(response.data.message);

        if (valuee === 'rec') {
          setdataExpensive(response?.data?.data?.expensesList);
        } else {
          setdataExpensive2(response?.data?.data?.expensesList);
        }
      }
    })
    .catch((err) => {
      console.error('Delete expense error:', err);
      toast.error('Something went wrong!');
    });
};


  const handleOpenExpenses = () => {
    setOpen(false);
    setValue('placement');
    setOpenExpenses(true);
  };

  const handleCloseExpenses = () => {
    setOpenExpenses(false);
  };

  const [dataExpensive, setdataExpensive] = useState(data?.expensesList || []);
  const [dataExpensive2, setdataExpensive2] = useState(data1?.expensesList || []);

  const handleAdd = () => {
    // --- VALIDATION ---
    if (!description1 || description1.trim() === '') {
      toast.error('Please enter description');
      return;
    }

    if (!amount1 || amount1.trim() === '') {
      toast.error('Please enter amount');
      return;
    }
    if (Number.isNaN(Number(amount1.trim()))) {
      toast.error('Amount must be a valid number');
      return;
    }

    // --- BODY ---
    const body = {
      placementId: valuee === 'rec' ? data._id : data1._id,
      expense: {
        description: description1.trim(),
        amount: amount1.trim(),
      },
    };

    const token = localStorage.getItem('token');
    const newEntry = {
      description: description1.trim(),
      amount: amount1.trim(),
    };

    // const obj = {
    //   addedBy: localStorage.getItem('contactPersonName'),
    //   amount: amount1.trim(),
    //   dateAdded: new Date(),
    //   description: description1.trim(),
    // };
    //  {row.dateAdded}
    // <TableCell sx={{ textAlign: 'center' }}>{row.description}</TableCell>
    // <TableCell sx={{ textAlign: 'center' }}>{row.amount}</TableCell>
    // <TableCell sx={{ textAlign: 'center' }}>{row.addedBy}</TableCell>

    Api(`resume/addExpense`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          // setExpenseList([...expenseList, newEntry]);
          // toast.success(response.data.message);

          console.log("hello shyamlal sharma ji   ====>>>>", response)
          setDescription('');
          setAmount('');
          // setOpen(false);
          setOpen22(false); 

          if (valuee === 'rec') {
            // console.log('helllllloooo', [...dataExpensive, obj]);
            //  setdataExpensive([...dataExpensive, obj]);   
             setdataExpensive(response?.data?.data?.expensesList);   
          
          } else {
            // setdataExpensive2([...dataExpensive2, obj]);
              setdataExpensive2(response?.data?.data?.expensesList);  
          }
        } else {
          setOpen(false);

          // toast.error("hello")
        }
      })
      .catch((err) => {
        console.error('Add expense error:', err);
        toast.error('Something went wrong!');
      });
  };

  const getGrandTotals = (weeks) => {
    let workingMin = 0;
    let overtimeMin = 0;
    let totalMin = 0;

    weeks.forEach((week) => {
      week.days.forEach((d) => {
        if (d.approvalStatus === 'Approved') {
          workingMin += timeToMinutes(d.workingHours);
          overtimeMin += timeToMinutes(d.overtime);
          totalMin += timeToMinutes(d.totalHours);
        }
        // workingMin += timeToMinutes(d.workingHours);
        // overtimeMin += timeToMinutes(d.overtime);
        // totalMin += timeToMinutes(d.totalHours);
      });
    });

    return {
      working: minutesToTime(workingMin),
      overtime: minutesToTime(overtimeMin),
      total: minutesToTime(totalMin),
    };
  };

  const grandTotals = getGrandTotals(weeksData);
  console.log('hiiiiiiiiii======>>>>>>>>>>>', weeksData);

  return (
    <>
      {valuee === 'rec' ? (
        <TableRow
          key={data?._id}
          sx={[
            {
              background: index % 2 === 0 ? 'text.background' : tablebg,

              '&:last-child td, &:last-child th': { border: 0 },
              '&:hover': { boxShadow: 5 },
            },
          ]}
        >
          <TableCell sx={{}}>
            <Typography sx={{}}>
              Up -{' '}
              {data?.updatedAt
                ? `${new Date(data?.updatedAt)?.toLocaleString('en-US', optionsDate)} 
    ${String(new Date(data?.updatedAt)?.getHours())?.padStart(2, '0')}:${String(
                    new Date(data?.updatedAt)?.getMinutes()
                  )?.padStart(2, '0')}`
                : '  '}
            </Typography>

            <Typography sx={{}}>
              Cr -{' '}
              {`${new Date(data.createdAt)?.toLocaleString('en-US', optionsDate)} 
  ${String(new Date(data?.createdAt)?.getHours())?.padStart(2, '0')}:${String(
                new Date(data?.createdAt)?.getMinutes()
              )?.padStart(2, '0')}`}
            </Typography>
            <Stack sx={{ flexDirection: 'row' }}>
              <Typography
                sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => getPlacementDetails(data)}
              >
                Edit
              </Typography>
            </Stack>
          </TableCell>

          <TableCell sx={{}}>
            <Stack sx={{ flexDirection: 'row' }}>
              <Tooltip
                title={
                  data?.chargeType === 'Annually' && (!data.annualSalary || !data.commisionDate)
                    ? 'Please fill out Commission Date and Amount '
                    : ''
                }
              >
                <Typography
                  sx={{ fontWeight: 'bold', cursor: 'pointer' }}
                  color={'text.secondary'}
                  onClick={() => getPlacementDetails(data)}
                >
                  {data?.placementId ? data?.placementId : '-'}
                </Typography>
              </Tooltip>

              <CopyToClipboard text={data?.placementId} onCopy={() => setPhoneCopy(true)}>
                <Iconify
                  icon="radix-icons:copy"
                  color={phoneCopy ? 'text.secondary' : 'text.textG'}
                  sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                  hover
                />
              </CopyToClipboard>
            </Stack>
            <Typography>{data?.clientName ? data?.clientName : '-'}</Typography>
            <Typography>
              {data?.clientCity} , {data?.clientStateCode}
            </Typography>
          </TableCell>

          <TableCell sx={{}}>
            <Stack sx={{ flexDirection: 'row' }}>
              <Typography
                sx={{
                  cursor: 'pointer',
                  fontWeight: '600',
                  maxWidth: 160,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  color:
                    data?.status === 'project ended' || data?.status === 'Job Quit' || data?.status === 'terminated'
                      ? '#3C6BA5'
                      : '#2ECC71',
                }}
                onClick={() =>
                  navigate('/resumeDetail', {
                    state: {
                      // addedSkills,
                      row: data,
                      mtab: 'Resume',
                      "valuee": valuee,
                      fTab: valuee === 'rec' || 'bench' ? 'submitted' : '' || valuee === 'bench' ? 'submitted' : '',
                    },
                  })
                }
              >
                {data?.fullName ? data?.fullName : '-'}
              </Typography>
              <CopyToClipboard text={data?.fullName} onCopy={() => setPhoneCopy(true)}>
                <Iconify
                  icon="radix-icons:copy"
                  color={phoneCopy ? 'text.secondary' : 'text.textG'}
                  sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                  hover
                />
              </CopyToClipboard>
            </Stack>
            <Typography>{data?.positionName ? data?.positionName : '-'}</Typography>
            <Typography>{data?.employmentType ? data?.employmentType : '-'}</Typography>
          </TableCell>

          <TableCell sx={{ py: 0, width: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            <Typography sx={{}}>{data?.jobType ? data?.jobType : '-'}</Typography>
            <Typography sx={{}}>
              {data?.chargeType === 'hourly' ? (
                <>
                  {localStorage.getItem('country') === 'INDIA'
                    ? '₹'
                    : localStorage.getItem('country') === 'UK'
                    ? '£'
                    : '$'}
                  {data?.billRate || '-'} /Hour
                  {/* {data?.chargeType && data?.chargeType !== "" && data?.chargeType === 'hourly' ? '/Hour' : 'K'} */}
                </>
              ) : (
                <>
                  {localStorage.getItem('country') === 'INDIA'
                    ? '₹'
                    : localStorage.getItem('country') === 'UK'
                    ? '£'
                    : '$'}
                  {data?.annualSalary || '-'} {localStorage.getItem('country') === 'INDIA' ? 'Lac' : 'k'}
                  {/* { data?.chargeType && data?.chargeType !== "" && data?.chargeType === 'hourly' ? '/Hour' : 'K'} */}
                </>
              )}
            </Typography>

            <Typography sx={{ textTransform: 'capitalize' }} color={'text.textG'}>
              {data?.taxTerm ? data?.taxTerm : '-'}
            </Typography>
          </TableCell>

          <TableCell sx={{}}>
            <Typography sx={{}}>{data?.accountManager ? data?.accountManager : '-'}</Typography>
            <Typography>
              {data?.projectType === 'msp'
                ? 'MSP'
                : data?.projectType === 'directclient'
                ? 'Direct Client'
                : data?.projectType === 'thirdpartystaffing'
                ? 'Third Party Staffing'
                : '-'}
            </Typography>

            <Typography>{data?.domain ? data?.domain : '-'}</Typography>
          </TableCell>
          <TableCell sx={{}}>
            <Typography sx={{}}>
              Std - {data?.startDate ? `${new Date(data?.startDate).toLocaleString('en-US', optionsDate)}` : '  '}
            </Typography>
            <Typography sx={{}}>
              End - {data?.endDate ? `${new Date(data?.endDate).toLocaleString('en-US', optionsDate)}` : '  '}
            </Typography>
            <Stack sx={{ flexDirection: 'row' }}>
              <Typography
                sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => getHis(data.resumeId)}
              >
                Notes
              </Typography>
            </Stack>
          </TableCell>

          <TableCell sx={{}}>
            <Typography sx={{}}>
              <Typography>{data?.status}</Typography>
            </Typography>
            <Typography>G.P. : {data?.guranttePeriod ? data?.guranttePeriod : '-'}</Typography>
            <Typography> {data?.recruitorName ? data?.recruitorName : '-'}</Typography>
          </TableCell>

          <TableCell sx={{}}>
            <Typography
              sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => handleOpenEmail(valuee, data._id, data.fullName, data.reportingManagerEmail, 'client')}
            >
              Invoice
            </Typography>

            <Typography
              sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => handleOpenEmail(valuee, data._id, data.fullName, data.email, 'candidate')}
            >
              Payment
            </Typography>
            {/* <Typography>{data?.feeType ? data?.feeType : "-"}</Typography> */}
            <Typography>{data?.amount ? data?.amount : '-'}</Typography>
          </TableCell>
        </TableRow>
      ) : (
        <TableRow
          key={data1?._id}
          sx={[
            {
              background: index % 2 === 0 ? 'text.background' : tablebg,
              '&:last-child td, &:last-child th': { border: 0 },
              '&:hover': { boxShadow: 5 },
            },
          ]}
        >
          <TableCell sx={{}}>
            <Typography sx={{}}>
              Up -{' '}
              {data1?.updatedAt
                ? `${new Date(data1?.updatedAt).toLocaleString('en-US', optionsDate)} 
      ${String(new Date(data1?.updatedAt).getHours()).padStart(2, '0')}:${String(
                    new Date(data1?.updatedAt).getMinutes()
                  ).padStart(2, '0')}`
                : '  '}
            </Typography>

            <Typography sx={{}}>
              Cr -{' '}
              {`${new Date(data1?.createdAt).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(data1?.createdAt).getHours()).padStart(2, '0')}`}
              :{`${String(new Date(data1?.createdAt).getMinutes()).padStart(2, '0')}`}
            </Typography>
            <Stack sx={{ flexDirection: 'row' }}>
              <Typography
                sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => getPlacementDetails(data1)}
              >
                Edit
              </Typography>
            </Stack>
          </TableCell>

          <TableCell sx={{}}>
            <Stack sx={{ flexDirection: 'row' }}>
              {/* <Typography sx={{ fontWeight: "bold", cursor: "pointer" }} color={'text.secondary'}
                onClick={() => getPlacementDetails(data1)}>

                {data1?.placementId ? data1?.placementId : "-"}</Typography> */}

              {/* !data1.annualSalary && !data1.commisionDate */}
              <Tooltip
                title={
                  data1?.chargeType === 'Annually' && (!data1?.annualSalary || !data1?.commisionDate)
                    ? 'Please fill out Commission Date and Amount '
                    : ''
                }
              >
                <Typography
                  sx={{ fontWeight: 'bold', cursor: 'pointer' }}
                  color={'text.secondary'}
                  onClick={() => getPlacementDetails(data1)}
                >
                  {data1?.placementId ? data1?.placementId : '-'}
                </Typography>
              </Tooltip>
              <CopyToClipboard text={data1?.placementId} onCopy={() => setPhoneCopy(true)}>
                <Iconify
                  icon="radix-icons:copy"
                  color={phoneCopy ? 'text.secondary' : 'text.textG'}
                  sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                  hover
                />
              </CopyToClipboard>
            </Stack>
            <Typography>{data1?.clientName ? data1?.clientName : '-'}</Typography>
            <Typography>
              {data1?.clientCity || data1?.clientCity} , {data1?.clientStateCode}
            </Typography>
          </TableCell>

          <TableCell sx={{}}>
            <Stack sx={{ flexDirection: 'row' }}>
              <Typography
                sx={{
                  cursor: 'pointer',
                  fontWeight: '600',
                  maxWidth: 160,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  color:
                    data1?.status === 'project ended' || data1?.status === 'Job Quit' || data1?.status === 'terminated'
                      ? '#3C6BA5'
                      : '#2ECC71',
                }}
                onClick={() =>
                  navigate('/benchresumedetails', {
                    state: {
                      // addedSkills,
                      data1,
                      row: {
                        ...data1,
                        phone: data1.contactNo,
                      },
                      mtab: 'Resume',
                      "valuee": valuee,
                      fTab: valuee === 'rec' || 'bench' ? 'submitted' : '' || valuee === 'bench' ? 'submitted' : '',
                    },
                  })
                }
              >
                {data1?.fullName ? data1?.fullName : '-'}
              </Typography>

              <CopyToClipboard text={data1?.fullName} onCopy={() => setPhoneCopy(true)}>
                <Iconify
                  icon="radix-icons:copy"
                  color={phoneCopy ? 'text.secondary' : 'text.textG'}
                  sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                  hover
                />
              </CopyToClipboard>
            </Stack>
            <Typography>{data1?.positionName ? data1?.positionName : '-'}</Typography>
            <Typography>{data1?.employmentType ? data1?.employmentType : '-'}</Typography>
          </TableCell>

          <TableCell sx={{ py: 0, width: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            <Typography sx={{}}>{data1?.jobType ? data1?.jobType : '-'}</Typography>
            {/* <Typography sx={{}} >
              {
                data1?.billRate
                  ? (
                    <>
                      {data1.country === "INDIA" ? "₹" : data1.country === "UK" ? "£" : "$"}{data1?.billRate}
                      {data1?.chargeType && data1?.chargeType !== "" && data1?.chargeType === 'hourly' ? '/Hour' : 'K'}
                    </>
                  ) : ("-")
              }
            </Typography> */}

            <Typography sx={{}}>
              {data1?.chargeType === 'hourly' ? (
                <>
                  {localStorage.getItem('country') === 'INDIA'
                    ? '₹'
                    : localStorage.getItem('country') === 'UK'
                    ? '£'
                    : '$'}
                  {data1?.billRate || '-'} /Hour
                  {/* {data?.chargeType && data?.chargeType !== "" && data?.chargeType === 'hourly' ? '/Hour' : 'K'} */}
                </>
              ) : (
                <>
                  {localStorage.getItem('country') === 'INDIA'
                    ? '₹'
                    : localStorage.getItem('country') === 'UK'
                    ? '£'
                    : '$'}
                  {data1?.annualSalary || '-'} {localStorage.getItem('country') === 'INDIA' ? 'Lac' : 'k'}
                  {/* { data?.chargeType && data?.chargeType !== "" && data?.chargeType === 'hourly' ? '/Hour' : 'K'} */}
                </>
              )}
            </Typography>

            <Typography sx={{ textTransform: 'capitalize' }} color={'text.textG'}>
              {data1?.taxTerm ? data1?.taxTerm : '-'}
            </Typography>
          </TableCell>

          <TableCell sx={{}}>
            <Typography sx={{}}>{data1?.accountManager ? data1?.accountManager : '-'}</Typography>
            <Typography>
              {data1?.projectType === 'msp'
                ? 'MSP'
                : data1?.projectType === 'directclient'
                ? 'Direct Client'
                : data1?.projectType === 'thirdpartystaffing'
                ? 'Third Party Staffing'
                : '-'}
            </Typography>
            <Typography>{data1?.domain ? data1?.domain : '-'}</Typography>
          </TableCell>
          <TableCell sx={{}}>
            <Typography sx={{}}>
              Std - {data1?.startDate ? `${new Date(data1?.startDate).toLocaleString('en-US', optionsDate)}` : '  '}
            </Typography>
            <Typography sx={{}}>
              End - {data1?.endDate ? `${new Date(data1?.endDate).toLocaleString('en-US', optionsDate)}` : '  '}
            </Typography>
            <Stack sx={{ flexDirection: 'row' }}>
              <Typography
              // sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}

              // onClick={() => getHis(data1.resumeId)}
              >
                -{/* Notes */}
              </Typography>
            </Stack>
          </TableCell>

          <TableCell sx={{}}>
            <Typography>{data1?.status}</Typography>
            <Typography>G.P. : {data1?.guranttePeriod ? data1?.guranttePeriod : '-'}</Typography>
            <Typography> {data1?.recruitorName ? data1?.recruitorName : '-'}</Typography>
          </TableCell>

          <TableCell sx={{}}>
            <Typography
              sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => {
                handleOpenEmail(valuee, data1._id, data1.fullName, data1.reportingManagerEmail, 'client');
              }}
            >
              Invoice
            </Typography>

            <Typography
              sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => {
                handleOpenEmail(valuee, data1._id, data1.fullName, data1.email, 'candidate');
              }}
            >
              Payment
            </Typography>

            {/* <Typography>{data1?.feeType ? data1?.feeType : "-"}</Typography> */}
            <Typography>{data1?.amount ? data1?.amount : '-'}</Typography>
          </TableCell>
        </TableRow>
      )}

      <Modal open={open} onClose={handleClose} style={{ borderRadius: 10 }}>
        <Box sx={styleSkill}>
          <Typography variant="h6" color={'#3C6BA5'} textAlign={'center'} sx={{ mt: -1, ml: { xs: -2, sm: 0 } }}>
            Placement Detail
          </Typography>
          <Stack sx={{ width: '100%', alignItems: 'flex-end', mt: -3.8 }}>
            {edit === false ? (
              // <Iconify
              //   icon="bx:edit"
              //   sx={{ width: 25, height: 25, cursor: "pointer" }}
              //   onClick={() => editSource()}
              // />

              <Button color="custom" variant="contained" sx={{}} onClick={() => editSource()} disabled={loadingEdit}>
                {/* Edit */}
                {loadingEdit ? <CircularProgress size={21} /> : 'Edit'}
              </Button>
            ) : (
              // <Iconify
              //   icon="carbon:save"
              //   sx={{ color: 'text.secondary', width: 25, height: 25, cursor: "pointer" }}
              //   onClick={() => editSource()}
              // />
              <Button color="custom" variant="contained" sx={{}} onClick={() => editSource()}>
                Save
              </Button>
            )}
          </Stack>
          {/* <Divider sx={{ mt: 1, mb: 1 }} /> */}

          {/* <Stack flexDirection={'row'} justifyContent={'space-between'} mb={1} mt={3}>

            <Stack sx={{ flexDirection: 'row', gap: 2, cursor: 'pointer', alignItems: 'center' }}>

              <Stack
                sx={[
                  { flexDirection: 'row', ml: 1, alignItems: 'center' },
                  value === 'placement' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('placement')}
              >
                <Iconify sx={{ mr: 0.6 }}
                  icon="icon-park-outline:agreement"
                  // fontSize={10}
                  width="0.9rem"
                  color={value === 'placement' ? 'green' : 'text.textG'}
                />
                <Typography variant="tabs" color={value === 'placement' ? 'text.secondary' : 'text.textG'}>
                  Placement Information
                </Typography>
              </Stack>

              <Stack
                sx={[
                  { flexDirection: 'row', ml: 4, alignItems: 'center' },
                  value === 'project' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('project')}
              >
                <Iconify sx={{ mr: 0.5 }}
                  icon="gridicons:multiple-users"
                  // fontSize={13}
                  width="1rem"
                  color={value === 'project' ? 'green' : 'text.textG'}
                />
                <Typography variant="tabs" color={value === 'project' ? 'text.secondary' : 'text.textG'} >
                  Project Information / Recruiting Team
                </Typography>
              </Stack>

              <Stack
                sx={[
                  { flexDirection: 'row', ml: 4, alignItems: 'center' },
                  value === 'invoice' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('invoice')}
              >
                <Iconify sx={{ mr: 0.5 }}
                  icon="hugeicons:invoice-03"
                  // fontSize={13}
                  width="0.9rem"

                  color={value === 'invoice' ? 'green' : 'text.textG'}
                />
                <Typography variant="tabs" color={value === 'invoice' ? 'text.secondary' : 'text.textG'} >
                  Invoicing Details
                </Typography>
              </Stack>

            </Stack>

          </Stack> */}

          <Stack flexDirection="row" justifyContent="space-between" mb={1} mt={3}>
            <Stack sx={{ flexDirection: 'row', gap: 2, cursor: 'pointer', alignItems: 'center' }}>
              <Stack
                sx={[
                  { flexDirection: 'row', ml: 1, alignItems: 'center' },
                  value === 'PlacementTimeLine'
                    ? { borderBottom: 3, color: 'text.secondary' }
                    : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('PlacementTimeLine')}
              >
                <Iconify
                  sx={{ mr: 0.6 }}
                  icon="icon-park-outline:agreement"
                  width="0.9rem"
                  color={value === 'PlacementTimeLine' ? 'green' : 'text.textG'}
                />
                <Typography
                  variant="tabs"
                  color={value === 'PlacementTimeLine' ? 'text.secondary' : 'text.textG'}
                  sx={{ display: { xs: 'none', sm: 'block' } }}
                >
                  Placement TimeLine
                </Typography>
              </Stack>

              <Stack
                sx={[
                  { flexDirection: 'row', ml: 1, alignItems: 'center' },
                  value === 'Documents' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('Documents')}
              >
                <Iconify
                  sx={{ mr: 0.6 }}
                  icon="icon-park-outline:agreement"
                  width="0.9rem"
                  color={value === 'Documents' ? 'green' : 'text.textG'}
                />
                <Typography
                  variant="tabs"
                  color={value === 'Documents' ? 'text.secondary' : 'text.textG'}
                  sx={{ display: { xs: 'none', sm: 'block' } }}
                >
                  Documents
                </Typography>
              </Stack>

              <Stack
                sx={[
                  { flexDirection: 'row', ml: 1, alignItems: 'center' },
                  value === 'placement' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('placement')}
              >
                <Iconify
                  sx={{ mr: 0.6 }}
                  icon="icon-park-outline:agreement"
                  width="0.9rem"
                  color={value === 'placement' ? 'green' : 'text.textG'}
                />
                <Typography
                  variant="tabs"
                  color={value === 'placement' ? 'text.secondary' : 'text.textG'}
                  sx={{ display: { xs: 'none', sm: 'block' } }}
                >
                  Placement Information
                </Typography>
              </Stack>

              <Stack
                sx={[
                  { flexDirection: 'row', ml: 4, alignItems: 'center' },
                  value === 'project' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('project')}
              >
                <Iconify
                  sx={{ mr: 0.5 }}
                  icon="gridicons:multiple-users"
                  width="1rem"
                  color={value === 'project' ? 'green' : 'text.textG'}
                />
                <Typography
                  variant="tabs"
                  color={value === 'project' ? 'text.secondary' : 'text.textG'}
                  sx={{ display: { xs: 'none', sm: 'block' } }}
                >
                  Project Information / Recruiting Team
                </Typography>
              </Stack>

              <Stack
                sx={[
                  { flexDirection: 'row', ml: 4, alignItems: 'center' },
                  value === 'invoice' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('invoice')}
              >
                <Iconify
                  sx={{ mr: 0.5 }}
                  icon="hugeicons:invoice-03"
                  width="0.9rem"
                  color={value === 'invoice' ? 'green' : 'text.textG'}
                />
                <Typography
                  variant="tabs"
                  color={value === 'invoice' ? 'text.secondary' : 'text.textG'}
                  sx={{ display: { xs: 'none', sm: 'block' } }}
                >
                  Invoicing Details
                </Typography>
              </Stack>
              <Stack
                sx={[
                  { flexDirection: 'row', ml: 1, alignItems: 'center' },
                  value === 'Expenses' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
                ]}
                onClick={() => handleTabPlace('Expenses')}
              >
                <Iconify
                  sx={{ mr: 0.6 }}
                  icon="icon-park-outline:agreement"
                  width="0.9rem"
                  color={value === 'Expenses' ? 'green' : 'text.textG'}
                />
                <Typography
                  variant="tabs"
                  color={value === 'Expenses' ? 'text.secondary' : 'text.textG'}
                  sx={{ display: { xs: 'none', sm: 'block' } }}
                >
                  Expenses
                </Typography>
              </Stack>
            </Stack>
          </Stack>
          <Divider sx={{ mt: 1 }} />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            {/* {loading !== "" && (
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>{loading}</Typography>
        </Stack>
      )} */}
            {value === 'PlacementTimeLine' ? (
              <>
                <Stack container sx={{ gap: 2, flexDirection: 'row', width: '100%' }}>
                  <Stack sx={{ backgroundColor: 'text.background', borderRadius: 3, width: '100%' }}>
                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Unofficial Po (Client Side)
                        </Typography>
                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet.unofficialPOClientStatus}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  unofficialPOClientStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>
                              <MenuItem value="yes">Yes</MenuItem>
                              <MenuItem value="no">No</MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.unofficialPOClientStatus === 'yes' && (
                              <Iconify icon="teenyicons:tick-solid" width={22} height={22} color="green" />
                            )}

                            {timeSheet?.unofficialPOClientStatus === 'no' && (
                              <Iconify icon="twemoji:cross-mark" width={22} height={22} />
                            )}

                            {!timeSheet?.unofficialPOClientStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Acceptance (Candidate)
                        </Typography>
                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet.unofficialPOCandidateAcceptanceStatus}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  unofficialPOCandidateAcceptanceStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>
                              <MenuItem value="yes">Yes</MenuItem>
                              <MenuItem value="no">No</MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.unofficialPOCandidateAcceptanceStatus === 'yes' && (
                              <Iconify icon="teenyicons:tick-solid" width={22} height={22} color="green" />
                            )}

                            {timeSheet?.unofficialPOCandidateAcceptanceStatus === 'no' && (
                              <Iconify icon="twemoji:cross-mark" width={22} height={22} />
                            )}

                            {!timeSheet?.unofficialPOCandidateAcceptanceStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Written Offer (Client Side)
                        </Typography>
                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.writtenOfferClientStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  writtenOfferClientStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="offer released">Offer Released</MenuItem>

                              <MenuItem value="offer cancelled">Offer Cancelled</MenuItem>

                              <MenuItem value="in process">In Process</MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.writtenOfferClientStatus === 'offer released' && (
                              <Iconify icon="teenyicons:tick-solid" width={22} height={22} color="green" />
                            )}

                            {timeSheet?.writtenOfferClientStatus === 'offer cancelled' && (
                              <Iconify icon="twemoji:cross-mark" width={22} height={22} />
                            )}

                            {timeSheet?.writtenOfferClientStatus === 'in process' && (
                              <Typography sx={{ color: 'text.secondary', fontWeight: 500 }}>In Process</Typography>
                            )}

                            {!timeSheet?.writtenOfferClientStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Acceptance (Candidate)
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.writtenOfferCandidateAcceptanceStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  writtenOfferCandidateAcceptanceStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="accepted">Accepted</MenuItem>

                              <MenuItem value="notAccepted">Not Accepted</MenuItem>

                              <MenuItem value="pending">Pending</MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {/* Accepted → Green Tick */}
                            {timeSheet?.writtenOfferCandidateAcceptanceStatus === 'accepted' && (
                              <Iconify icon="teenyicons:tick-solid" width={22} height={22} color="green" />
                            )}

                            {/* Not Accepted → Red Cross */}
                            {timeSheet?.writtenOfferCandidateAcceptanceStatus === 'notAccepted' && (
                              <Iconify icon="twemoji:cross-mark" width={22} height={22} />
                            )}

                            {/* Pending → Grey Text */}
                            {timeSheet?.writtenOfferCandidateAcceptanceStatus === 'pending' && (
                              <Typography sx={{ color: 'text.secondary', fontWeight: 500 }}>Pending</Typography>
                            )}

                            {/* Empty → Dash */}
                            {!timeSheet?.writtenOfferCandidateAcceptanceStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Background Checks
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.backgroundChecksOverallStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  backgroundChecksOverallStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="Completed">Completed</MenuItem>

                              <MenuItem value="failed">Failed</MenuItem>

                              <MenuItem value="inprocess">In process</MenuItem>

                              <MenuItem value="pending">Pending</MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {/* Accepted → Green Tick */}
                            {timeSheet?.backgroundChecksOverallStatus === 'Completed' && (
                              <Iconify icon="teenyicons:tick-solid" width={22} height={22} color="green" />
                            )}

                            {/* Not Accepted → Red Cross */}
                            {timeSheet?.backgroundChecksOverallStatus === 'failed' && (
                              <Iconify icon="twemoji:cross-mark" width={22} height={22} />
                            )}

                            {/* Pending → Grey Text */}
                            {timeSheet?.backgroundChecksOverallStatus === 'pending' && (
                              <Typography sx={{ color: 'text.secondary', fontWeight: 500 }}>Pending</Typography>
                            )}

                            {timeSheet?.backgroundChecksOverallStatus === 'inprocess' && (
                              <Typography sx={{ color: 'text.secondary', fontWeight: 500 }}>Inprocess</Typography>
                            )}

                            {/* Empty → Dash */}
                            {!timeSheet?.backgroundChecksOverallStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Employment Check
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              value={timeSheet?.employmentCheckStatus || ''}
                              displayEmpty
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  employmentCheckStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="completed">
                                <Typography sx={{ color: 'green', fontWeight: 500 }}>Completed</Typography>
                              </MenuItem>

                              <MenuItem value="in_process">
                                <Typography sx={{ color: 'orange', fontWeight: 500 }}>In Process</Typography>
                              </MenuItem>

                              <MenuItem value="failed">
                                <Typography sx={{ color: 'red', fontWeight: 500 }}>Failed</Typography>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.employmentCheckStatus === 'completed' && (
                              <Typography sx={{ color: 'green', fontWeight: 600 }}>Completed</Typography>
                            )}

                            {timeSheet?.employmentCheckStatus === 'in_process' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>In Process</Typography>
                            )}

                            {timeSheet?.employmentCheckStatus === 'failed' && (
                              <Typography sx={{ color: 'red', fontWeight: 600 }}>Failed</Typography>
                            )}

                            {!timeSheet?.employmentCheckStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Security Check
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.securityCheckStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  securityCheckStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="completed">
                                <Typography sx={{ color: 'green', fontWeight: 500 }}>Completed</Typography>
                              </MenuItem>

                              <MenuItem value="in_process">
                                <Typography sx={{ color: 'orange', fontWeight: 500 }}>In Process</Typography>
                              </MenuItem>

                              <MenuItem value="failed">
                                <Typography sx={{ color: 'red', fontWeight: 500 }}>Failed</Typography>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.securityCheckStatus === 'completed' && (
                              <Typography sx={{ color: 'green', fontWeight: 600 }}>Completed</Typography>
                            )}

                            {timeSheet?.securityCheckStatus === 'in_process' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>In Process</Typography>
                            )}

                            {timeSheet?.securityCheckStatus === 'failed' && (
                              <Typography sx={{ color: 'red', fontWeight: 600 }}>Failed</Typography>
                            )}

                            {!timeSheet?.securityCheckStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Work Visa /ID Check
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.workVisaIdCheckStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  workVisaIdCheckStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="completed">
                                <Typography sx={{ color: 'green', fontWeight: 500 }}>Completed</Typography>
                              </MenuItem>

                              <MenuItem value="in_process">
                                <Typography sx={{ color: 'orange', fontWeight: 500 }}>In Process</Typography>
                              </MenuItem>

                              <MenuItem value="failed">
                                <Typography sx={{ color: 'red', fontWeight: 500 }}>Failed</Typography>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.workVisaIdCheckStatus === 'completed' && (
                              <Typography sx={{ color: 'green', fontWeight: 600 }}>Completed</Typography>
                            )}

                            {timeSheet?.workVisaIdCheckStatus === 'in_process' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>In Process</Typography>
                            )}

                            {timeSheet?.workVisaIdCheckStatus === 'failed' && (
                              <Typography sx={{ color: 'red', fontWeight: 600 }}>Failed</Typography>
                            )}

                            {!timeSheet?.workVisaIdCheckStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Drug Test{' '}
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.drugTestStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  drugTestStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="completed">
                                <Typography sx={{ color: 'green', fontWeight: 500 }}>Completed</Typography>
                              </MenuItem>

                              <MenuItem value="in_process">
                                <Typography sx={{ color: 'orange', fontWeight: 500 }}>In Process</Typography>
                              </MenuItem>

                              <MenuItem value="failed">
                                <Typography sx={{ color: 'red', fontWeight: 500 }}>Failed</Typography>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.drugTestStatus === 'completed' && (
                              <Typography sx={{ color: 'green', fontWeight: 600 }}>Completed</Typography>
                            )}

                            {timeSheet?.drugTestStatus === 'in_process' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>In Process</Typography>
                            )}

                            {timeSheet?.drugTestStatus === 'failed' && (
                              <Typography sx={{ color: 'red', fontWeight: 600 }}>Failed</Typography>
                            )}

                            {!timeSheet?.drugTestStatus && <Typography sx={{ color: 'text.secondary' }}>—</Typography>}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Credit Check
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.creditCheckStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  creditCheckStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="completed">
                                <Typography sx={{ color: 'green', fontWeight: 500 }}>Completed</Typography>
                              </MenuItem>

                              <MenuItem value="in_process">
                                <Typography sx={{ color: 'orange', fontWeight: 500 }}>In Process</Typography>
                              </MenuItem>

                              <MenuItem value="failed">
                                <Typography sx={{ color: 'red', fontWeight: 500 }}>Failed</Typography>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.creditCheckStatus === 'completed' && (
                              <Typography sx={{ color: 'green', fontWeight: 600 }}>Completed</Typography>
                            )}

                            {timeSheet?.creditCheckStatus === 'in_process' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>In Process</Typography>
                            )}

                            {timeSheet?.creditCheckStatus === 'failed' && (
                              <Typography sx={{ color: 'red', fontWeight: 600 }}>Failed</Typography>
                            )}

                            {!timeSheet?.creditCheckStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 190, p: 1, whiteSpace: 'nowrap' }}>
                          Education Background Check
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.educationBackgroundCheckStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  educationBackgroundCheckStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="completed">
                                <Typography sx={{ color: 'green', fontWeight: 500 }}>Completed</Typography>
                              </MenuItem>

                              <MenuItem value="in_process">
                                <Typography sx={{ color: 'orange', fontWeight: 500 }}>In Process</Typography>
                              </MenuItem>

                              <MenuItem value="failed">
                                <Typography sx={{ color: 'red', fontWeight: 500 }}>Failed</Typography>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.educationBackgroundCheckStatus === 'completed' && (
                              <Typography sx={{ color: 'green', fontWeight: 600 }}>Completed</Typography>
                            )}

                            {timeSheet?.educationBackgroundCheckStatus === 'in_process' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>In Process</Typography>
                            )}

                            {timeSheet?.educationBackgroundCheckStatus === 'failed' && (
                              <Typography sx={{ color: 'red', fontWeight: 600 }}>Failed</Typography>
                            )}

                            {!timeSheet?.educationBackgroundCheckStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Security Clearance
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.securityClearanceStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  securityClearanceStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="completed">
                                <Typography sx={{ color: 'green', fontWeight: 500 }}>Completed</Typography>
                              </MenuItem>

                              <MenuItem value="in_process">
                                <Typography sx={{ color: 'orange', fontWeight: 500 }}>In Process</Typography>
                              </MenuItem>

                              <MenuItem value="failed">
                                <Typography sx={{ color: 'red', fontWeight: 500 }}>Failed</Typography>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.securityClearanceStatus === 'completed' && (
                              <Typography sx={{ color: 'green', fontWeight: 600 }}>Completed</Typography>
                            )}

                            {timeSheet?.securityClearanceStatus === 'in_process' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>In Process</Typography>
                            )}

                            {timeSheet?.securityClearanceStatus === 'failed' && (
                              <Typography sx={{ color: 'red', fontWeight: 600 }}>Failed</Typography>
                            )}

                            {!timeSheet?.securityClearanceStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          References Check
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.referencesCheckStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  referencesCheckStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="completed">
                                <Typography sx={{ color: 'green', fontWeight: 500 }}>Completed</Typography>
                              </MenuItem>

                              <MenuItem value="in_process">
                                <Typography sx={{ color: 'orange', fontWeight: 500 }}>In Process</Typography>
                              </MenuItem>

                              <MenuItem value="failed">
                                <Typography sx={{ color: 'red', fontWeight: 500 }}>Failed</Typography>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.referencesCheckStatus === 'completed' && (
                              <Typography sx={{ color: 'green', fontWeight: 600 }}>Completed</Typography>
                            )}

                            {timeSheet?.referencesCheckStatus === 'in_process' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>In Process</Typography>
                            )}

                            {timeSheet?.referencesCheckStatus === 'failed' && (
                              <Typography sx={{ color: 'red', fontWeight: 600 }}>Failed</Typography>
                            )}

                            {!timeSheet?.referencesCheckStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 300, p: 1, whiteSpace: 'nowrap' }}>
                          Background Check Acceptance From Client
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.backgroundCheckClientAcceptanceStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  backgroundCheckClientAcceptanceStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="completed">
                                <Typography sx={{ color: 'green', fontWeight: 500 }}>Completed</Typography>
                              </MenuItem>

                              <MenuItem value="panding">
                                <Typography sx={{ color: 'text.secondary', fontWeight: 500 }}>Pending</Typography>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.backgroundCheckClientAcceptanceStatus === 'completed' && (
                              <Typography sx={{ color: 'green', fontWeight: 600 }}>Completed</Typography>
                            )}

                            {timeSheet?.backgroundCheckClientAcceptanceStatus === 'panding' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>Pending</Typography>
                            )}

                            {!timeSheet?.backgroundCheckClientAcceptanceStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Final SOW
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.finalSOWStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  finalSOWStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="completed">
                                <Typography sx={{ color: 'green', fontWeight: 500 }}>Completed</Typography>
                              </MenuItem>

                              <MenuItem value="panding">
                                <Typography sx={{ color: 'text.secondary', fontWeight: 500 }}>Pending</Typography>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.finalSOWStatus === 'completed' && (
                              <Typography sx={{ color: 'green', fontWeight: 600 }}>Completed</Typography>
                            )}

                            {timeSheet?.finalSOWStatus === 'panding' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>Pending</Typography>
                            )}

                            {!timeSheet?.finalSOWStatus && <Typography sx={{ color: 'text.secondary' }}>—</Typography>}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Actual Start Date
                        </Typography>

                        {!placeEdit ? (
                          <>
                            <FormControl size="small" sx={{}}>
                              <Select
                                displayEmpty
                                value={timeSheet?.actualStartDateStatus || ''}
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    actualStartDateStatus: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value="" disabled>
                                  Select
                                </MenuItem>

                                <MenuItem value="Allotted">
                                  <Typography sx={{ color: 'green', fontWeight: 500 }}>
                                    Allotted (Actual Date)
                                  </Typography>
                                </MenuItem>

                                <MenuItem value="panding">
                                  <Typography sx={{ color: 'text.secondary', fontWeight: 500 }}>Pending</Typography>
                                </MenuItem>
                              </Select>
                            </FormControl>

                            {timeSheet.actualStartDateStatus === 'Allotted' && (
                              <TextField
                                size="small"
                                type="date"
                                displayEmpty
                                sx={{ marginLeft: 4 }}
                                value={timeSheet.actualStartDate || ''}
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    actualStartDate: e.target.value,
                                  })
                                }
                              />
                            )}
                          </>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.actualStartDateStatus === 'Allotted' && (
                              <Typography sx={{ color: 'green', fontWeight: 600, marginRight: 1.5 }}>
                                Allotted (Actual Date)
                              </Typography>
                            )}

                            {timeSheet?.actualStartDateStatus === 'panding' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>Pending</Typography>
                            )}
                            {timeSheet.actualStartDate && timeSheet.actualStartDateStatus === 'Allotted' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>
                                {timeSheet.actualStartDate}
                              </Typography>
                            )}

                            {!timeSheet?.actualStartDateStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 250, p: 1, whiteSpace: 'nowrap' }}>
                          Logistics / Equipments / Devices{' '}
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.logisticsEquipmentStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  logisticsEquipmentStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="received">
                                <Typography sx={{ color: 'green', fontWeight: 500 }}>Received</Typography>
                              </MenuItem>

                              <MenuItem value="panding">
                                <Typography sx={{ color: 'text.secondary', fontWeight: 500 }}>Pending</Typography>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.logisticsEquipmentStatus === 'received' && (
                              <Typography sx={{ color: 'green', fontWeight: 600 }}>Received</Typography>
                            )}

                            {timeSheet?.logisticsEquipmentStatus === 'panding' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>Pending</Typography>
                            )}

                            {!timeSheet?.logisticsEquipmentStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Candidate Started
                        </Typography>

                        {!placeEdit ? (
                          <FormControl sx={{ width: '100%' }}>
                            <Stack direction="row" alignItems="center" gap={1}>
                              {/* <Switch
            checked={Boolean(timeSheet?.autoReminderEmailEnabled)}
            onChange={(e) =>
              setTimeSheet({
                ...timeSheet,
                autoReminderEmailEnabled: e.target.checked, // true / false
              })
            }
          />  */}

                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={Boolean(timeSheet?.autoReminderEmailEnabled)}
                                    onChange={(e) =>
                                      setTimeSheet({
                                        ...timeSheet,
                                        autoReminderEmailEnabled: e.target.checked,
                                      })
                                    }
                                    inputProps={{ 'aria-label': 'automailer-switch' }}
                                  />
                                }
                                labelPlacement="start"
                                sx={{ m: 0, cursor: 'pointer' }}
                              />

                              <Typography sx={{ fontWeight: 500 }}>
                                {timeSheet?.autoReminderEmailEnabled ? 'On' : 'Off'}
                              </Typography>
                            </Stack>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.autoReminderEmailEnabled === true && (
                              <Typography sx={{ color: 'green', fontWeight: 600 }}>Done</Typography>
                            )}

                            {timeSheet?.autoReminderEmailEnabled === false && (
                              <Typography sx={{ color: 'text.secondary', fontWeight: 600 }}>Pending</Typography>
                            )}

                            {(timeSheet?.autoReminderEmailEnabled === undefined ||
                              timeSheet?.autoReminderEmailEnabled === null) && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'black', width: 170, p: 1, whiteSpace: 'nowrap' }}>
                          Candidate Started{' '}
                        </Typography>

                        {!placeEdit ? (
                          <FormControl size="small" sx={{ width: '100%' }}>
                            <Select
                              displayEmpty
                              value={timeSheet?.candidateStartStatus || ''}
                              onChange={(e) =>
                                setTimeSheet({
                                  ...timeSheet,
                                  candidateStartStatus: e.target.value,
                                })
                              }
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>

                              <MenuItem value="Started">
                                <Typography sx={{ color: 'green', fontWeight: 500 }}>Successfully Started</Typography>
                              </MenuItem>

                              <MenuItem value="backOut">
                                <Typography sx={{ color: 'text.secondary', fontWeight: 500 }}>
                                  Candidate Back Out
                                </Typography>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                            {timeSheet?.candidateStartStatus === 'Started' && (
                              <Typography sx={{ color: 'green', fontWeight: 600 }}>Successfully Started</Typography>
                            )}

                            {timeSheet?.candidateStartStatus === 'backOut' && (
                              <Typography sx={{ color: 'orange', fontWeight: 600 }}>Candidate Back Out</Typography>
                            )}

                            {!timeSheet?.candidateStartStatus && (
                              <Typography sx={{ color: 'text.secondary' }}>—</Typography>
                            )}
                          </Box>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'flex-start',
                          width: { xs: '100%', sm: '50%' }, //  SAME AS FIRST YEAR
                        }}
                      >
                        <Typography
                          fontWeight={500}
                          sx={{
                            color: 'black',
                            minWidth: 170,
                            p: 1,
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                          }}
                        >
                          First Day
                        </Typography>

                        {!placeEdit ? (
                          <Stack direction="row" spacing={1} alignItems="center" width="100%">
                            {/* Client / Candidate */}
                            <FormControl size="small" sx={{ minWidth: 160 }}>
                              <Select
                                value={timeSheet?.firstDay?.type || ''}
                                displayEmpty
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    firstDay: {
                                      type: e.target.value,
                                      status: '',
                                      notes: '',
                                    },
                                  })
                                }
                              >
                                <MenuItem value="" disabled>
                                  Select
                                </MenuItem>
                                <MenuItem value="client">Client</MenuItem>
                                <MenuItem value="candidate">Candidate</MenuItem>
                              </Select>
                            </FormControl>

                            {/* Yes / Pending */}
                            {timeSheet?.firstDay?.type === 'client' && (
                              <FormControl size="small" sx={{ minWidth: 120 }}>
                                <Select
                                  value={timeSheet?.firstDay?.status || ''}
                                  displayEmpty
                                  onChange={(e) =>
                                    setTimeSheet({
                                      ...timeSheet,
                                      firstDay: {
                                        ...timeSheet.firstDay,
                                        status: e.target.value,
                                        notes: '',
                                      },
                                    })
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select
                                  </MenuItem>
                                  <MenuItem value="yes">Yes</MenuItem>
                                  <MenuItem value="no">No</MenuItem>
                                </Select>
                              </FormControl>
                            )}

                            {timeSheet?.firstDay?.type === 'candidate' && (
                              <FormControl size="small" sx={{ minWidth: 120 }}>
                                <Select
                                  value={timeSheet?.firstDay?.status || ''}
                                  displayEmpty
                                  onChange={(e) =>
                                    setTimeSheet({
                                      ...timeSheet,
                                      firstDay: {
                                        ...timeSheet.firstDay,
                                        status: e.target.value,
                                        notes: '',
                                      },
                                    })
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select
                                  </MenuItem>
                                  <MenuItem value="yes">Yes</MenuItem>
                                  <MenuItem value="no">No</MenuItem>
                                </Select>
                              </FormControl>
                            )}

                            {/* Notes */}
                            {timeSheet?.firstDay?.status === 'yes' && (
                              <TextField
                                multiline
                                rows={2}
                                size="small"
                                placeholder="Enter notes"
                                sx={{ minWidth: 260 }}
                                value={timeSheet?.firstDay?.notes || ''}
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    firstDay: {
                                      ...timeSheet.firstDay,
                                      notes: e.target.value,
                                    },
                                  })
                                }
                              />
                            )}
                          </Stack>
                        ) : (
                          <Typography sx={{ p: 1, color: 'primary.main', fontWeight: 500 }}>
                            First Day ({timeSheet?.firstDay?.type})
                            {timeSheet?.firstDay?.status && ` – ${timeSheet.firstDay.status}`}
                            {timeSheet?.firstDay?.notes && ` : ${timeSheet.firstDay.notes}`}
                          </Typography>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'flex-start',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography
                          fontWeight={500}
                          sx={{
                            color: 'black',
                            minWidth: 170,
                            p: 1,
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                          }}
                        >
                          First Week
                        </Typography>

                        {!placeEdit ? (
                          <Stack direction="row" spacing={1} alignItems="center" width="100%">
                            {/* 1️ Client / Candidate */}
                            <FormControl size="small" sx={{ minWidth: 160 }}>
                              <Select
                                value={timeSheet?.firstWeek?.type || ''}
                                displayEmpty
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    firstWeek: {
                                      ...timeSheet.firstWeek,
                                      type: e.target.value,
                                      status: '',
                                      notes: '',
                                    },
                                  })
                                }
                              >
                                <MenuItem value="" disabled>
                                  Select
                                </MenuItem>
                                <MenuItem value="client">Client</MenuItem>
                                <MenuItem value="candidate">Candidate</MenuItem>
                              </Select>
                            </FormControl>

                            {/* 2️ Yes / No → only for Client */}
                            {timeSheet?.firstWeek?.type === 'client' && (
                              <FormControl size="small" sx={{ minWidth: 120 }}>
                                <Select
                                  value={timeSheet?.firstWeek?.status || ''}
                                  displayEmpty
                                  onChange={(e) =>
                                    setTimeSheet({
                                      ...timeSheet,
                                      firstWeek: {
                                        ...timeSheet.firstWeek,
                                        status: e.target.value,
                                        notes: '',
                                      },
                                    })
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select
                                  </MenuItem>
                                  <MenuItem value="yes">Yes</MenuItem>
                                  <MenuItem value="no">No</MenuItem>
                                </Select>
                              </FormControl>
                            )}

                            {timeSheet?.firstWeek?.type === 'candidate' && (
                              <FormControl size="small" sx={{ minWidth: 120 }}>
                                <Select
                                  value={timeSheet?.firstWeek?.status || ''}
                                  displayEmpty
                                  onChange={(e) =>
                                    setTimeSheet({
                                      ...timeSheet,
                                      firstWeek: {
                                        ...timeSheet.firstWeek,
                                        status: e.target.value,
                                        notes: '',
                                      },
                                    })
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select
                                  </MenuItem>
                                  <MenuItem value="yes">Yes</MenuItem>
                                  <MenuItem value="no">No</MenuItem>
                                </Select>
                              </FormControl>
                            )}

                            {/* 3️ TextArea → only when YES */}
                            {timeSheet?.firstWeek?.status === 'yes' && (
                              <TextField
                                multiline
                                rows={2}
                                size="small"
                                placeholder="Enter notes"
                                sx={{ minWidth: 260 }}
                                value={timeSheet?.firstWeek?.notes || ''}
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    firstWeek: {
                                      ...timeSheet.firstWeek,
                                      notes: e.target.value,
                                    },
                                  })
                                }
                              />
                            )}
                          </Stack>
                        ) : (
                          <Typography sx={{ p: 1, color: 'primary.main', fontWeight: 500 }}>
                            First Week ({timeSheet?.firstWeek?.type})
                            {timeSheet?.firstWeek?.status && ` – ${timeSheet.firstWeek.status}`}
                            {timeSheet?.firstWeek?.notes && ` : ${timeSheet.firstWeek.notes}`}
                          </Typography>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'flex-start',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography
                          fontWeight={500}
                          sx={{
                            color: 'black',
                            minWidth: 170,
                            p: 1,
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                          }}
                        >
                          First Month
                        </Typography>

                        {!placeEdit ? (
                          <Stack direction="row" spacing={1} alignItems="center" width="100%">
                            {/* Client / Candidate */}
                            <FormControl size="small" sx={{ minWidth: 160 }}>
                              <Select
                                value={timeSheet?.firstMonth?.type || ''}
                                displayEmpty
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    firstMonth: {
                                      ...timeSheet.firstMonth,
                                      type: e.target.value,
                                      status: '',
                                      notes: '',
                                    },
                                  })
                                }
                              >
                                <MenuItem value="" disabled>
                                  Select
                                </MenuItem>
                                <MenuItem value="client">Client</MenuItem>
                                <MenuItem value="candidate">Candidate</MenuItem>
                              </Select>
                            </FormControl>

                            {/* Yes / No */}
                            {timeSheet?.firstMonth?.type === 'client' && (
                              <FormControl size="small" sx={{ minWidth: 120 }}>
                                <Select
                                  value={timeSheet?.firstMonth?.status || ''}
                                  displayEmpty
                                  onChange={(e) =>
                                    setTimeSheet({
                                      ...timeSheet,
                                      firstMonth: {
                                        ...timeSheet.firstMonth,
                                        status: e.target.value,
                                        notes: '',
                                      },
                                    })
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select
                                  </MenuItem>
                                  <MenuItem value="yes">Yes</MenuItem>
                                  <MenuItem value="no">No</MenuItem>
                                </Select>
                              </FormControl>
                            )}

                            {timeSheet?.firstMonth?.type === 'candidate' && (
                              <FormControl size="small" sx={{ minWidth: 120 }}>
                                <Select
                                  value={timeSheet?.firstMonth?.status || ''}
                                  displayEmpty
                                  onChange={(e) =>
                                    setTimeSheet({
                                      ...timeSheet,
                                      firstMonth: {
                                        ...timeSheet.firstMonth,
                                        status: e.target.value,
                                        notes: '',
                                      },
                                    })
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select
                                  </MenuItem>
                                  <MenuItem value="yes">Yes</MenuItem>
                                  <MenuItem value="no">No</MenuItem>
                                </Select>
                              </FormControl>
                            )}

                            {/* Notes */}
                            {timeSheet?.firstMonth?.status === 'yes' && (
                              <TextField
                                multiline
                                rows={2}
                                size="small"
                                placeholder="Enter notes"
                                sx={{ minWidth: 260 }}
                                value={timeSheet?.firstMonth?.notes || ''}
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    firstMonth: {
                                      ...timeSheet.firstMonth,
                                      notes: e.target.value,
                                    },
                                  })
                                }
                              />
                            )}
                          </Stack>
                        ) : (
                          <Typography sx={{ p: 1, color: 'primary.main', fontWeight: 500 }}>
                            First Month ({timeSheet?.firstMonth?.type})
                            {timeSheet?.firstMonth?.status && ` – ${timeSheet.firstMonth.status}`}
                            {timeSheet?.firstMonth?.notes && ` : ${timeSheet.firstMonth.notes}`}
                          </Typography>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'flex-start',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography
                          fontWeight={500}
                          sx={{
                            color: 'black',
                            minWidth: 170,
                            p: 1,
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                          }}
                        >
                          Six Months
                        </Typography>

                        {!placeEdit ? (
                          <Stack direction="row" spacing={1} alignItems="center" width="100%">
                            {/* Client / Candidate */}
                            <FormControl size="small" sx={{ minWidth: 160 }}>
                              <Select
                                value={timeSheet?.sixMonths?.type || ''}
                                displayEmpty
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    sixMonths: {
                                      ...timeSheet.sixMonths,
                                      type: e.target.value,
                                      status: '',
                                      notes: '',
                                    },
                                  })
                                }
                              >
                                <MenuItem value="" disabled>
                                  Select
                                </MenuItem>
                                <MenuItem value="client">Client</MenuItem>
                                <MenuItem value="candidate">Candidate</MenuItem>
                              </Select>
                            </FormControl>

                            {/* Yes / No */}
                            {timeSheet?.sixMonths?.type === 'client' && (
                              <FormControl size="small" sx={{ minWidth: 120 }}>
                                <Select
                                  value={timeSheet?.sixMonths?.status || ''}
                                  displayEmpty
                                  onChange={(e) =>
                                    setTimeSheet({
                                      ...timeSheet,
                                      sixMonths: {
                                        ...timeSheet.sixMonths,
                                        status: e.target.value,
                                        notes: '',
                                      },
                                    })
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select
                                  </MenuItem>
                                  <MenuItem value="yes">Yes</MenuItem>
                                  <MenuItem value="no">No</MenuItem>
                                </Select>
                              </FormControl>
                            )}

                            {timeSheet?.sixMonths?.type === 'candidate' && (
                              <FormControl size="small" sx={{ minWidth: 120 }}>
                                <Select
                                  value={timeSheet?.sixMonths?.status || ''}
                                  displayEmpty
                                  onChange={(e) =>
                                    setTimeSheet({
                                      ...timeSheet,
                                      sixMonths: {
                                        ...timeSheet.sixMonths,
                                        status: e.target.value,
                                        notes: '',
                                      },
                                    })
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select
                                  </MenuItem>
                                  <MenuItem value="yes">Yes</MenuItem>
                                  <MenuItem value="no">No</MenuItem>
                                </Select>
                              </FormControl>
                            )}
                            {/* Notes */}
                            {timeSheet?.sixMonths?.status === 'yes' && (
                              <TextField
                                multiline
                                rows={2}
                                size="small"
                                placeholder="Enter notes"
                                sx={{ minWidth: 260 }}
                                value={timeSheet?.sixMonths?.notes || ''}
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    sixMonths: {
                                      ...timeSheet.sixMonths,
                                      notes: e.target.value,
                                    },
                                  })
                                }
                              />
                            )}
                          </Stack>
                        ) : (
                          <Typography sx={{ p: 1, color: 'primary.main', fontWeight: 500 }}>
                            Six Months ({timeSheet?.sixMonths?.type})
                            {timeSheet?.sixMonths?.status && ` – ${timeSheet.sixMonths.status}`}
                            {timeSheet?.sixMonths?.notes && ` : ${timeSheet.sixMonths.notes}`}
                          </Typography>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                        mt: 0.4,
                        mb: 0.3,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'flex-start',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography
                          fontWeight={500}
                          sx={{
                            color: 'black',
                            minWidth: 170,
                            p: 1,
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                          }}
                        >
                          First Year
                        </Typography>

                        {!placeEdit ? (
                          <Stack direction="row" spacing={1} alignItems="center" width="100%">
                            {/* Client / Candidate */}
                            <FormControl size="small" sx={{ minWidth: 160 }}>
                              <Select
                                value={timeSheet?.firstYear?.type || ''}
                                displayEmpty
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    firstYear: {
                                      ...timeSheet.firstYear,
                                      type: e.target.value,
                                      status: '',
                                      notes: '',
                                    },
                                  })
                                }
                              >
                                <MenuItem value="" disabled>
                                  Select
                                </MenuItem>
                                <MenuItem value="client">Client</MenuItem>
                                <MenuItem value="candidate">Candidate</MenuItem>
                              </Select>
                            </FormControl>

                            {/* Yes / No */}
                            {timeSheet?.firstYear?.type === 'client' && (
                              <FormControl size="small" sx={{ minWidth: 120 }}>
                                <Select
                                  value={timeSheet?.firstYear?.status || ''}
                                  displayEmpty
                                  onChange={(e) =>
                                    setTimeSheet({
                                      ...timeSheet,
                                      firstYear: {
                                        ...timeSheet.firstYear,
                                        status: e.target.value,
                                        notes: '',
                                      },
                                    })
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select
                                  </MenuItem>
                                  <MenuItem value="yes">Yes</MenuItem>
                                  <MenuItem value="no">No</MenuItem>
                                </Select>
                              </FormControl>
                            )}

                            {timeSheet?.firstYear?.type === 'candidate' && (
                              <FormControl size="small" sx={{ minWidth: 120 }}>
                                <Select
                                  value={timeSheet?.firstYear?.status || ''}
                                  displayEmpty
                                  onChange={(e) =>
                                    setTimeSheet({
                                      ...timeSheet,
                                      firstYear: {
                                        ...timeSheet.firstYear,
                                        status: e.target.value,
                                        notes: '',
                                      },
                                    })
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select
                                  </MenuItem>
                                  <MenuItem value="yes">Yes</MenuItem>
                                  <MenuItem value="no">No</MenuItem>
                                </Select>
                              </FormControl>
                            )}

                            {/* Notes */}
                            {timeSheet?.firstYear?.status === 'yes' && (
                              <TextField
                                multiline
                                rows={2}
                                size="small"
                                placeholder="Enter notes"
                                sx={{ minWidth: 260 }}
                                value={timeSheet?.firstYear?.notes || ''}
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    firstYear: {
                                      ...timeSheet.firstYear,
                                      notes: e.target.value,
                                    },
                                  })
                                }
                              />
                            )}
                          </Stack>
                        ) : (
                          <Typography sx={{ p: 1, color: 'primary.main', fontWeight: 500 }}>
                            First Year ({timeSheet?.firstYear?.type})
                            {timeSheet?.firstYear?.status && ` – ${timeSheet.firstYear.status}`}
                            {timeSheet?.firstYear?.notes && ` : ${timeSheet.firstYear.notes}`}
                          </Typography>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '75%' }, //  WIDTH BADHA DI
                        }}
                      >
                        {/* Label */}
                        <Typography
                          fontWeight={500}
                          sx={{
                            color: 'black',
                            minWidth: 170,
                            p: 1,
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                          }}
                        >
                          Client Feedback
                        </Typography>

                        {!placeEdit ? (
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            width="100%"
                            flexWrap="nowrap" //  WRAP OFF
                          >
                            {/* Yes / No / Pending */}
                            <FormControl size="small" sx={{ width: 160 }}>
                              <Select
                                value={timeSheet?.feedbackClientStatus || ''}
                                displayEmpty
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    feedbackClientStatus: e.target.value,
                                    clientResponseStatus: '',
                                    feedbackClientSurveyResultFile: '',
                                  })
                                }
                              >
                                <MenuItem value="" disabled>
                                  Select
                                </MenuItem>
                                <MenuItem value="yes">Yes</MenuItem>
                                <MenuItem value="no">No</MenuItem>
                                <MenuItem value="pending">Pending</MenuItem>
                              </Select>
                            </FormControl>

                            {/* Positive / Negative */}
                            {timeSheet?.feedbackClientStatus === 'yes' && (
                              <FormControl size="small" sx={{ width: 130 }}>
                                <Select
                                  value={timeSheet?.clientResponseStatus || ''}
                                  displayEmpty
                                  onChange={(e) =>
                                    setTimeSheet({
                                      ...timeSheet,
                                      clientResponseStatus: e.target.value,
                                      feedbackClientSurveyResultFile: '',
                                    })
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select
                                  </MenuItem>
                                  <MenuItem value="positive">Positive</MenuItem>
                                  <MenuItem value="negative">Negative</MenuItem>
                                </Select>
                              </FormControl>
                            )}

                            {/* Browse File */}
                            {timeSheet?.feedbackClientStatus === 'yes' && timeSheet?.clientResponseStatus && (
                              <Button
                                component="label"
                                variant="outlined"
                                size="small"
                                sx={{ ml: 5 }}
                                //  sx={{ width: 200 }} //  BUTTON WIDTH BADHAI
                              >
                                Browse File
                                <input
                                  hidden
                                  type="file"
                                  onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (file) {
                                      setTimeSheet({
                                        ...timeSheet,
                                        feedbackClientSurveyResultFile: file.name,
                                      });
                                    }
                                  }}
                                />
                              </Button>
                            )}
                          </Stack>
                        ) : (
                          <Typography sx={{ p: 1, color: 'primary.main', fontWeight: 500 }}>
                            Client Feedback ({timeSheet?.feedbackClientStatus})
                            {timeSheet?.clientResponseStatus && ` – ${timeSheet.clientResponseStatus}`}
                            {timeSheet?.feedbackClientSurveyResultFile &&
                              ` : ${timeSheet.feedbackClientSurveyResultFile}`}
                          </Typography>
                        )}
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        px: 1,
                        width: '100%',
                        gap: 2,
                      }}
                    >
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '75%' },
                        }}
                      >
                        {/* Label */}
                        <Typography
                          fontWeight={500}
                          sx={{
                            color: 'black',
                            minWidth: 170,
                            p: 1,
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                          }}
                        >
                          Candidate Feedback
                        </Typography>

                        {!placeEdit ? (
                          <Stack direction="row" spacing={1} alignItems="center" width="100%" flexWrap="nowrap">
                            {/* Yes / No / Pending */}
                            <FormControl size="small" sx={{ width: 160 }}>
                              <Select
                                value={timeSheet?.feedbackCandidateStatus || ''}
                                displayEmpty
                                onChange={(e) =>
                                  setTimeSheet({
                                    ...timeSheet,
                                    feedbackCandidateStatus: e.target.value,
                                    candidateResponseStatus: '',
                                    feedbackCandidateSurveyResultFile: '',
                                  })
                                }
                              >
                                <MenuItem value="" disabled>
                                  Select
                                </MenuItem>
                                <MenuItem value="yes">Yes</MenuItem>
                                <MenuItem value="no">No</MenuItem>
                                <MenuItem value="pending">Pending</MenuItem>
                              </Select>
                            </FormControl>

                            {/* Positive / Negative */}
                            {timeSheet?.feedbackCandidateStatus === 'yes' && (
                              <FormControl size="small" sx={{ width: 130 }}>
                                <Select
                                  value={timeSheet?.candidateResponseStatus || ''}
                                  displayEmpty
                                  onChange={(e) =>
                                    setTimeSheet({
                                      ...timeSheet,
                                      candidateResponseStatus: e.target.value,
                                      feedbackCandidateSurveyResultFile: '',
                                    })
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select
                                  </MenuItem>
                                  <MenuItem value="positive">Positive</MenuItem>
                                  <MenuItem value="negative">Negative</MenuItem>
                                </Select>
                              </FormControl>
                            )}

                            {/* Browse File */}
                            {timeSheet?.feedbackCandidateStatus === 'yes' && timeSheet?.candidateResponseStatus && (
                              <Button
                                component="label"
                                variant="outlined"
                                size="small"
                                //  sx={{ ml: 5, width: 150 }}
                              >
                                Browse File
                                <input
                                  hidden
                                  type="file"
                                  onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (file) {
                                      setTimeSheet({
                                        ...timeSheet,
                                        feedbackCandidateSurveyResultFile: file.name,
                                      });
                                    }
                                  }}
                                />
                              </Button>
                            )}
                          </Stack>
                        ) : (
                          <Typography sx={{ p: 1, color: 'primary.main', fontWeight: 500 }}>
                            Candidate Feedback ({timeSheet?.feedbackCandidateStatus})
                            {timeSheet?.candidateResponseStatus && ` – ${timeSheet.candidateResponseStatus}`}
                            {timeSheet?.feedbackCandidateSurveyResultFile &&
                              ` : ${timeSheet.feedbackCandidateSurveyResultFile}`}
                          </Typography>
                        )}
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              </>
            ) : value === 'Documents' ? (
              navigate('/DocumentManager', {
                state: {
                  id: data?._id || data1?._id,
                  type: valuee,
                },
              })
            ) : value === 'placement' ? (
              <Stack container sx={{ gap: 2, flexDirection: 'row', width: '100%' }}>
                <Stack sx={{ backgroundColor: 'text.background', borderRadius: 3, width: '100%' }}>
                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Placement ID
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.placementId}
                        </Typography>
                      ) : (
                        <TextField
                          disabled
                          size="small"
                          value={tab1?.placementId}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, placementId: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Status
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.status}
                        </Typography>
                      ) : (
                        <FormControl size="small" sx={{ width: '100%' }}>
                          <InputLabel>Status</InputLabel>
                          <Select
                            value={tab1?.status || ''}
                            label="Status"
                            onChange={(e) => setTab1({ ...tab1, status: e.target.value })}
                          >
                            {/* <MenuItem value="active">Active</MenuItem>
                              <MenuItem value="closed">Closed</MenuItem> */}

                            <MenuItem value="placement">Placement</MenuItem>
                            <MenuItem value="project ended">Project Ended</MenuItem>
                            <MenuItem value="Job Quit">Quit</MenuItem>
                            <MenuItem value="terminated">Terminated</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </Stack>
                  </Stack>

                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Candidate Name
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.fullName}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.fullName}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, fullName: e.target.value })}
                        />
                      )}
                    </Stack>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Candidate ID
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.candidateId}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.candidateId}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, candidateId: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        End Client Name
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.endClientName}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.endClientName}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, endClientName: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Position Name
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.positionName}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.positionName}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, positionName: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>

                  <Divider />
                  <Stack
                    sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2, mt: 0.4, mb: 0.3 }}
                  >
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Country
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.country}
                        </Typography>
                      ) : (
                        <FormControl size="small" sx={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-label">Country</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={tab1?.country}
                            label="Country"
                            onChange={(e) => setTab1({ ...tab1, country: e.target.value })}
                          >
                            {/* <MenuItem value="USA">USA</MenuItem>
                              <MenuItem value="CANADA">CANADA</MenuItem>
                               <MenuItem value={'INDIA'}>INDIA</MenuItem>; */}
                            {countries?.map((item) => (
                              <MenuItem key={item.id} value={item.country}>
                                {item.country}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Stack>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        City
                      </Typography>
                      {placeEdit ? (
                        // <Typography fontWeight={500} sx={{ p: 1 }}>{tab1?.city}</Typography>
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {cityy}
                        </Typography>
                      ) : (
                        <CustomCompleteWorksheets
                          placeholder={'City & Pincode'}
                          option={cityData}
                          propVal={cityy}
                          childFuc={childFuc}
                          fullVal={fullVal}
                          fetch={'state'}
                          cityStateStyling1={cityStateStyling}
                          err={err}
                          helperText={helperText}
                        />
                      )}
                    </Stack>
                  </Stack>
                  {/* <FormControl> */}
                  {cityandstate ? (
                    <Stack
                      sx={{
                        ml: '64%',
                        mb: 0.5,
                        flexDirection: 'row',
                      }}
                    >
                      <Typography color={'text.textG'} variant="body">
                        {cityandstate?.state}
                        {cityandstate?.state ? ',' : ''}
                      </Typography>
                      <Typography color={'text.textG'} variant="body" sx={{ ml: 1 }}>
                        {cityandstate?.stateCode || cityandstate?.zipCode || cityandstate?.zipcode}
                      </Typography>
                    </Stack>
                  ) : null}

                  {/* </FormControl> */}

                  <Divider sx={{ mb: 0.5 }} />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Job Type
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.jobType}
                        </Typography>
                      ) : (
                        <Select
                          size="small"
                          value={tab1?.jobType}
                          sx={{ width: '100%' }}
                          onChange={(e) => setTab1({ ...tab1, jobType: e.target.value })}
                        >
                          <MenuItem value="onsite">Onsite</MenuItem>
                          <MenuItem value="hybrid">Hybrid</MenuItem>
                          <MenuItem value="remote">Remote</MenuItem>
                        </Select>
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Tax Term
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.taxTerm}
                        </Typography>
                      ) : (
                        <Select
                          size="small"
                          disabled={localStorage.getItem('country') === 'INDIA'}
                          value={tab1?.taxTerm}
                          sx={{ width: '100%' }}
                          onChange={(e) => setTab1({ ...tab1, taxTerm: e.target.value })}
                        >
                          <MenuItem value="w2">W2</MenuItem>
                          <MenuItem value="1099">1099</MenuItem>
                          <MenuItem value="cth">CTH</MenuItem>
                        </Select>
                      )}
                    </Stack>
                  </Stack>

                  <Divider sx={{ mt: 0.5 }} />

                  {tab1.chargeType === 'Annually' && (
                    <>
                      <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                        <Stack
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            width: { xs: '100%', sm: '50%' },
                          }}
                        >
                          <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                            Salary / Rate
                          </Typography>
                          {placeEdit ? (
                            placeDetails1?.annualSalary && (
                              <>
                                {/* {placeDetails1?.country ===  "INDIA" ? "₹" :"$"} */}
                                {/* {placeDetails1?.country === "INDIA" ? "₹" : placeDetails1?.country === "UK" ? "£" : "$"} */}
                                {localStorage.getItem('country') === 'INDIA'
                                  ? '₹'
                                  : localStorage.getItem('country') === 'UK'
                                  ? '£'
                                  : '$'}
                                {placeDetails1?.annualSalary}
                                {placeDetails1?.chargeType &&
                                placeDetails1?.chargeType !== '' &&
                                placeDetails1?.chargeType === 'hourly'
                                  ? '/Hour'
                                  : localStorage.getItem('country') === 'INDIA'
                                  ? 'Lac'
                                  : 'K'}
                              </>
                            )
                          ) : (
                            <TextField
                              size="small"
                              value={tab1?.annualSalary}
                              sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                              InputProps={{
                                // startAdornment: <InputAdornment position="start" sx={{ color: "black" }}> {placeDetails1?.country === "INDIA" ? "₹" : placeDetails1?.country === "UK" ? "£" : "$"}</InputAdornment>,
                                startAdornment: (
                                  <InputAdornment position="start" sx={{ color: 'black' }}>
                                    {localStorage.getItem('country') === 'INDIA'
                                      ? '₹'
                                      : localStorage.getItem('country') === 'UK'
                                      ? '£'
                                      : '$'}
                                  </InputAdornment>
                                ),
                                // endAdornment: <InputAdornment position="end" sx={{ color: "black" }}>
                                //   <FormControl variant="standard" size="small">
                                //     <Select
                                //       value={tab1.chargeType}
                                //       onChange={(e) => setTab1({ ...tab1, chargeType: e.target.value })}
                                //       sx={{ color: 'black', width: '70px' }}
                                //     >
                                //       <MenuItem value="hourly">P/h</MenuItem>
                                //       <MenuItem value="Annually">K</MenuItem>
                                //       <MenuItem value="Annually">  {tab1?.country === "INDIA" ? "Lac" : "K"}</MenuItem>
                                //     </Select>
                                //   </FormControl>
                                // </InputAdornment>,
                                endAdornment: (
                                  <InputAdornment position="end" sx={{ color: 'black' }}>
                                    {localStorage.getItem('country') === 'INDIA' ? 'Lac' : 'K'}
                                  </InputAdornment>
                                ),
                              }}
                              onChange={(e) => setTab1({ ...tab1, annualSalary: e.target.value })}
                            />
                          )}
                        </Stack>

                        {/* <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: { xs: '100%', sm: '50%' } }}>
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>Pay Rate</Typography>
                        {placeEdit ? (
                          <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>{tab1?.payRate}</Typography>
                        ) : (
                          <TextField
                            size="small"
                            value={tab1?.payRate}
                            sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                            onChange={(e) => setTab1({ ...tab1, payRate: e.target.value })}
                          />
                        )}
                      </Stack> */}

                        <Stack
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            width: { xs: '100%', sm: '50%' },
                          }}
                        >
                          <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                            {' '}
                            Commision Date
                          </Typography>
                          {placeEdit ? (
                            <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                              {tab1?.commisionDate
                                ? new Date(tab1.commisionDate).toLocaleString('en-US', optionsDate)
                                : ''}
                            </Typography>
                          ) : (
                            <FormControl fullWidth size="small" sx={{ width: '100%' }}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="Date"
                                  slotProps={{
                                    textField: {
                                      size: 'small',
                                      sx: { width: '100%', background: 'text.background' },
                                    },
                                  }}
                                  value={tab1.commisionDate ? dayjs(tab1.commisionDate) : null}
                                  onChange={(date) => handleDateChange(date, 'commisionDate')}
                                />
                              </LocalizationProvider>
                            </FormControl>
                          )}
                        </Stack>
                      </Stack>
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '98%', sm: '49%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                          Commision Amount
                        </Typography>
                        {placeEdit ? (
                          <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                            {tab1?.commisionAmount}
                          </Typography>
                        ) : (
                          <TextField
                            size="small"
                            value={tab1?.commisionAmount}
                            sx={{ py: 0.5, width: '90%', background: 'text.background' }}
                            onChange={(e) => setTab1({ ...tab1, commisionAmount: e.target.value })}
                          />
                        )}
                      </Stack>
                    </>
                  )}

                  {tab1.chargeType === 'hourly' && (
                    <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                          Billing(Salary/Rate)
                        </Typography>
                        {placeEdit ? (
                          <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                            {placeDetails1?.billRate && (
                              <>
                                {/* {placeDetails1?.country ===  "INDIA" ? "₹" :"$"} */}
                                {localStorage.getItem('country') === 'INDIA'
                                  ? '₹'
                                  : localStorage.getItem('country') === 'UK'
                                  ? '£'
                                  : '$'}
                                {/* {placeDetails1?.country === "INDIA" ? "₹" : placeDetails1?.country === "UK" ? "£" : "$"} */}
                                {placeDetails1?.billRate}
                                {/* {placeDetails1?.chargeType && placeDetails1?.chargeType !== "" && placeDetails1?.chargeType === 'hourly' ? '/Hour' : 'K'} */}
                                {'/hour'}
                              </>
                            )}
                          </Typography>
                        ) : (
                          <TextField
                            size="small"
                            value={tab1?.billRate}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start" sx={{ color: 'black' }}>
                                  {localStorage.getItem('country') === 'INDIA'
                                    ? '₹'
                                    : localStorage.getItem('country') === 'UK'
                                    ? '£'
                                    : '$'}
                                </InputAdornment>
                              ),
                              // startAdornment: <InputAdornment position="start" sx={{ color: "black" }}> {placeDetails1?.country === "INDIA" ? "₹" : placeDetails1?.country === "UK" ? "£" : "$"}</InputAdornment>,
                              // endAdornment: <InputAdornment position="end" sx={{ color: "black" }}>
                              //   <FormControl variant="standard" size="small">
                              //     <Select
                              //       value={tab1.chargeType}
                              //       onChange={(e) => setTab1({ ...tab1, chargeType: e.target.value })}
                              //       sx={{ color: 'black', width: '70px' }}
                              //     >
                              //       <MenuItem value="hourly">P/h</MenuItem>
                              //       <MenuItem value="Annually">K</MenuItem>
                              //       <MenuItem value="Annually"> {tab1?.country === "INDIA" ? "Lac" : "K"}</MenuItem>

                              //     </Select>
                              //   </FormControl>
                              // </InputAdornment>,
                              endAdornment: (
                                <InputAdornment position="end" sx={{ color: 'black' }}>
                                  P/h
                                </InputAdornment>
                              ),
                            }}
                            sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                            onChange={(e) => setTab1({ ...tab1, billRate: e.target.value })}
                          />
                        )}
                      </Stack>

                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                          {' '}
                          Pay(Salary/Rate)
                        </Typography>
                        {placeEdit ? (
                          <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                            {placeDetails1?.payRate && (
                              <>
                                {/* {placeDetails1?.country ===  "INDIA" ? "₹" :"$"} */}
                                {/* {placeDetails1?.country === "INDIA" ? "₹" : placeDetails1?.country === "UK" ? "£" : "$"} */}
                                {localStorage.getItem('country') === 'INDIA'
                                  ? '₹'
                                  : localStorage.getItem('country') === 'UK'
                                  ? '£'
                                  : '$'}
                                {placeDetails1?.payRate}
                                {/* {placeDetails1?.chargeType && placeDetails1?.chargeType !== "" && placeDetails1?.chargeType === 'hourly' ? '/Hour' : placeDetails1?.country === "INDIA" ? 'Lac' : 'K'} */}
                                {'Hour'}
                              </>
                            )}
                          </Typography>
                        ) : (
                          <TextField
                            size="small"
                            value={tab1?.payRate}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start" sx={{ color: 'black' }}>
                                  {localStorage.getItem('country') === 'INDIA'
                                    ? '₹'
                                    : localStorage.getItem('country') === 'UK'
                                    ? '£'
                                    : '$'}
                                </InputAdornment>
                              ),
                              // startAdornment: <InputAdornment position="start" sx={{ color: "black" }}> {placeDetails1?.country === "INDIA" ? "₹" : placeDetails1?.country === "UK" ? "£" : "$"}</InputAdornment>,
                              // endAdornment: <InputAdornment position="end" sx={{ color: "black" }}>
                              //   <FormControl variant="standard" size="small">
                              //     <Select
                              //       value={tab1.chargeType}
                              //       onChange={(e) => setTab1({ ...tab1, chargeType: e.target.value })}
                              //       sx={{ color: 'black', width: '70px' }}
                              //     >
                              //       <MenuItem value="hourly">P/h</MenuItem>
                              //       <MenuItem value="Annually">K</MenuItem>
                              //       <MenuItem value="Annually"> {tab1?.country === "INDIA" ? "Lac" : "K"}</MenuItem>
                              //     </Select>
                              //   </FormControl>
                              // </InputAdornment>,
                              endAdornment: (
                                <InputAdornment position="end" sx={{ color: 'black' }}>
                                  P/h
                                </InputAdornment>
                              ),
                            }}
                            sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                            onChange={(e) => setTab1({ ...tab1, payRate: e.target.value })}
                          />
                        )}
                      </Stack>
                    </Stack>
                  )}
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Relocation Assistance
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.relocationAssistance}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.relocationAssistance}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, relocationAssistance: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Annual Bonus
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.annualBonus}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.annualBonus}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, annualBonus: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>

                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    {/* 
                      <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: { xs: '100%', sm: '50%' } }}>
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>Over Time Bill Rate</Typography>
                        {placeEdit ? (
                          <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>{tab1?.overTimeBillRate}</Typography>
                        ) : (
                          <TextField
                            size="small"
                            value={tab1?.overTimeBillRate}
                            sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                            onChange={(e) => setTab1({ ...tab1, overTimeBillRate: e.target.value })}
                          />
                        )}
                      </Stack> */}

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Account Manager
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.accountManager}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.accountManager}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, accountManager: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Joining Bonus
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.joiningBonus}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.joiningBonus}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, joiningBonus: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider sx={{ mb: 0.5 }} />

                  <Stack sx={{ width: '100%', gap: 2, px: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Start Date
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.startDate ? new Date(tab1.startDate).toLocaleString('en-US', optionsDate) : ''}
                        </Typography>
                      ) : (
                        <FormControl size="small" sx={{ width: '100%' }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Start Date"
                              slotProps={{
                                textField: {
                                  size: 'small',
                                  sx: { width: '100%', background: 'text.background' },
                                },
                              }}
                              value={tab1.startDate ? dayjs(tab1.startDate) : null}
                              onChange={(date) => handleDateChange(date, 'startDate')}
                            />
                          </LocalizationProvider>
                        </FormControl>
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        End Date
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.endDate ? new Date(tab1.endDate).toLocaleString('en-US', optionsDate) : ''}
                        </Typography>
                      ) : (
                        <FormControl fullWidth size="small" sx={{ width: '100%' }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="End Date"
                              slotProps={{
                                textField: {
                                  size: 'small',
                                  sx: { width: '100%', background: 'text.background' },
                                },
                              }}
                              value={tab1.endDate ? dayjs(tab1.endDate) : null}
                              onChange={(date) => handleDateChange(date, 'endDate')}
                            />
                          </LocalizationProvider>
                        </FormControl>
                      )}
                    </Stack>
                  </Stack>

                  <Divider sx={{ mt: 0.5 }} />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Placement Tenure
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.placementTenture}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.placementTenture}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, placementTenture: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Placement Status
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.placementStatus}
                        </Typography>
                      ) : (
                        <Select
                          size="small"
                          value={tab1?.placementStatus}
                          sx={{ width: '100%' }}
                          onChange={(e) => setTab1({ ...tab1, placementStatus: e.target.value })}
                        >
                          <MenuItem value="complete">Completed</MenuItem>
                          <MenuItem value="active">Active</MenuItem>
                        </Select>
                      )}
                    </Stack>
                  </Stack>
                  <Divider sx={{ mt: 0.5 }} />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Guarantee Period
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.guranttePeriod}
                        </Typography>
                      ) : (
                        <Select
                          size="small"
                          value={tab1?.guranttePeriod}
                          sx={{ width: '100%', mt: 0.5, mb: 0.5 }}
                          onChange={(e) => setTab1({ ...tab1, guranttePeriod: e.target.value })}
                        >
                          <MenuItem value="30 Days">30 Days</MenuItem>
                          <MenuItem value="60 Days">60 Days</MenuItem>
                          <MenuItem value="90 Days">90 Days</MenuItem>
                          <MenuItem value="6 Months">6 Months</MenuItem>
                          <MenuItem value="1 Year">1 Year</MenuItem>
                        </Select>
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Employment Type
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.employmentType}
                        </Typography>
                      ) : (
                        <Select
                          size="small"
                          value={tab1?.employmentType}
                          sx={{ width: '100%', mt: 0.5, mb: 0.5 }}
                          onChange={(e) => setTab1({ ...tab1, employmentType: e.target.value })}
                        >
                          <MenuItem value="fulltime">Full Time</MenuItem>
                          <MenuItem value="contract">Contract</MenuItem>
                          <MenuItem value="contractToHire">Contract To Hire</MenuItem>
                        </Select>
                      )}
                    </Stack>
                  </Stack>
                  <Divider sx={{ mt: 0.5 }} />
                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Reporting Manager Name
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.reportingManagerName}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.reportingManagerName}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, reportingManagerName: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Reporting Manager Email
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.reportingManagerEmail}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.reportingManagerEmail}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, reportingManagerEmail: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>

                  <Divider sx={{ mt: 0.5 }} />
                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '98%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 160, p: 1 }}>
                        Reporting Manager Number{' '}
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.reportingManagerNumber}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.reportingManagerNumber}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, reportingManagerNumber: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>

                  <Divider sx={{ mt: 0.5 }} />
                  {valuee !== 'bench' && (
                    <>
                      {!placeEdit && <Divider />}
                      <Stack sx={{ flexDirection: 'row', px: 1, width: '100%', gap: 2 }}>
                        <Stack
                          sx={{ display: 'flex', flexDirection: 'row', width: { xs: '100%', sm: '50%' }, mt: 0.5 }}
                        >
                          {!placeEdit && (
                            <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 160, p: 1 }}>
                              Notes
                            </Typography>
                          )}
                          {placeEdit ? (
                            <Typography fontWeight={500} sx={{ p: 1 }}>
                              {/* {tab1?.notes} */}
                            </Typography>
                          ) : (
                            <TextField
                              sx={{ width: '99%' }}
                              id="outlined-multiline-static"
                              label="Notes"
                              multiline
                              rows={4}
                              value={tab1.notes}
                              onChange={(e) => setTab1({ ...tab1, notes: e.target.value })}
                            />
                          )}
                        </Stack>
                      </Stack>
                    </>
                  )}

                  <Divider sx={{ mt: 0.5 }} />

                  {/* {placeEdit ? (
                    <Divider sx={{ mt: -2 }} />
                    ):(
<Divider sx={{ mt: 0.5 }} />
                    )} */}
                  <Typography
                    fontWeight={500}
                    sx={{
                      color: 'text.secondary',
                      p: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    Additional
                  </Typography>
                  <Divider sx={{ mt: 0.5 }} />
                  {placeEdit && <Divider sx={{ mb: 1 }} />}
                  {placeEdit ? (
                    <Grid sx={{}}>
                      <Grid container spacing={2}>
                        {tab1?.placementInfoBoX1 &&
                          Object.entries(tab1?.placementInfoBoX1)?.map(([key, value], index, array) => {
                            const isLastItem = index === array.length - 1;

                            return (
                              <React.Fragment key={key}>
                                <Grid item xs={6}>
                                  <Stack
                                    direction="row"
                                    sx={{ width: '100%', alignItems: 'center', textTransform: 'capitalize' }}
                                  >
                                    <Typography sx={{ color: 'text.secondary', width: '120px', ml: 2 }}>
                                      {key}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        color: 'text.primary',
                                        // flexGrow: 1,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        ml: 6,
                                      }}
                                    >
                                      {value}
                                    </Typography>
                                  </Stack>
                                </Grid>

                                {!isLastItem && index % 2 === 1 && (
                                  // <Grid item xs={12}>
                                  <Divider sx={{ mb: -0.9, width: '100%', mt: 0.8 }} />
                                  // </Grid>
                                  // -0.9
                                )}
                              </React.Fragment>
                            );
                          })}
                      </Grid>
                    </Grid>
                  ) : (
                    <Stack sx={{ width: '100%' }}>
                      <Stack sx={{}}>
                        <Grid container spacing={2}>
                          {tab1?.placementInfoBoX1 &&
                            Object.entries(tab1?.placementInfoBoX1)?.map(([key, value]) => (
                              <Grid item xs={6} key={key}>
                                <Stack direction="row" sx={{ width: '98.7%', alignItems: 'center' }}>
                                  <Typography sx={{ color: 'text.secondary', width: 165, p: 1 }}>
                                    {key?.length > 10 ? `${key?.substring(0, 15)}...` : key}
                                  </Typography>
                                  {/* <Typography 
            sx={{ 
              color: 'text.primary', 
              flexGrow: 1, 
              whiteSpace: 'nowrap', 
              overflow: 'hidden', 
              textOverflow: 'ellipsis',
              // ml:15 
            }}
          >
            {value}
          </Typography> */}

                                  <TextField
                                    size="small"
                                    sx={{ py: 0.5, width: '99%', background: 'text.background' }}
                                    value={inputValues[key] || ''}
                                    onChange={(event) => handleValueInputChange(key, event)}
                                  />

                                  {/* <Iconify
            sx={{
              cursor: 'pointer', 
              color: 'error.main',
              flexShrink: 0 
            }}
            icon="ph:x-circle-fill"
            width="2rem"
            onClick={() => handleRemoveButtonClick(key)}
          /> */}
                                </Stack>
                              </Grid>
                            ))}
                        </Grid>
                      </Stack>
                      <Stack sx={{ flexDirection: 'row', width: '100%', alignItems: 'center' }}>
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 149, p: 1 }}>
                          Key
                        </Typography>
                        <TextField
                          size="small"
                          value={currentKey}
                          sx={{ py: 0.5, width: '42.4%', background: 'text.background' }}
                          onChange={handleKeyInputChange}
                          placeholder="Enter key"
                        />

                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 160, p: 1, ml: 3, mr: -2 }}>
                          Value
                        </Typography>
                        <TextField
                          value={currentValue}
                          size="small"
                          sx={{ py: 0.5, width: '38%', background: 'text.background' }}
                          onChange={handleValueInputChangeValue}
                          placeholder="Enter value"
                        />

                        <Iconify
                          sx={{ cursor: 'pointer', ml: 0.6 }}
                          icon="ph:plus-fill"
                          width="3rem"
                          color="text.secondary"
                          // onClick={handleAddButtonClick}
                          onClick={() => addAdditionalKeys()}
                        />
                      </Stack>
                    </Stack>
                  )}
                  {/* <Divider /> */}
                </Stack>
              </Stack>
            ) : value === 'project' ? (
              <Stack container sx={{ gap: 2, flexDirection: 'row', width: '100%' }}>
                <Stack sx={{ backgroundColor: 'text.background', borderRadius: 3, width: '100%' }}>
                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Implementation Partner
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.implementationPartner}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.implementationPartner}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, implementationPartner: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Project Type
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.projectType}
                        </Typography>
                      ) : (
                        <Select
                          size="small"
                          value={tab1?.projectType}
                          sx={{ width: '100%' }}
                          onChange={(e) => setTab1({ ...tab1, projectType: e.target.value })}
                        >
                          <MenuItem value="msp">MSP</MenuItem>
                          <MenuItem value="directclient">Direct Client</MenuItem>
                          <MenuItem value="thirdpartystaffing">Third Party Staffing</MenuItem>
                        </Select>
                      )}
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '49%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Domain
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.domain}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.domain}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, domain: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider sx={{}} />
                  <Typography
                    fontWeight={500}
                    sx={{
                      color: 'text.secondary',
                      p: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    Additional
                  </Typography>
                  <Divider sx={{ mb: 1 }} />
                  {placeEdit ? (
                    <Grid sx={{}}>
                      <Grid container spacing={2}>
                        {tab1?.projectInfoBox1 &&
                          Object.entries(tab1?.projectInfoBox1)?.map(([key, value], index, array) => {
                            const isLastItem = index === array.length - 1;

                            return (
                              <React.Fragment key={key}>
                                <Grid item xs={6}>
                                  <Stack
                                    direction="row"
                                    sx={{ width: '100%', alignItems: 'center', textTransform: 'capitalize' }}
                                  >
                                    <Typography sx={{ color: 'text.secondary', width: '120px', ml: 2 }}>
                                      {key}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        color: 'text.primary',
                                        // flexGrow: 1,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        ml: 6,
                                      }}
                                    >
                                      {value}
                                    </Typography>
                                  </Stack>
                                </Grid>

                                {!isLastItem && index % 2 === 1 && (
                                  // <Grid item xs={12}>
                                  <Divider sx={{ mb: -0.9, width: '100%', mt: -0.9 }} />
                                  // </Grid>
                                )}
                              </React.Fragment>
                            );
                          })}
                      </Grid>
                    </Grid>
                  ) : (
                    <Stack sx={{ width: '100%' }}>
                      <Stack sx={{}}>
                        <Grid container spacing={2}>
                          {tab1?.projectInfoBox1 &&
                            Object.entries(tab1?.projectInfoBox1)?.map(([key, value]) => (
                              <Grid item xs={6} key={key}>
                                <Stack direction="row" sx={{ width: '98.7%', alignItems: 'center' }}>
                                  <Typography sx={{ color: 'text.secondary', width: 165, p: 1 }}>
                                    {key?.length > 10 ? `${key?.substring(0, 15)}...` : key}
                                  </Typography>
                                  {/* <Typography 
            sx={{ 
              color: 'text.primary', 
              flexGrow: 1, 
              whiteSpace: 'nowrap', 
              overflow: 'hidden', 
              textOverflow: 'ellipsis',
              // ml:15 
            }}
          >
            {value}
          </Typography> */}

                                  {/* <TextField
                                      size="small"
                                      sx={{ py: 0.5, width: '99%', background: 'text.background' }}
                                      value={inputValues11[key] || ''}
                                      onChange={(event) => handleValueInputChange11(key, event)}
                                    /> */}

                                  {/* <Iconify
            sx={{
              cursor: 'pointer', 
              color: 'error.main',
              flexShrink: 0 
            }}
            icon="ph:x-circle-fill"
            width="2rem"
            onClick={() => handleRemoveButtonClick(key)}
          /> */}
                                </Stack>
                              </Grid>
                            ))}
                        </Grid>
                      </Stack>
                      <Stack sx={{ flexDirection: 'row', width: '100%', alignItems: 'center' }}>
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 149, p: 1 }}>
                          Key
                        </Typography>
                        <TextField
                          size="small"
                          sx={{ py: 0.5, width: '42.4%', background: 'text.background' }}
                          onChange={handleKeyInputChange11}
                          placeholder="Enter key"
                        />

                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 160, p: 1, ml: 3, mr: -2 }}>
                          Value
                        </Typography>
                        <TextField
                          size="small"
                          sx={{ py: 0.5, width: '38%', background: 'text.background' }}
                          onChange={handleValueInputChangeValue11}
                          placeholder="Enter value"
                        />

                        <Iconify
                          sx={{ cursor: 'pointer', ml: 0.6 }}
                          icon="ph:plus-fill"
                          width="3rem"
                          color="text.secondary"
                          // onClick={handleAddButtonClick}
                          onClick={() => addAdditionalKeys()}
                        />
                      </Stack>
                    </Stack>
                  )}
                  <Divider sx={{ mb: 5, mt: 1 }} />
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Recruiter Name
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.recruitorName}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.recruitorName}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, recruitorName: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Managing Team Info
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.ManagingTeamInfo}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.ManagingTeamInfo}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, ManagingTeamInfo: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Lead
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.lead}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.lead}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, lead: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Manager
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.Manager}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.Manager}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, Manager: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Head
                      </Typography>

                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.head}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.head}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, head: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Account Manager Ownership
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.accountManagerOwnership}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.accountManagerOwnership}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, accountManagerOwnership: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '49%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Recruitor Team Info
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.recruitorTeamInfo}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.recruitorTeamInfo}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, recruitorTeamInfo: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider />
                  <Typography
                    fontWeight={500}
                    sx={{
                      color: 'text.secondary',
                      p: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    Additional
                  </Typography>
                  <Divider sx={{ mb: 1 }} />
                  {placeEdit ? (
                    <Grid sx={{}}>
                      <Grid container spacing={2}>
                        {tab1?.projectInfoBox2 &&
                          Object.entries(tab1?.projectInfoBox2)?.map(([key, value], index, array) => {
                            const isLastItem = index === array.length - 1;

                            return (
                              <React.Fragment key={key}>
                                <Grid item xs={6}>
                                  <Stack
                                    direction="row"
                                    sx={{ width: '100%', alignItems: 'center', textTransform: 'capitalize' }}
                                  >
                                    <Typography sx={{ color: 'text.secondary', width: '120px', ml: 2 }}>
                                      {key}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        color: 'text.primary',
                                        // flexGrow: 1,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        ml: 6,
                                      }}
                                    >
                                      {value}
                                    </Typography>
                                  </Stack>
                                </Grid>

                                {!isLastItem && index % 2 === 1 && (
                                  // <Grid item xs={12}>
                                  <Divider sx={{ mb: -0.9, width: '100%', mt: -0.9 }} />
                                  // </Grid>
                                )}
                              </React.Fragment>
                            );
                          })}
                      </Grid>
                    </Grid>
                  ) : (
                    <Stack sx={{ width: '100%' }}>
                      <Stack sx={{}}>
                        <Grid container spacing={2}>
                          {tab1?.projectInfoBox2 &&
                            Object.entries(tab1?.projectInfoBox2)?.map(([key, value]) => (
                              <Grid item xs={6} key={key}>
                                <Stack direction="row" sx={{ width: '98.7%', alignItems: 'center' }}>
                                  <Typography sx={{ color: 'text.secondary', width: 165, p: 1 }}>
                                    {key?.length > 10 ? `${key?.substring(0, 15)}...` : key}
                                  </Typography>
                                  {/* <Typography 
            sx={{ 
              color: 'text.primary', 
              flexGrow: 1, 
              whiteSpace: 'nowrap', 
              overflow: 'hidden', 
              textOverflow: 'ellipsis',
              // ml:15 
            }}
          >
            {value}
          </Typography> */}

                                  {/* <TextField
                                      size="small"
                                      sx={{ py: 0.5, width: '99%', background: 'text.background' }}
                                      value={inputValues1[key] || ''}
                                      onChange={(event) => handleValueInputChange1(key, event)}
                                    /> */}

                                  {/* <Iconify
            sx={{
              cursor: 'pointer', 
              color: 'error.main',
              flexShrink: 0 
            }}
            icon="ph:x-circle-fill"
            width="2rem"
            onClick={() => handleRemoveButtonClick(key)}
          /> */}
                                </Stack>
                              </Grid>
                            ))}
                        </Grid>
                      </Stack>
                      <Stack sx={{ flexDirection: 'row', width: '100%', alignItems: 'center' }}>
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 149, p: 1 }}>
                          Key
                        </Typography>
                        <TextField
                          size="small"
                          sx={{ py: 0.5, width: '42.4%', background: 'text.background' }}
                          onChange={handleKeyInputChange1}
                          placeholder="Enter key"
                        />

                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 160, p: 1, ml: 3, mr: -2 }}>
                          Value
                        </Typography>
                        <TextField
                          size="small"
                          sx={{ py: 0.5, width: '38%', background: 'text.background' }}
                          onChange={handleValueInputChangeValue1}
                          placeholder="Enter value"
                        />

                        <Iconify
                          sx={{ cursor: 'pointer', ml: 0.6 }}
                          icon="ph:plus-fill"
                          width="3rem"
                          color="text.secondary"
                          // onClick={handleAddButtonClick}
                          onClick={() => addAdditionalKeys()}
                        />
                      </Stack>
                    </Stack>
                  )}
                </Stack>
              </Stack>
            ) : value === 'invoice' ? (
              <Stack container sx={{ gap: 2, flexDirection: 'row', width: '100%' }}>
                <Stack sx={{ backgroundColor: 'text.background', borderRadius: 3, width: '100%' }}>
                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Invoice Information
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.invoiceInformation}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.invoiceInformation}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, invoiceInformation: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Contact Name
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.contactName}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.contactName}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, contactName: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Email
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.email}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.email}
                          disabled
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, email: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Additional Email
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.additionalEmail}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.additionalEmail}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, additionalEmail: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider />

                  {tab1.chargeType === 'hourly' && (
                    <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                          Billing(Salary/Rate)
                        </Typography>
                        {placeEdit ? (
                          <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                            {placeDetails1?.billRate && (
                              <>
                                {/* {placeDetails1?.country ===  "INDIA" ? "₹" :"$"} */}
                                {localStorage.getItem('country') === 'INDIA'
                                  ? '₹'
                                  : localStorage.getItem('country') === 'UK'
                                  ? '£'
                                  : '$'}
                                {placeDetails1?.billRate}
                                {/* {placeDetails1?.chargeType && placeDetails1?.chargeType !== "" && placeDetails1?.chargeType === 'hourly' ? '/Hour' : tab1?.country === "INDIA" ? 'Lac' : 'K'} */}
                                {'/hour'}
                              </>
                            )}
                          </Typography>
                        ) : (
                          <TextField
                            size="small"
                            value={tab1?.billRate}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start" sx={{ color: 'black' }}>
                                  {' '}
                                  {localStorage.getItem('country') === 'INDIA'
                                    ? '₹'
                                    : localStorage.getItem('country') === 'UK'
                                    ? '£'
                                    : '$'}
                                </InputAdornment>
                              ),
                              // endAdornment: <InputAdornment position="end" sx={{ color: "black" }}>
                              //   <FormControl variant="standard" size="small">
                              //     <Select
                              //       value={tab1.chargeType}
                              //       onChange={(e) => setTab1({ ...tab1, chargeType: e.target.value })}
                              //       sx={{ color: 'black', width: '70px' }}
                              //     >
                              //       <MenuItem value="hourly">P/h</MenuItem>
                              //       <MenuItem value="Annually">K</MenuItem>
                              //       <MenuItem value="Annually">  {tab1?.country === "INDIA" ? "Lac" : "K"}</MenuItem>

                              //     </Select>
                              //   </FormControl>
                              // </InputAdornment>,

                              endAdornment: (
                                <InputAdornment position="end" sx={{ color: 'black' }}>
                                  P/h
                                </InputAdornment>
                              ),
                            }}
                            sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                            onChange={(e) => setTab1({ ...tab1, billRate: e.target.value })}
                          />
                        )}
                      </Stack>
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: { xs: '100%', sm: '50%' },
                        }}
                      >
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                          {' '}
                          Pay(Salary/Rate)
                        </Typography>
                        {placeEdit ? (
                          <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                            {placeDetails1?.payRate && (
                              <>
                                {/* {placeDetails1?.country ===  "INDIA" ? "₹" :"$"} */}
                                {/* {placeDetails1?.country === "INDIA" ? "₹" : placeDetails1?.country === "UK" ? "£" : "$"} */}
                                {localStorage.getItem('country') === 'INDIA'
                                  ? '₹'
                                  : localStorage.getItem('country') === 'UK'
                                  ? '£'
                                  : '$'}
                                {placeDetails1?.payRate}
                                {'Hour'}
                                {/* {placeDetails1?.chargeType && placeDetails1?.chargeType !== "" && placeDetails1?.chargeType === 'hourly' ? '/Hour' : placeDetails1?.country === "INDIA" ? 'Lac' : 'K'} */}
                              </>
                            )}
                          </Typography>
                        ) : (
                          <TextField
                            size="small"
                            value={tab1?.payRate}
                            InputProps={{
                              // startAdornment: <InputAdornment position="start" sx={{ color: "black" }}> {placeDetails1?.country === "INDIA" ? "₹" : placeDetails1?.country === "UK" ? "£" : "$"}</InputAdornment>,
                              startAdornment: (
                                <InputAdornment position="start" sx={{ color: 'black' }}>
                                  {localStorage.getItem('country') === 'INDIA'
                                    ? '₹'
                                    : localStorage.getItem('country') === 'UK'
                                    ? '£'
                                    : '$'}
                                </InputAdornment>
                              ),

                              // endAdornment: <InputAdornment position="end" sx={{ color: "black" }}>
                              //   <FormControl variant="standard" size="small">
                              //     <Select
                              //       value={tab1.chargeType}
                              //       onChange={(e) => setTab1({ ...tab1, chargeType: e.target.value })}
                              //       sx={{ color: 'black', width: '70px' }}
                              //     >
                              //       <MenuItem value="hourly">P/h</MenuItem>
                              //       <MenuItem value="Annually">K</MenuItem>
                              //       <MenuItem value="Annually">  {tab1?.country === "INDIA" ? "Lac" : "K"}</MenuItem>
                              //     </Select>
                              //   </FormControl>
                              // </InputAdornment>,
                              endAdornment: (
                                <InputAdornment position="end" sx={{ color: 'black' }}>
                                  P/h
                                </InputAdornment>
                              ),
                            }}
                            sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                            onChange={(e) => setTab1({ ...tab1, payRate: e.target.value })}
                          />
                        )}
                      </Stack>

                      {/* 
                              <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: { xs: '100%', sm: '50%' } }}>
                                <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>Bill Rate</Typography>


                                {placeEdit ? (
                                  <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>{tab1?.billRate}</Typography>
                                ) : (
                                  <TextField
                                    size="small"
                                    value={tab1?.billRate}
                                    sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                                    onChange={(e) => setTab1({ ...tab1, billRate: e.target.value })}
                                  />
                                )}




                              </Stack> */}

                      {/* <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: { xs: '100%', sm: '50%' } }}>
                                <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>Pay Rate</Typography>
                                {placeEdit ? (
                                  <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>{tab1?.payRate}</Typography>
                                ) : (
                                  <TextField
                                    size="small"
                                    value={tab1?.payRate}
                                    sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                                    onChange={(e) => setTab1({ ...tab1, payRate: e.target.value })}
                                  />
                                )}
                              </Stack> */}
                    </Stack>
                  )}

                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        End Client Phone Number
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.endClientPhoneNumber}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.endClientPhoneNumber}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, endClientPhoneNumber: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Address
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.address}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.address}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, address: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Payroll Tax State
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.payrollTaxState}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.payrollTaxState}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, payrollTaxState: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Billing Type
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.billingType}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.billingType}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, billingType: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Billing Frequency
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.billingFrequency}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.billingFrequency}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, billingFrequency: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Billing Instruction
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.billingIntruction}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.billingIntruction}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, billingIntruction: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Tenure Worked
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.tenureWorked}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.tenureWorked}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, tenureWorked: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Expenses
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.expenses}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.expenses}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, expenses: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Hours Per Day
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.hoursPerDay}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.hoursPerDay}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, hoursPerDay: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Currency
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.currency}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.currency}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, currency: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, px: 1, width: '100%', gap: 2 }}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Vendor Name
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.vendorName}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.vendorName}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, vendorName: e.target.value })}
                        />
                      )}
                    </Stack>

                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: { xs: '100%', sm: '50%' },
                      }}
                    >
                      <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                        Vendor Fee
                      </Typography>
                      {placeEdit ? (
                        <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                          {tab1?.vendorFee}
                        </Typography>
                      ) : (
                        <TextField
                          size="small"
                          value={tab1?.vendorFee}
                          sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                          onChange={(e) => setTab1({ ...tab1, vendorFee: e.target.value })}
                        />
                      )}
                    </Stack>
                  </Stack>

                  <Divider />

                  <Stack
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      width: { xs: '100%', sm: '50%' },
                    }}
                  >
                    <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 170, p: 1 }}>
                      Over Time Bill Rate
                    </Typography>
                    {placeEdit ? (
                      <Typography fontWeight={500} sx={{ p: 1, textTransform: 'capitalize' }}>
                        {tab1?.overTimeBillRate}
                      </Typography>
                    ) : (
                      <TextField
                        size="small"
                        value={tab1?.overTimeBillRate}
                        sx={{ py: 0.5, width: '100%', background: 'text.background' }}
                        onChange={(e) => setTab1({ ...tab1, overTimeBillRate: e.target.value })}
                      />
                    )}
                  </Stack>
                  <Divider />
                  <Typography
                    fontWeight={500}
                    sx={{
                      color: 'text.secondary',
                      p: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    Additional
                  </Typography>
                  <Divider sx={{ mb: 1 }} />
                  {placeEdit ? (
                    <Grid sx={{}}>
                      <Grid container spacing={2}>
                        {tab1?.voiceInfoBox3 &&
                          Object.entries(tab1?.voiceInfoBox3)?.map(([key, value], index, array) => {
                            const isLastItem = index === array.length - 1;

                            return (
                              <React.Fragment key={key}>
                                <Grid item xs={6}>
                                  <Stack
                                    direction="row"
                                    sx={{ width: '100%', alignItems: 'center', textTransform: 'capitalize' }}
                                  >
                                    <Typography sx={{ color: 'text.secondary', width: '120px', ml: 2 }}>
                                      {key}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        color: 'text.primary',
                                        // flexGrow: 1,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        ml: 6,
                                      }}
                                    >
                                      {value}
                                    </Typography>
                                  </Stack>
                                </Grid>

                                {!isLastItem && index % 2 === 1 && (
                                  // <Grid item xs={12}>
                                  <Divider sx={{ mb: -0.9, width: '100%', mt: -0.9 }} />
                                  // </Grid>
                                )}
                              </React.Fragment>
                            );
                          })}
                      </Grid>
                    </Grid>
                  ) : (
                    <Stack sx={{ width: '100%' }}>
                      <Stack sx={{}}>
                        <Grid container spacing={2}>
                          {tab1?.voiceInfoBox3 &&
                            Object.entries(tab1?.voiceInfoBox3)?.map(([key, value]) => (
                              <Grid item xs={6} key={key}>
                                <Stack direction="row" sx={{ width: '98.7%', alignItems: 'center' }}>
                                  <Typography sx={{ color: 'text.secondary', width: 165, p: 1 }}>
                                    {key?.length > 10 ? `${key?.substring(0, 15)}...` : key}
                                  </Typography>
                                  {/* <Typography 
            sx={{ 
              color: 'text.primary', 
              flexGrow: 1, 
              whiteSpace: 'nowrap', 
              overflow: 'hidden', 
              textOverflow: 'ellipsis',
              // ml:15 
            }}
          >
            {value}
          </Typography> */}

                                  {/* <TextField
                                        size="small"
                                        sx={{ py: 0.5, width: '99%', background: 'text.background' }}
                                        value={inputValues2[key] || ''}
                                        onChange={(event) => handleValueInputChange2(key, event)}
                                      /> */}

                                  {/* <Iconify
            sx={{
              cursor: 'pointer', 
              color: 'error.main',
              flexShrink: 0 
            }}
            icon="ph:x-circle-fill"
            width="2rem"
            onClick={() => handleRemoveButtonClick(key)}
          /> */}
                                </Stack>
                              </Grid>
                            ))}
                        </Grid>
                      </Stack>
                      <Stack sx={{ flexDirection: 'row', width: '100%', alignItems: 'center' }}>
                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 149, p: 1 }}>
                          Key
                        </Typography>
                        <TextField
                          size="small"
                          sx={{ py: 0.5, width: '42.4%', background: 'text.background' }}
                          onChange={handleKeyInputChange2}
                          placeholder="Enter key"
                        />

                        <Typography fontWeight={500} sx={{ color: 'text.secondary', width: 160, p: 1, ml: 3, mr: -2 }}>
                          Value
                        </Typography>
                        <TextField
                          size="small"
                          sx={{ py: 0.5, width: '38%', background: 'text.background' }}
                          onChange={handleValueInputChangeValue2}
                          placeholder="Enter value"
                        />

                        <Iconify
                          sx={{ cursor: 'pointer', ml: 0.6 }}
                          icon="ph:plus-fill"
                          width="3rem"
                          color="text.secondary"
                          // onClick={handleAddButtonClick}
                          onClick={() => addAdditionalKeys()}
                        />
                      </Stack>
                    </Stack>
                  )}
                </Stack>
              </Stack>
            ) : value === 'Expenses' ? (
              <>
                {/* 
                        <Box sx={{ p: 2 }}>
                     
                        <Button
                          variant="contained"
                          sx={{
                            background: "#3C6BA5",
                            color: "#fff",
                            mb: 2,
                            "&:hover": { background: "#315a8a" }
                          }}
                          onClick={() => setOpen22(true)}
                        >
                          Add Expense
                        </Button>

                     
                        <TableContainer component={Paper}>
                          <Table>
                            <TableHead sx={{ backgroundColor: "#3C6BA5" }}>
                              <TableRow>
                                <TableCell sx={{ color: "#fff", textAlign: 'center' }}>Date Added</TableCell>
                                <TableCell sx={{ color: "#fff", textAlign: 'center' }}>Description of Expense</TableCell>
                                <TableCell sx={{ color: "#fff", textAlign: 'center' }}>Amount</TableCell>
                                <TableCell sx={{ color: "#fff", textAlign: 'center' }}>Added By</TableCell>
                              </TableRow>
                            </TableHead>

                            <TableBody>
                              {valuee === "rec" ? data?.expensesList?.map((row, index) => (
                                <TableRow key={index}>
                                  <TableCell sx={{ textAlign: 'center' }}>{row.dateAdded}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' }}>{row.description}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' }}>{row.amount}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' }}>{row.addedBy}</TableCell>
                                </TableRow>
                              )) : data1?.expensesList?.map((row, index) => (
                                <TableRow key={index}>
                                  <TableCell sx={{ textAlign: 'center' }}>{row.dateAdded}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' }}>{row.description}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' }}>{row.amount}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' }}>{row.addedBy}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>

                      
                        <Modal open={open22} onClose={() => setOpen22(false)}>
                          <Box sx={style}>
                             <Typography variant="h6" sx={{ mb: 2 }}>
                               Add Manual Expense
                             </Typography>

                        <TextField
                           fullWidth
                           label="Description of Expense"
                           sx={{ mb: 2 }}
                           value={description1}
                           onChange={(e) => setDescription(e.target.value)}
                         />

                         <TextField
                           fullWidth
                              label="Amount"
                           sx={{ mb: 2 }}
                           value={amount1}
                           onChange={(e) => setAmount(e.target.value)}
                            />

                          <Button
                            variant="contained"
                            fullWidth
                            sx={{ background: "#3C6BA5", color: "#fff" }}
                            onClick={handleAdd}
                          >
                            Save
                          </Button>
                        </Box>
                      </Modal>
                        </Box> */}
              </>
            ) : null}
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={openExpenses} onClose={() => handleCloseExpenses()} style={{ borderRadius: 10 }}>
        <Box sx={styleClients}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
              justifyContent: { xs: 'center', sm: 'space-between' },
              width: '100%',
              mb: 2,
            }}
          >
            <Typography
              variant="h5"
              color="#3C6BA5"
              sx={{
                textTransform: 'capitalize',
                textAlign: 'center',
                width: '100%',
                mt: { xs: 0, sm: -3 },
                mb: { xs: 1, sm: 0 },
              }}
            >
              expenses
            </Typography>

            <Box
              sx={{
                width: { xs: '100%', sm: 'auto' },
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-end' },
              }}
            >
              <Button color="custom" variant="contained" size="small" onClick={() => setOpen22(true)}>
                Add
              </Button>
            </Box>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <Scrollbar sx={{ maxHeight: 400, overflowX: 'auto' }}>
            <Box sx={{ minWidth: 600 }}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ backgroundColor: '#3C6BA5' }}>
                    <TableRow>
                      <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Date Added</TableCell>
                      <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Description of Expense</TableCell>
                      <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Amount</TableCell>
                      <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Added By</TableCell>
                      <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Action </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {valuee === 'rec'
                      ? dataExpensive?.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell>
                              {new Date(row?.dateAdded)
                                ?.toLocaleString('en-US', {
                                  month: 'short',
                                  day: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: false,
                                })
                                .replace(',', '')}
                            </TableCell>
                            <TableCell>{row.description}</TableCell>
                            <TableCell>
                              {`${
                                localStorage.getItem('country') === 'INDIA'
                                  ? '₹'
                                  : localStorage.getItem('country') === 'UK'
                                  ? '£'
                                  : '$'
                              } ${row?.amount}`}
                            </TableCell>
                            <TableCell>{row.addedBy}</TableCell>

<TableCell>
  <Button
    color="custom"
    variant="contained"
    size="small"
    sx={{ mr: 1 }}
    onClick={() => handleOpenEdit(row)}
  >
    Edit
  </Button>

  <Button
    color="custom"
    variant="contained"
    size="small"
    onClick={() => handleDeleteExpense(row?._id)}
  >
    Delete
  </Button>
</TableCell>

                          </TableRow>
                        ))
                      : dataExpensive2?.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell>
                              {new Date(row?.dateAdded)
                                ?.toLocaleString('en-US', {
                                  month: 'short',
                                  day: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: false,
                                })
                                .replace(',', '')}
                            </TableCell>
                            <TableCell>{row.description}</TableCell>
                            <TableCell>
                              {`${
                                localStorage.getItem('country') === 'INDIA'
                                  ? '₹'
                                  : localStorage.getItem('country') === 'UK'
                                  ? '£'
                                  : '$'
                              } ${row?.amount}`}
                            </TableCell>
                            <TableCell>{row.addedBy}</TableCell>
                                <TableCell>
  <Button
    color="custom"
    variant="contained"
    size="small"
    sx={{ mr: 1 }}
    onClick={() => handleOpenEdit(row)}
  >
    Edit
  </Button>

  <Button
    color="custom"
    variant="contained"
    size="small"
    onClick={() => handleDeleteExpense(row?._id)}
  >
    Delete
  </Button>
</TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={open22} onClose={() => setOpen22(false)}>
        <Box sx={style}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Add Manual Expense
          </Typography>

          <TextField
            fullWidth
            label="Description of Expense"
            sx={{ mb: 2 }}
            value={description1}
            onChange={(e) => setDescription(e.target.value)}
          />

          {/* <TextField
            fullWidth
            label="Amount"
            sx={{ mb: 2 }}
            value={amount1}
            onChange={(e) => setAmount(e.target.value)}
          /> */}

          <TextField
            fullWidth
            label={`Expected Compensation( In ${localStorage.getItem('country') === 'INDIA' ? 'INR' : 'Dollars'} )*`}
            placeholder="Expected Compensation"
            sx={{ mb: 2 }}
            value={amount1}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {localStorage.getItem('country') === 'INDIA'
                    ? '₹'
                    : localStorage.getItem('country') === 'UK'
                    ? '£'
                    : '$'}
                </InputAdornment>
              ),
            }}
            onChange={(e) => {
              const newValue = e.target.value;
              if (/^\d*\.?\d*$/.test(newValue)) {
                setAmount(newValue);
              }
            }}
          />

          {/* 
          <TextField
            size="small"

            sx={{ width: '60%', py: 0.5, ml: -12 }}
            id="outlined-basic"

            label={`Expected Compensation( In ${box1.box1Country === "INDIA" ? "INR" : "Dollars"} )*`}
            placeholder="Expected Compensation"
            variant="outlined"
            type="text"
            InputLabelProps={{ shrink: true }}
            value={box1?.box1compensation}
            InputProps={{
              startAdornment: <InputAdornment position="start">{box1.box1Country === "INDIA" ? "₹" : box1.box1Country === "UK" ? "£" : "$"}</InputAdornment>,
              endAdornment: box1?.box1ChargeType && (
                <InputAdornment position="end">
                  {box1?.box1ChargeType === 'hourly' ? 'per/hour' : 'K'}
                </InputAdornment>
              ),
            }}
            onChange={(e) => {
              const newValue = e.target.value;
              if (/^\d*\.?\d*$/.test(newValue)) {
                setBox1({ ...box1, box1compensation: newValue });
              }
            }}
          />

 */}

          {/* <Button
                            variant="contained"
                            fullWidth
                            sx={{ background: "#3C6BA5", color: "#fff" }}
                            onClick={handleAdd}
                          >
                            Save
                          </Button> */}

          <Button
            color="custom"
            variant="contained"
            //  size="small"
            fullWidth
            //    onClick={() => setOpen22(true)}
            onClick={handleAdd}
          >
            Save
          </Button>
        </Box>
      </Modal>

      {/* 

      <Dialog open={open1} onClose={() => setOpen1(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Select Period</DialogTitle>

        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

          
          <FormControl fullWidth>
            <InputLabel>Year</InputLabel>
            <Select value={year} label="Year" onChange={(e) => setYear(e.target.value)}>
              {years.map((y) => (
                <MenuItem key={y} value={y}>{y}</MenuItem>
              ))}
            </Select>
          </FormControl>

         
          <FormControl fullWidth>
            <InputLabel>Month</InputLabel>
            <Select value={month} label="Month" onChange={(e) => setMonth(e.target.value)}>
              {months.map((m, i) => (
                <MenuItem key={i} value={i + 1}>{m}</MenuItem>
              ))}
            </Select>
          </FormControl>

         
          <FormControl fullWidth>
            <InputLabel>From Week</InputLabel>
            <Select
              value={fromWeek}
              label="From Week"
              onChange={(e) => {
                setFromWeek(e.target.value);
                setToWeek(""); 
              }}
            >
              {fromWeeks.map((w) => (
                <MenuItem key={w} value={w}>Week {w}</MenuItem>
              ))}
            </Select>
          </FormControl>

       
          <FormControl fullWidth disabled={!fromWeek}>
            <InputLabel>To Week</InputLabel>
            <Select value={toWeek} label="To Week" onChange={(e) => setToWeek(e.target.value)}>
              {toWeeks.map((w) => (
                <MenuItem key={w} value={w}>Week {w}</MenuItem>
              ))}
            </Select>
          </FormControl>

        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen1(false)}>Cancel</Button>
          <Button
            variant="contained"
            disabled={!year || !month || !fromWeek || !toWeek}

            onClick={handleApply}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog> */}

      <Modal open={open1} onClose={() => setOpen1(false)}>
        <Box
          className="morFltr_pop"
          // sx={{
          //   position: 'absolute',
          // //  top: '36%',
          //   transform: 'translate(-50%, -50%)',
          //   width: { xs: '95%', sm: '70%' },
          //   // width: { xs: '85%', sm: '60%' },
          //   bgcolor: 'background.paper',
          //   border: '3px solid #3C6BA5',
          //   boxShadow: 24,
          //   p: 2,
          //   borderRadius: 3,
          //   top: '40%',
          //   left: '30%'
          // }}

          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95%', sm: '50%' },
            bgcolor: 'background.paper',
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 2,
            borderRadius: 3,
          }}
        >
          <Grid container spacing={1} justifyContent="center">
            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Year</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  // value={value.domain}
                  value={year}
                  label="Year"
                  // InputLabelProps={{ shrink: true }}
                  onChange={(e) => setYear(e.target.value)}
                >
                  {years.map((y) => (
                    <MenuItem key={y} value={y}>
                      {y}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Month</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Month"
                  placeholder="Month"
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                >
                  {months.map((m, i) => (
                    <MenuItem key={i} value={i + 1}>
                      {m}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">From Week</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  // value={value.domain}
                  value={fromWeek}
                  label="From Week"
                  // InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setFromWeek(e.target.value);
                    setToWeek('');
                  }}
                >
                  {fromWeeks.map((w) => (
                    <MenuItem key={w} value={w}>
                      Week {w}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">To Week</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  // value={value.domain}
                  value={toWeek}
                  label="To Week"
                  // InputLabelProps={{ shrink: true }}
                  onChange={(e) => setToWeek(e.target.value)}
                >
                  {toWeeks.map((w) => (
                    <MenuItem key={w} value={w}>
                      Week {w}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6} textAlign="center" sx={{ marginTop: '1px' }}>
              <Button color="custom" variant="contained" size="small" onClick={() => setOpen1(false)}>
                Cancel
              </Button>
              <Button
                color="custom"
                variant="contained"
                size="small"
                sx={{ marginLeft: '12px' }}
                disabled={!year || !month || !fromWeek || !toWeek}
                onClick={() => {
                  if (valuew === 'invoiveManuval') {
                    handleUploadInvoice();
                    setOpen1(false);
                  } else if (valuew === 'timeSheetManuval') {
                    handleUploadTimeSheet();
                    setOpen1(false);
                  } else {
                    handleApply();
                  }
                }}
              >
                apply
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      {/* <Modal
        open={deleteModalOpen}
        onClose={handleCloseDeleteModal}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: "35%",
          bgcolor: 'background.paper',
          border: '3px solid #3C6BA5',
          boxShadow: 24,
          p: 3,
          borderRadius: 3,
        }}>
          <Typography variant="h6" color={'#3C6BA5'} textAlign={'center'}>
            Any changes will not be saved.
            are you sure you want to close this?
          </Typography>
          <Stack flexDirection={'row'} gap={2} mt={2} sx={{ justifyContent: 'center' }}>
            <Button color="custom" variant="contained"
              onClick={() => closeMultiModal()}
            >
              Yes
            </Button>
            <Button color="custom" variant="contained" onClick={handleCloseDeleteModal}>
              No 
            </Button>
          </Stack> 
        </Box>
      </Modal> */}

      <Modal open={deleteModalOpen} onClose={handleCloseDeleteModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: {
              xs: '90%',
              sm: '70%',
              md: '40%',
              lg: '35%',
            },
            bgcolor: 'background.paper',
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
          }}
        >
          <Typography variant="h6" color="#3C6BA5" textAlign="center" sx={{ fontSize: { xs: '1rem', sm: '1.2rem' } }}>
            Any changes will not be saved. Are you sure you want to close this?
          </Typography>

          <Stack direction="row" spacing={2} mt={2} justifyContent="center" flexWrap="wrap">
            <Button color="custom" variant="contained" onClick={() => closeMultiModal()} sx={{ minWidth: 100 }}>
              Yes, cancel
            </Button>
            <Button color="custom" variant="contained" onClick={handleCloseDeleteModal} sx={{ minWidth: 100 }}>
              No, Continue editing
            </Button>
          </Stack>
        </Box>
      </Modal>

      {/* <Modal open={openn} onClose={handleClosen} style={{ borderRadius: 10 }}>
        <Box sx={styleClients}>
          <Stack sx={{ width: '100%', alignItems: 'flex-end' }}>
            <Button
              
              color="custom"
              variant="contained"
              size="small"
              onClick={() =>
                navigate('/resumeDetail', {
                  state: {
                   
                    placeNotes: "PlaceNotes",
                    row: data,
                    mtab: 'Resume',
                    fTab: 'submitted',
                  },
                })
              }
            >
              Add Note
            </Button>
          </Stack>
          <Typography variant="h5" color={'#3C6BA5'} sx={{ textTransform: 'capitalize', mt: -3 }} textAlign={'center'}>
            
            Notes
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Stack sx={{ backgroundColor: 'text.secondary', flexDirection: 'row', p: 1, py: 0.5, borderRadius: 1 }}>
              <Typography color={'white'} sx={{ width: '16%', fontSize: '0.976rem', fontWeight: '600' }}>
                Date
              </Typography>
              <Typography color={'white'} sx={{ width: '10%', fontSize: '0.976rem', fontWeight: '600' }}>
                User
              </Typography>
              <Typography color={'white'} sx={{ width: '80%', fontSize: '0.976rem', fontWeight: '600' }}>
                Note
              </Typography>
            </Stack>
            {his?.length
              ? his?.map((item, index) => {
                return (
                  <Stack
                    sx={[
                      { background: index % 2 === 0 ? 'text.background' : tablebg },
                      { flexDirection: 'row', p: 1 },
                    ]}
                  >
                    <Typography sx={{ width: '16%' }}>
                      {`${new Date(item.createdAt).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(item?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(item?.createdAt).getMinutes()).padStart(2, '0')}`}
                    </Typography>
                    <Typography sx={{ width: '10%', textTransform: 'capitalize', fontWeight: '800', color: 'text.secondary' }}>{item?.actionBy}</Typography>
                    <Typography sx={{ width: '80%' }}>
                      {item?.note}
                    </Typography>
                  </Stack>
                );
              })
              : null}
          </Scrollbar>
        </Box>
      </Modal> */}

      <Modal open={openEmail} onClose={() => handleCloseEmail()} style={{ borderRadius: 10 }}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95%', sm: '70%' },

            bgcolor: 'background.paper',
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
          }}
        >
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Send Email
          </Typography>
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <TextField
                  fullWidth
                  required
                  label="To"
                  variant="outlined"
                  size="small"
                  disabled
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={5.9}>
                <Autocomplete
                  size="small"
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setCcEmail([...newValue]);
                  }}
                  options={[{ title: '' }]}
                  getOptionLabel={(option) => option.title}
                  value={ccEmail.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;

                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="Cc" placeholder="Cc" size="small" />}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <Autocomplete
                  size="small"
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setBccEmail([...newValue]);
                  }}
                  options={[{ title: '' }]}
                  getOptionLabel={(option) => option.title}
                  value={bccEmail.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;

                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="BCc" placeholder="BCc" size="small" />}
                />
              </Grid>

              <Grid item xs={5} sx={{}}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel>Select Template</InputLabel>
                  <Select label="Select Template" onChange={(e) => handleTemplateSelect(e.target.value)}>
                    {tempList?.map((item) => (
                      <MenuItem key={item.id} value={item}>
                        {item.templateName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Typography
                onClick={() => navigate('/Email', { state: { undid: 'undid', bodyDis: '' } })}
                sx={{
                  color: '#23A6F0',
                  fontWeight: 'bold',
                  fontSize: '17px',
                  marginLeft: '30px',
                  marginTop: '18px',
                  cursor: 'pointer',
                }}
              >
                Edit
              </Typography>
            </Grid>

            <Grid item xs={8} marginTop={2}>
              <Grid container spacing={1}>
                {/* Timesheet */}
                <Grid item xs={1}>
                  <Typography>Timesheet:</Typography>
                </Grid>

                <Grid item xs={2}>
                  <input
                    type="file"
                    ref={timeSheetRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChangeTimeSheet}
                  />

                  {/* Tumhara existing button */}
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      width: '80%',
                      backgroundColor: '#3C6BA5',
                      '&:hover': {
                        backgroundColor: '#3C6BA5',
                      },
                    }}
                    onClick={() => {
                      setValuew('timeSheetManuval');
                      setOpen1(true);
                      // handleUploadTimeSheet();
                    }}
                  >
                    Upload
                  </Button>

                  {/* Just to check */}
                  {filetime && <Typography>{filetime.name ? 'file attached' : ''}</Typography>}
                </Grid>

                <Grid item xs={2}>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      width: '80%',
                      backgroundColor: '#3C6BA5',
                      '&:hover': {
                        backgroundColor: '#3C6BA5',
                      },
                    }}
                    // sx={{ width: "80%",backgroundColor: "#3C6BA5" }}

                    onClick={() => {
                      setOpen1(true);
                      setValuew('timesheet');
                    }}
                  >
                    Foxearch
                  </Button>
                  <div>{atchedsecond === '' ? '' : ' file attached'}</div>
                </Grid>

                <Grid item xs={2}>
                  <TextField
                    size="small"
                    placeholder="Hours"
                    fullWidth
                    disabled={handleInputDisable}
                    onChange={(e) => setTotalHours(e.target.value)}
                    value={totalHours}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={8} marginTop={2}>
              <Grid container spacing={1} alignItems="center">
                {/* Invoice */}
                <Grid item xs={1}>
                  <Typography>Invoice :</Typography>
                </Grid>

                <Grid item xs={2}>
                  <input type="file" ref={invoiceRef} style={{ display: 'none' }} onChange={handleFileChangeInvoice} />

                  {/* Tumhara existing button */}
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      width: '80%',
                      backgroundColor: '#3C6BA5',
                      '&:hover': {
                        backgroundColor: '#3C6BA5',
                      },
                    }}
                    onClick={() => {
                      setValuew('invoiveManuval');
                      setOpen1(true);
                      //  handleUploadInvoice
                    }}
                  >
                    Upload
                  </Button>

                  {/* Just to check */}
                  {fileinvoice && <Typography>{fileinvoice.name ? 'file attached' : ''}</Typography>}
                </Grid>

                <Grid item xs={2}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      setOpen1(true);
                      setValuew('Invoice');
                    }}
                    size="small"
                    sx={{
                      width: '80%',
                      backgroundColor: '#3C6BA5',
                      '&:hover': {
                        backgroundColor: '#3C6BA5',
                      },
                    }}
                  >
                    Foxearch
                  </Button>
                  <div>{atched === '' ? '' : ' file attached'}</div>
                </Grid>

                {/* const [totalHours, setTotalHours] = useState(); */}
                {/* const [totalamount, setTotalAmount] = useState(0); */}

                <Grid item xs={2}>
                  <TextField
                    size="small"
                    placeholder="Amount"
                    fullWidth
                    disabled={handleInputDisable2}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {localStorage.getItem('country') === 'INDIA'
                            ? '₹'
                            : localStorage.getItem('country') === 'UK'
                            ? '£'
                            : '$'}
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => setTotalAmount(e.target.value)}
                    value={totalamount}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={11.8}>
                <TextField
                  label="Sub"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                />
              </Grid>
              <Grid item xs={11.8}>
                <Stack sx={{ flexDirection: 'row', gap: 1, alignItems: 'center' }}>
                  <Typography sx={{ textTransform: 'capitalize' }}>
                    {/* {greeting
                                        ? `${greeting} ${row?.fullName?.split(" ")[0]},`
                                        : row?.fullName?.split(" ")[0]} */}
                    {greeting}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={11.8}>
                <CKEditor
                  data={emailBody}
                  config={{
                    extraPlugins: [MyCustomUploadAdapterPlugin],
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();

                    setEmailBody(data);
                  }}
                  editor={ClassicEditor}
                />
              </Grid>
            </Grid>

            <Box
              sx={{
                border: '1px solid #3C6BA5',
                p: 2,
                borderRadius: 1,
                marginTop: 3,
              }}
            >
              <Typography fontWeight="bold">Naveen Kumar, B.Tech | Managing Director</Typography>

              <Typography variant="body2">Phone: (302) 200-3272</Typography>

              <Typography variant="body2" color="primary">
                info@foxearch.com
              </Typography>

              <Box sx={{ mt: 1 }}>
                <img src="/foxearch-logo.png" alt="foxearch" height={32} />
              </Box>

              <Box sx={{ mt: 1 }}>
                <Typography variant="body2" fontWeight="bold">
                  Foxearch LLC
                </Typography>
                <Typography variant="body2">16912 Coastal Hwy Lewes, DE 19958</Typography>
                <Typography variant="body2" color="primary">
                  www.foxearch.com
                </Typography>
              </Box>

              <Typography variant="caption" sx={{ display: 'block', mt: 2, color: 'gray' }}>
                If you prefer not to receive future communications like this, please email us at{' '}
                <span style={{ color: '#3C6BA5' }}>support@foxearch.com</span> with your name to{' '}
                <span style={{ color: '#3C6BA5' }}>Unsubscribe</span>. Kindly allow up to 3 business days for your
                request to be processed.
              </Typography>

              <Stack direction="row" justifyContent="center" spacing={1}>
                <Button color="custom" variant="contained" size="small" onClick={sendPlacedMail}>
                  send Email
                </Button>
              </Stack>
            </Box>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={openn} onClose={handleClosen} style={{ borderRadius: 10 }}>
        <Box sx={styleClients}>
          {/* <Stack sx={{ width: '100%', alignItems: 'flex-end' }}>
      <Button
        color="custom"
        variant="contained"
        size="small"
        onClick={() =>
          navigate('/resumeDetail', {
            state: {
              placeNotes: 'PlaceNotes',
              row: data,
              mtab: 'Resume',
              fTab: 'submitted',
            },
          })
        }
      >
        Add Note
      </Button>
    </Stack>

    <Typography
      variant="h5"
      color="#3C6BA5"
      sx={{ textTransform: 'capitalize', mt: -3 }}
      textAlign="center"
    >
      Notes
    </Typography> */}

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
              justifyContent: { xs: 'center', sm: 'space-between' },
              width: '100%',
              mb: 2,
            }}
          >
            <Typography
              variant="h5"
              color="#3C6BA5"
              sx={{
                textTransform: 'capitalize',
                textAlign: 'center',
                width: '100%',
                mt: { xs: 0, sm: -3 },
                mb: { xs: 1, sm: 0 },
              }}
            >
              Notes
            </Typography>

            <Box
              sx={{
                width: { xs: '100%', sm: 'auto' },
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-end' },
              }}
            >
              <Button
                color="custom"
                variant="contained"
                size="small"
                onClick={() =>
                  navigate('/resumeDetail', {
                    state: {
                      placeNotes: 'PlaceNotes',
                      row: data,
                      mtab: 'Resume',
                      fTab: 'submitted',
                    },
                  })
                }
              >
                Add Note
              </Button>
            </Box>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <Scrollbar sx={{ maxHeight: 400, overflowX: 'auto' }}>
            <Box sx={{ minWidth: 600 }}>
              <Stack
                sx={{
                  backgroundColor: 'text.secondary',
                  flexDirection: 'row',
                  p: 1,
                  py: 0.5,
                  borderRadius: 1,
                }}
              >
                <Typography color="white" sx={{ minWidth: '18%', fontSize: '0.976rem', fontWeight: '600' }}>
                  Date
                </Typography>
                <Typography color="white" sx={{ width: '13%', fontSize: '0.976rem', fontWeight: '600' }}>
                  User
                </Typography>
                <Typography color="white" sx={{ width: '80%', fontSize: '0.976rem', fontWeight: '600' }}>
                  Note
                </Typography>
              </Stack>

              {his?.length
                ? his.map((item, index) => (
                    <Stack
                      key={index}
                      sx={{
                        background: index % 2 === 0 ? 'text.background' : tablebg,
                        flexDirection: 'row',
                        p: 1,
                      }}
                    >
                      <Typography sx={{ minWidth: '18%' }}>
                        {`${new Date(item.createdAt)?.toLocaleString('en-US', optionsDate)} 
${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}:${String(
                          new Date(item?.createdAt)?.getMinutes()
                        )?.padStart(2, '0')}`}
                      </Typography>
                      <Typography
                        sx={{
                          width: '13%',
                          textTransform: 'capitalize',
                          fontWeight: '800',
                          color: 'text.secondary',
                        }}
                      >
                        {item?.actionBy}
                      </Typography>
                      <Typography sx={{ width: '80%' }}>{item?.note}</Typography>
                    </Stack>
                  ))
                : null}
            </Box>
          </Scrollbar>
        </Box>
      </Modal>

      {/* 
      <Dialog open={invoiceModalOpen} onClose={() => { setInvoiceModalOpen(false) }} maxWidth="md" fullWidth={false} PaperProps={{
        sx: {
          width: "750px",
          maxWidth: "90%",
        },
      }}>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
          Invoice
          <Button variant="contained" size="small" onClick={handleEditSave}>
            {isInvoiceEdit ? "Save" : "Edit"}

          </Button>
        </DialogTitle>




        <DialogContent
          sx={{
            border: "2px solid #2f4fa1",
            borderRadius: 2,
            padding: 4,
            fontSize: 14,
          }}

          ref={pdfRef}
        >
      
          <Typography
            align="center"
            fontWeight={700}
            letterSpacing={1}
            mb={3}
          >
            INVOICE
          </Typography>

        
          <Box display="flex" justifyContent="space-between">
           
            <Box width="60%">
             
              <Box mb={2}>
                <Typography fontWeight={600}>From :</Typography>
                {isInvoiceEdit ? (
                  <TextField
                    name="fromAddress"
                    multiline
                    minRows={2}
                    //  fullWidth
                    size="small"
                    value={invoiceData.fromAddress}
                    onChange={handleChange}
                  />
                ) : (
                  <Typography whiteSpace="pre-line">
                    {invoiceData.fromAddress}
                  </Typography>
                )}
              </Box>

              
              <Box mb={3}>
                <Typography fontWeight={600}>Billed To :</Typography>
                {isInvoiceEdit ? (
                  <TextField
                    name="billedTo"
                    multiline
                    minRows={2}
                    //  fullWidth
                    size="small"
                    value={invoiceData.billedTo}
                    onChange={handleChange}
                  />
                ) : (
                  <Typography whiteSpace="pre-line">
                    {invoiceData.billedTo}
                  </Typography>
                )}
              </Box>

              <Box>
                <Typography fontWeight={600}>ACH Details:</Typography>

                {isInvoiceEdit ? (
                  <>
                    <TextField
                      label="Account Number"
                      name="accountNumber"
                      //  fullWidth 
                      size="small"
                      value={invoiceData.accountNumber}
                      onChange={handleChange}
                      sx={{ mt: 1 }}
                    />
                    <TextField
                      label="Account Type"
                      name="accountType"
                      //  fullWidth
                      value={invoiceData.accountType}
                      size="small"
                      onChange={handleChange}
                      sx={{ mt: 1 }}
                    />
                    <TextField
                      label="Routing Number"
                      name="routingNumber"
                      //  fullWidth
                      size="small"
                      value={invoiceData.routingNumber}
                      onChange={handleChange}
                      sx={{ mt: 1 }}
                    />
                 
                    <TextField
                      label="Bank Details"
                      multiline
                      minRows={2}
                      size="small"
                      name="bankName"
                      value={invoiceData.bankName}
                      onChange={handleChange}
                    />






                    <TextField
                      label="Beneficiary Name"
                      name="beneficiaryName"
                      //  fullWidth
                      size="small"
                      value={invoiceData.beneficiaryName}
                      onChange={handleChange}
                      sx={{ mt: 1 }}
                    />
                  </>
                ) : (
                  <>
                    <Typography>Account Number : {invoiceData.accountNumber}</Typography>
                    <Typography>Account Type : {invoiceData.accountType}</Typography>
                    <Typography>Routing Number : {invoiceData.routingNumber}</Typography>
                    <Typography>Bank Details : {invoiceData.bankName}</Typography>
                    <Typography>
                      Beneficiary Name : {invoiceData.beneficiaryName}
                    </Typography>
                  </>
                )}
              </Box>
            </Box>

       
            <Box width="35%">
              {isInvoiceEdit ? (
                <>
                  <TextField
                    type="date"
                    label="Date"
                    InputLabelProps={{ shrink: true }}
                    name="invoiceDate"
                    sx={{ width: 160, mb: 2 }}
                    //    fullWidth
                    size="small"
                    value={invoiceData.invoiceDate}
                    onChange={handleChange}

                  />
                  <TextField
                    label="Invoice #"
                    name="invoiceNumber"
                    //  fullWidth
                    size="small"
                    value={invoiceData.invoiceNumber}
                    onChange={handleChange}
                    sx={{ width: 160, mb: 2 }}
                  />
                  <TextField
                    type="date"
                    label="Due Date"
                    InputLabelProps={{ shrink: true }}
                    name="dueDate"
                    //   fullWidth
                    size="small"
                    sx={{ width: 160, mb: 2 }}
                    value={invoiceData.dueDate}
                    onChange={handleChange}
                  />
                </>
              ) : (
                <>
                  <Typography>Date : {invoiceData.invoiceDate}</Typography>
                  <Typography>Invoice # : {invoiceData.invoiceNumber}</Typography>
                  <Typography>Due Date : {invoiceData.dueDate}</Typography>
                </>
              )}
            </Box>
          </Box>

        
          <Box mt={4}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Description</TableCell>
                  <TableCell>Rate</TableCell>
                  <TableCell>Hours</TableCell>
                  <TableCell>Amount</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow>
                  <TableCell>
                    {isInvoiceEdit ? (
                      <TextField
                        variant="standard"
                        //  fullWidth
                        size="small"
                        name="description"
                        value={invoiceData.description}
                        onChange={handleChange}
                      />
                    ) : (
                      <Typography>{invoiceData.description}</Typography>
                    )}
                  </TableCell>
                  <TableCell>${rate}/hr</TableCell>
                  <TableCell>{totalHours}</TableCell>
                  <TableCell>${rate *  fun1(totalHours)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>

         
          <Box textAlign="right" mt={3}>
            <Typography>Subtotal : ${rate*fun1(totalHours)}</Typography>
            <Typography>Tax : $0</Typography>
            <Typography fontWeight={700}>Total : ${rate*fun1(totalHours)}</Typography>
          </Box>

       
          <Box textAlign="center" mt={4}>

            <>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept=".pdf"
                onChange={handleFileChange55} 
              />

              <Button
                variant="contained"
                disabled={!isInvoiceSaved}
                onClick={handleUploadClick11}
              >
                Upload (Select PDF)
              </Button>

              {selectedFile && (
                <p style={{ marginTop: "8px" }}>
                  Selected File: {selectedFile.name}
                </p>
              )}
            </>

          </Box>
        </DialogContent>
      </Dialog>   */}

      <Modal
        open={invoiceModalOpen}
        onClose={() => setInvoiceModalOpen(false)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            border: '3px solid #3C6BA5',
            borderRadius: 2,
            width: '750px',
            maxWidth: '95%',
            bgcolor: 'background.paper',
            p: 3,

            maxHeight: '90vh',
            overflowY: 'auto',
            overflowX: 'hidden',

            '&::-webkit-scrollbar': { width: '0px' },
            scrollbarWidth: 'none',
          }}
        >
          <Box
            sx={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              mb: 2,
            }}
          >
            <Typography
              sx={{
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
              }}
              fontSize={18}
              fontWeight={700}
            >
              Invoice
            </Typography>

            <Box sx={{ marginLeft: 'auto' }}>
              <Button variant="contained" size="small" onClick={handleEditSave}>
                {isInvoiceEdit ? 'Save' : 'Edit'}
              </Button>
            </Box>
          </Box>

          <Box
            ref={pdfRef}
            sx={{
              border: '2px solid #3C6BA5',
              borderRadius: 2,
              p: 4,
            }}
          >
            <Box
              component="img"
              src={logoCompany}
              alt="Logo"
              sx={{
                height: 60,
                width: 'auto',
                objectFit: 'contain',
              }}
            />

            <Typography align="center" fontWeight={700} mb={3}>
              INVOICE
            </Typography>

            <Box display="flex" justifyContent="space-between" gap={2}>
              <Box width="50%">
                <Box mb={2}>
                  <Typography fontWeight={600}>From :</Typography>
                  {isInvoiceEdit ? (
                    <TextField
                      multiline
                      minRows={2}
                      size="small"
                      fullWidth
                      name="fromAddress"
                      value={invoiceData.fromAddress}
                      onChange={handleChange}
                    />
                  ) : (
                    <Typography whiteSpace="pre-line">{invoiceData.fromAddress}</Typography>
                  )}
                </Box>

                <Box mb={2}>
                  <Typography fontWeight={600}>Billed To :</Typography>
                  {isInvoiceEdit ? (
                    <TextField
                      multiline
                      minRows={2}
                      size="small"
                      fullWidth
                      name="billedTo"
                      value={invoiceData.billedTo}
                      onChange={handleChange}
                    />
                  ) : (
                    <Typography whiteSpace="pre-line">{invoiceData.billedTo}</Typography>
                  )}
                </Box>

                <Box mt={2}>
                  <Typography fontWeight={600} mb={1}>
                    ACH Details :
                  </Typography>

                  {isInvoiceEdit ? (
                    <Stack spacing={1.5}>
                      {[
                        ['Account Number', 'accountNumber'],
                        ['Account Type', 'accountType'],
                        ['Routing Number', 'routingNumber'],
                      ].map(([label, name]) => (
                        <Box key={name} display="flex" gap={1}>
                          <Typography sx={{ minWidth: 150 }}>{label} :</Typography>
                          <TextField
                            size="small"
                            fullWidth
                            name={name}
                            value={invoiceData[name]}
                            onChange={handleChange}
                          />
                        </Box>
                      ))}

                      <Box display="flex" gap={1}>
                        <Typography sx={{ minWidth: 150 }}>Bank Details :</Typography>
                        <TextField
                          multiline
                          minRows={2}
                          size="small"
                          fullWidth
                          name="bankName"
                          value={invoiceData.bankName}
                          onChange={handleChange}
                        />
                      </Box>

                      <Box display="flex" gap={1}>
                        <Typography sx={{ minWidth: 150 }}>Beneficiary Name :</Typography>
                        <TextField
                          size="small"
                          fullWidth
                          name="beneficiaryName"
                          value={invoiceData.beneficiaryName}
                          onChange={handleChange}
                        />
                      </Box>
                    </Stack>
                  ) : (
                    <>
                      <Typography>Account Number : {invoiceData.accountNumber}</Typography>
                      <Typography>Account Type : {invoiceData.accountType}</Typography>
                      <Typography>Routing Number : {invoiceData.routingNumber}</Typography>
                      <Typography>Bank Details : {invoiceData.bankName}</Typography>
                      <Typography>Beneficiary Name : {invoiceData.beneficiaryName}</Typography>
                    </>
                  )}
                </Box>
              </Box>

              <Box width="35%">
                {isInvoiceEdit ? (
                  <>
                    <Typography fontWeight={600}>Date :</Typography>
                    <TextField
                      type="date"
                      size="small"
                      fullWidth
                      name="invoiceDate"
                      value={invoiceData.invoiceDate}
                      onChange={handleChange}
                      sx={{ mb: 2 }}
                    />

                    <Typography fontWeight={600}>Invoice :</Typography>
                    <TextField
                      size="small"
                      fullWidth
                      name="invoiceNumber"
                      value={invoiceData.invoiceNumber}
                      onChange={handleChange}
                      sx={{ mb: 2 }}
                    />

                    <Typography fontWeight={600}>Due Date :</Typography>
                    <TextField
                      type="date"
                      size="small"
                      fullWidth
                      name="dueDate"
                      value={invoiceData.dueDate}
                      onChange={handleChange}
                    />
                  </>
                ) : (
                  <>
                    <Typography>Date : {invoiceData.invoiceDate}</Typography>
                    <Typography>Invoice # : {invoiceData.invoiceNumber}</Typography>
                    <Typography>Due Date : {invoiceData.dueDate}</Typography>
                  </>
                )}
              </Box>
            </Box>

            <Box mt={4}>
              <TableContainer component={Paper}>
                <Table sx={{ tableLayout: 'fixed', width: '100%' }} aria-label="simple table">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: 'text.secondary' }}>
                      {['Description', 'Rate', 'Hours', 'Amount'].map((h) => (
                        <TableCell key={h} sx={{ color: 'white', py: 0.5 }}>
                          {h}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ textAlign: 'left' }}>
                        {isInvoiceEdit ? (
                          <TextField
                            variant="standard"
                            fullWidth
                            name="description"
                            value={invoiceData.description}
                            onChange={handleChange}
                          />
                        ) : (
                          invoiceData.description
                        )}
                      </TableCell>
                      <TableCell sx={{ pl: 2 }}>
                        {localStorage.getItem('country') === 'INDIA'
                          ? '₹'
                          : localStorage.getItem('country') === 'UK'
                          ? '£'
                          : '$'}
                        {rate}/hr
                      </TableCell>

                      <TableCell sx={{ pl: 2 }}>{totalHours}</TableCell>
                      <TableCell sx={{ pl: 2 }}>
                        {' '}
                        {localStorage.getItem('country') === 'INDIA'
                          ? '₹'
                          : localStorage.getItem('country') === 'UK'
                          ? '£'
                          : '$'}
                        {rate * fun1(totalHours)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                mt: 4,
              }}
            >
              <Typography sx={{ ml: '120px', fontSize: 14, color: '#555' }}>Thank you for your business</Typography>

              <Box textAlign="right">
                <Typography>
                  Subtotal :{' '}
                  {localStorage.getItem('country') === 'INDIA'
                    ? '₹'
                    : localStorage.getItem('country') === 'UK'
                    ? '£'
                    : '$'}
                  {rate * fun1(totalHours)}
                </Typography>
                <Typography>
                  Tax :{' '}
                  {localStorage.getItem('country') === 'INDIA'
                    ? '₹'
                    : localStorage.getItem('country') === 'UK'
                    ? '£'
                    : '$'}
                  0
                </Typography>
                <Typography fontWeight={700}>
                  Total :{' '}
                  {localStorage.getItem('country') === 'INDIA'
                    ? '₹'
                    : localStorage.getItem('country') === 'UK'
                    ? '£'
                    : '$'}
                  {rate * fun1(totalHours)}
                </Typography>
              </Box>
            </Box>

            <Box textAlign="center" mt={4}>
              <>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                  accept=".pdf"
                  onChange={handleFileChange55}
                />

                <Button variant="contained" disabled={!isInvoiceSaved} onClick={handleUploadClick11}>
                  Upload (Select PDF)
                </Button>

                {selectedFile && <p style={{ marginTop: '8px' }}>Selected File: {selectedFile.name}</p>}
              </>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal open={modalOpentimesheet} onClose={handleCloseModaltimesheet} style={{ borderRadius: 10 }}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95%', sm: '70%' },
          //  height: '70%',
            // width: { xs: '85%', sm: '60%' },
            bgcolor: 'background.paper',
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
          }}
        >
          <Box ref={pdfRef1} sx={{}}>
            <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
              Time sheet
            </Typography>

            <Box display="flex" justifyContent="flex-end" mb={2}>
              {!isEditMode ? (
                <Button variant="contained" sx={{ bgcolor: '#3C6BA5' }} onClick={handleEditAll}>
                  Edit
                </Button>
              ) : (
                <Button variant="contained" sx={{ bgcolor: '#3C6BA5' }} onClick={handleSaveAll}>
                  Save
                </Button>
              )}
            </Box>

            <Grid container spacing={2} mb={3}>
              {/* Box 1 */}
              {/* <Grid item xs={12} md={4}>
    <Box
      sx={{
        border: "4px solid #000",
        borderRadius: "12px",
        padding: "10px",
        background: "#f8fbff",
        height: { xs: "auto", md: 100 },    
        overflow: "hidden",
      }}
    >
      <Typography><b>Candidate Id:</b>{' '}
  <span style={{ color: '#3C6BA5',fontWeight:"bold"}}>
    {id || TokenData.candidateId}
  </span></Typography>
      <Typography><b>Name :</b>{' '}
  <span style={{ color: '#3C6BA5',fontWeight:"bold"}}>
    {candidateName || TokenData.candidateName}
  </span></Typography>
      <Typography><b>Email :</b>{' '}
  <span style={{ color: '#3C6BA5',fontWeight:"bold" }}>
 {email || TokenData.
email}
  </span></Typography>
      <Typography><b>Job Title :</b>  {' '}
  <span style={{ color: '#3C6BA5',fontWeight:"bold" }}>
  {jobTitle || TokenData.jobTitle}
  </span></Typography>
    </Box>
  </Grid>  */}
              {/* Box 2 */}
              {/* <Grid item xs={12} md={4}>
    <Box
      sx={{
        border: "4px solid #000",
        borderRadius: "12px",
        padding: "10px",
        background: "#f8fbff",
        height: { xs: "auto", md: 100 },     // responsive height
        overflow: "hidden",
      }}
    >
    <Typography>
  <b>Client Name :</b>{' '}
  <span style={{  fontWeight: "bold",color: '#3C6BA5'}}>
    {endClientName || TokenData.endClientName}
  </span>
</Typography>

      <Typography>
           <b>Address:</b> 1358 Sandal Suites, Bon House,
               Jersey City, NJ 133217 this is static
      </Typography>
    </Box>
  </Grid> */}
              {/* Box 3 */}
              {/* <Grid item xs={12} md={4}>
    <Box
      sx={{
        border: "4px solid #000",
        borderRadius: "12px",
        padding: "10px",
        background: "#f8fbff",
        height: { xs: "auto", md: 100 },     // responsive height
        overflow: "hidden",
      }}
    >
      <Typography><b>Reporting Manager :</b> {' '}
  <span style={{  fontWeight: "bold",color: '#3C6BA5'}}>
    {reportingManagerName || TokenData.reportingManagerName}
  </span></Typography>
      <Typography><b>Email :</b>{' '}
  <span style={{  fontWeight: "bold",color: '#3C6BA5'}}>
    {reportingManagerEmail || TokenData.reportingManagerEmail}
  </span></Typography>
    </Box>
         </Grid> */}
            </Grid>

            <Grid container mb={2} spacing={2}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    background: tablebg,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '1px solid #3C6BA5',
                    height: '26px',
                    p: 1,
                    fontWeight: 700,
                    textAlign: 'center',
                    borderRadius: '8px',
                  }}
                >
                  Details
                </Box>
              </Grid>
            </Grid>

            <Scrollbar data-scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
              {weeksData.map((week, wIdx) => {
                const totals = getWeekTotals(week.days);
                return (
                  <Box key={wIdx} sx={{ mb: 4 }}>
                    {/* WEEK + TABLE */}
                    <Box sx={{ display: 'flex', overflowX: 'auto' }}>
                      {/* <Box
                sx={{
                  background: tablebg,
                  border: "2px solid #3C6BA5",
                  borderRadius: "10px",
                  writingMode: "vertical-rl",
                  textOrientation: "upright",
                  


                  fontWeight: 700,
                  px: 1,
                  mr: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                WEEK {week.weekNumber}
              </Box> */}

                      <Box
                        sx={{
                          background: tablebg,
                          border: '1px solid #3C6BA5',
                          borderRadius: '10px',

                          writingMode: 'vertical-rl',
                          textOrientation: 'mixed',
                          fontSize: '18px',
                          transform: 'rotate(180deg)',
                          width: '26px',

                          fontWeight: 700,
                          px: 1,
                          mr: 1,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Week {week.weekNumber}
                      </Box>

                      <TableContainer
                        sx={{ minWidth: 900, border: '2px solid #3C6BA5', width: 'fit-content', borderRadius: '10px' }}
                      >
                        <Table sx={{ minWidth: 900, borderRadius: '10px' }}>
                          <TableHead>
                            <TableRow>
                              {[
                                'Day / Date',
                                'Time In',
                                'Break',
                                'Time Out',
                                'Time Off',
                                'Working Hours',
                                'Overtime',
                                'Total Hours',
                              ].map((h) => (
                                <TableCell
                                  key={h}
                                  sx={{ border: '1px solid #a4b0bf', fontWeight: 700, textAlign: 'center', py: 0.3 }}
                                >
                                  {h}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {week.days.map((row, i) => (
                              <TableRow key={i} sx={{ py: 0, my: 0 }}>
                                {/* Day / Date */}
                                <TableCell sx={{ border: '1px solid #a4b0bf', textAlign: 'center', py: 0.2 }}>
                                  {row.day} -{' '}
                                  {new Date(+row.date)
                                    .toLocaleDateString('en-US', {
                                      month: 'short',
                                      day: '2-digit',
                                      year: 'numeric',
                                    })
                                    .replace(',', '')
                                    .replace(/ /g, '-')}
                                </TableCell>

                                {/* Time In */}

                                {/* <TableCell sx={{ border: "2px solid #3C6BA5", textAlign: "center" , py: 0.5,}}>
        {row.editMode ? (
          <TextField
            size="small"
            value={row.timeIn}
            onChange={(e) => handleChange(wIdx, i, "timeIn", e.target.value)}
          />
        ) : (
          row.timeIn
        )} 
             
          















      </TableCell>  */}

                                <TableCell sx={{ border: '1px solid #a4b0bf', textAlign: 'center', py: 0.2 }}>
                                  {row.editMode ? (
                                    <Select
                                      size="small"
                                      value={row.timeIn || ''}
                                      onChange={(e) => handleChangetime(wIdx, i, 'timeIn', e.target.value)}
                                      sx={{ minWidth: 90 }}
                                    >
                                      {timeOptions.map((t) => (
                                        <MenuItem key={t} value={t}>
                                          {t}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  ) : (
                                    row.timeIn
                                  )}
                                </TableCell>

                                {/* Break */}

                                {/* 
      <TableCell sx={{ border: "2px solid #3C6BA5", textAlign: "center" , py: 0.5,}}> 
        {row.editMode ? (
          <TextField
                 size="small"
                 value={row.break}
                 onChange={(e) => handleChange(wIdx, i, "break", e.target.value)}
          />
        ) : (
                 row.break 
        )}
      </TableCell> */}

                                <TableCell sx={{ border: '1px solid #a4b0bf', textAlign: 'center', py: 0.2 }}>
                                  {row.editMode ? (
                                    <TextField
                                      select
                                      size="small"
                                      value={row.break || ''}
                                      onChange={(e) => handleChangetime(wIdx, i, 'break', e.target.value)}
                                      sx={{ minWidth: 90 }}
                                    >
                                      {breakOptions.map((b) => (
                                        <MenuItem key={b} value={b}>
                                          {b}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  ) : (
                                    row.break
                                  )}
                                </TableCell>

                                {/* Time Out */}
                                {/* <TableCell sx={{ border: "2px solid #3C6BA5", textAlign: "center" , py: 0.5,}}>
        {row.editMode ? (
          <TextField
            size="small"
            value={row.timeOut}
            onChange={(e) => handleChange(wIdx, i, "timeOut", e.target.value)} 
          />
        ) : (
          row.timeOut
        )}
      </TableCell> */}

                                {/* <TableCell sx={{ border: "2px solid #3C6BA5", textAlign: "center", py: 0.2, }}>
                                {row.editMode ? (
                                  <Select
                                    size="small"
                                    value={row.timeOut || ""}
                                    onChange={(e) => handleChangetime(wIdx, i, "timeOut", e.target.value)}
                                    sx={{ minWidth: 90 }}
                                  >
                                    {timeOptions.map((t) => (
                                      <MenuItem key={t} value={t}>
                                        {t}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                ) : (
                                  row.timeOut
                                )}

                              </TableCell> */}

                                <TableCell sx={{ border: '1px solid #a4b0bf', textAlign: 'center', py: 0.2 }}>
                                  {row.editMode ? (
                                    <Select
                                      size="small"
                                      value={row.timeOut || ''}
                                      onChange={(e) => handleChangetime(wIdx, i, 'timeOut', e.target.value)}
                                      sx={{ minWidth: 90 }}
                                    >
                                      {getFilteredTimeOutOptions(row.timeIn).map((t) => (
                                        <MenuItem key={t} value={t}>
                                          {t}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  ) : (
                                    row.timeOut
                                  )}
                                </TableCell>

                                {/* Time Off */}
                                <TableCell sx={{ border: '1px solid #a4b0bf', textAlign: 'center', py: 0.2 }}>
                                  {row.editMode ? (
                                    <Select
                                      size="small"
                                      value={row.timeOff}
                                      onChange={(e) => handleChangetime(wIdx, i, 'timeOff', e.target.value)}
                                    >
                                      <MenuItem value="">-</MenuItem>
                                      <MenuItem value="Paid">Paid</MenuItem>
                                      <MenuItem value="Unpaid">Unpaid</MenuItem>
                                    </Select>
                                  ) : (
                                    row.timeOff
                                  )}
                                </TableCell>

                                {/* Working Hours */}
                                {/* <TableCell sx={{ border: "2px solid #3C6BA5", textAlign: "center" }}>
        {row.editMode ? (
          <TextField
            size="small"
            value={row.workingHours}
            onChange={(e) => handleChange(wIdx, i, "workingHours", e.target.value)}
          />
        ) : (
          row.workingHours
        )}
      </TableCell> */}

                                {/* Working Hours */}
                                <TableCell sx={{ border: '1px solid #a4b0bf', textAlign: 'center', py: 0.2 }}>
                                  <Box sx={{ color: row.approvalStatus === 'Disapproved' ? 'red' : 'none' }}>
                                    {row.workingHours}
                                  </Box>
                                </TableCell>

                                {/* Overtime */}

                                {/* <TableCell sx={{ border: "2px solid #3C6BA5", textAlign: "center" , py: 0.5,}}>
        {row.editMode ? (
          <TextField
            size="small" 
            value={row.overtime}
            onChange={(e) => handleChange(wIdx, i, "overtime", e.target.value)}
          />
        ) : (
          row.overtime 
        )}
      </TableCell> */}

                                <TableCell sx={{ border: '1px solid #a4b0bf', textAlign: 'center', py: 0.2 }}>
                                  {row.editMode ? (
                                    <TextField
                                      select
                                      size="small"
                                      value={row.overtime || ''}
                                      onChange={(e) => handleChangetime(wIdx, i, 'overtime', e.target.value)}
                                      sx={{ minWidth: 90 }}
                                    >
                                      {breakOptions.map((time) => (
                                        <MenuItem key={time} value={time}>
                                          {time}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  ) : (
                                    <Box sx={{ color: row.approvalStatus === 'Disapproved' ? 'red' : 'none' }}>
                                      {row.overtime}
                                    </Box>
                                  )}
                                </TableCell>

                                {/* Total Hours */}
                                {/* <TableCell sx={{ border: "2px solid #3C6BA5", textAlign: "center" }}>
        {row.editMode ? (
          <TextField
            size="small"
            value={row.totalHours}
            onChange={(e) => handleChange(wIdx, i, "totalHours", e.target.value)}
          />
        ) : (
          row.totalHours
        )}
      </TableCell> */}

                                <TableCell sx={{ border: '1px solid #a4b0bf', textAlign: 'center', py: 0.2 }}>
                                  <Box sx={{ color: row.approvalStatus === 'Disapproved' ? 'red' : 'none' }}>
                                    {row.totalHours}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>

                    {/* ===== TOTALS (TABLE KE NICHE) ===== */}

                    {/* <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                mt: 2,
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  border: "3px solid black",
                //   justifyContent: "center",
                  borderRadius: "8px",
                  px: 2,
                  py: 1,
                  gap: 5,
                  flexWrap: "wrap",
                  width:470
                }}
              >
                <Typography >Total Hours:</Typography>
                 <Typography >{totals.working}</Typography>
                <Typography >{totals.overtime}</Typography>
                <Typography >{totals.total}</Typography>
              </Box>

              <Button
                variant="contained"
                sx={{
                  background: "#9eff84",
                //  color: "#004700",
                  border: "3px solid black",
                  borderRadius: "8px",
                  minWidth: 340,
                }}
              >
                Paid
              </Button>
            </Box>
 */}

                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                      sx={{ mt: 2, width: '100%' }}
                    >
                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            alignItems: { xs: 'flex-start', sm: 'center' },
                            justifyContent: 'space-between',
                            border: '1px solid #a4b0bf',
                            borderRadius: '8px',
                            px: { xs: 2, sm: 3 },
                            py: 1,
                            width: '100%',
                            height: { xs: 'auto', sm: '26px' },
                            maxWidth: 600,
                            background: '#f8fbff',
                            gap: { xs: 1.5, sm: 0 },
                          }}
                        >
                          <Typography fontWeight={600}>Total Hours:</Typography>

                          <Box
                            sx={{
                              display: 'flex',
                              width: { xs: '100%', sm: 'auto' },
                              justifyContent: { xs: 'space-between', sm: 'flex-end' },
                              gap: { xs: 2, sm: 10 },
                            }}
                          >
                            <Typography>{totals.working}</Typography>
                            <Typography>{totals.overtime}</Typography>
                            <Typography>{totals.total}</Typography>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                );
              })}
            </Scrollbar>

            {/* ===== GRAND TOTAL (ALL WEEKS) ===== */}

            <Box
              sx={{
                mt: 5,
                px: 1,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  alignItems: { xs: 'flex-start', sm: 'center' },
                  justifyContent: 'space-between',
                  border: '1px solid #a4b0bf',
                  borderRadius: '10px',
                  height: { xs: 'auto', sm: '26px' },

                  px: { xs: 2, sm: 3 },
                  py: 1.5,
                  width: '100%',
                  maxWidth: 650,
                  background: '#f8fbff',
                  gap: { xs: 1.5, sm: 0 },
                }}
              >
                <Typography fontWeight={800}>Total Billable Hours:</Typography>

                <Box
                  sx={{
                    display: 'flex',
                    gap: { xs: 2, sm: 10 },
                    width: { xs: '100%', sm: 'auto' },
                    justifyContent: { xs: 'space-between', sm: 'flex-end' },
                  }}
                >
                  <Typography fontWeight={700}>{grandTotals.working}</Typography>
                  <Typography fontWeight={700}>{grandTotals.overtime}</Typography>
                  <Typography fontWeight={800}>{grandTotals.total}</Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          <Box sx={{ textAlign: 'center' }}>
            <input type="file" ref={browseInputRef} style={{ display: 'none' }} onChange={onFileSelect} />

            <Button
              variant="contained"
              size="small"
              sx={{ textAlign: 'center', backgroundColor: '#3C6BA5', ml: 1.5, mt: 2 }}
              onClick={openFileBrowser}
              disabled={isUploading}
            >
              {isUploading ? 'Uploading...' : 'Upload'}
            </Button>

            {uploadedFile && (
              <p>
                Selected File: <b>{uploadedFile.name}</b>
              </p>
            )}

            {/* <Button
              variant="contained"

              size="small"
              sx={{ textAlign: "center", backgroundColor: "#3C6BA5", ml: 3 }}
              onClick={handleDownloadPDF}
            >
              Download

            </Button> */}
          </Box>
        </Box>
      </Modal>

      <Modal open={openNotesModal2} onClose={handleCloseNotesModal2} style={{ borderRadius: 10 }}>
        <Box sx={styleClients}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
              justifyContent: { xs: 'center', sm: 'space-between' },
              width: '100%',
              mb: 2,
            }}
          >
            <Typography
              variant="h5"
              color="#3C6BA5"
              sx={{
                textTransform: 'capitalize',
                textAlign: 'center',
                width: '100%',
                mt: { xs: 0, sm: -3 },
                mb: { xs: 1, sm: 0 },
              }}
            >
              Notes
            </Typography>

            <Button
              color="custom"
              variant="contained"
              size="small"
              onClick={() =>
                navigate('/resumeDetail', {
                  state: {
                    placeNotes: 'PlaceNotes',
                    row: data,
                    mtab: 'Resume',
                    fTab: 'submitted',
                  },
                })
              }
            >
              Add Note
            </Button>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <Scrollbar sx={{ maxHeight: 400 }}>
            <Box sx={{ minWidth: 600 }}>
              {/* Header */}
              <Stack
                sx={{
                  backgroundColor: 'text.secondary',
                  flexDirection: 'row',
                  p: 1,
                  borderRadius: 1,
                }}
              >
                <Typography color="white" sx={{ minWidth: '18%', fontWeight: 600 }}>
                  Date
                </Typography>
                <Typography color="white" sx={{ width: '13%', fontWeight: 600 }}>
                  User
                </Typography>
                <Typography color="white" sx={{ width: '80%', fontWeight: 600 }}>
                  Note
                </Typography>
              </Stack>

              {/* Data */}
              {his?.map((item, index) => (
                <Stack
                  key={index}
                  sx={{
                    background: index % 2 === 0 ? 'text.background' : tablebg,
                    flexDirection: 'row',
                    p: 1,
                  }}
                >
                  <Typography sx={{ minWidth: '18%' }}>{new Date(item.createdAt).toLocaleString()}</Typography>
                  <Typography sx={{ width: '13%', fontWeight: 800 }}>{item.actionBy}</Typography>
                  <Typography sx={{ width: '80%' }}>{item.note}</Typography>
                </Stack>
              ))}
            </Box>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal
  open={openEditExpense}
  onClose={() => setOpenEditExpense(false)}
>
  <Box sx={style}>
    <Typography variant="h6" sx={{ mb: 2 }}>
      Edit Manual Expense
    </Typography>

    <TextField
      fullWidth
      label="Description of Expense"
      sx={{ mb: 2 }}
      value={editDescription}
      onChange={(e) => setEditDescription(e.target.value)}
    />

    <TextField
      fullWidth
      label={`Expected Compensation( In ${
        localStorage.getItem('country') === 'INDIA'
          ? 'INR'
          : 'Dollars'
      } )*`}
      placeholder="Expected Compensation"
      sx={{ mb: 2 }}
      value={editAmount}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {localStorage.getItem('country') === 'INDIA'
              ? '₹'
              : localStorage.getItem('country') === 'UK'
              ? '£'
              : '$'}
          </InputAdornment>
        ),
      }}
      onChange={(e) => {
        const newValue = e.target.value;

        if (/^\d*\.?\d*$/.test(newValue)) {
          setEditAmount(newValue);
        }
      }}
    />

    <Button
      color="custom"
      variant="contained"
      fullWidth
      onClick={handleEditExpense}
    >
      Update
    </Button>
  </Box>
</Modal>
    </>
  );
}

export default Placement;

const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 92;

const HEADER_MOBILE1 = 150;
const HEADER_DESKTOP1 = 300;

const StyledSearchbar = styled('div')(({ theme }) => ({
  top: 0,
  left: 0,
  zIndex: 99,
  width: '100%',
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  height: HEADER_MOBILE,
  padding: theme.spacing(0, 3),
  // boxShadow: theme.customShadows.z8,
  [theme.breakpoints.up('md')]: {
    height: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

const ModalContent = styled('div')(({ theme }) => ({
  marginTop: '220px',
  width: '100%',
  display: 'flex',
  marginRight: '50px',

  height: HEADER_MOBILE1,
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.customShadows.z8,
  [theme.breakpoints.up('md')]: {
    height: HEADER_DESKTOP1,
    padding: theme.spacing(0, 5),
  },
}));

const StyledIconButtonWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 'bold',
});

function Search({ placementFrom, searchData, func, funcc, funnc, resetSearch }) {
  const [formValues, setFormValues] = useState({
    commonSearch: '',
  });

  const [loading, setLoading] = useState(false);

  const searchPlace = (page = 1) => {
    setLoading(true);

    const token = localStorage.getItem('token');
    const body = {
      commonSearch: formValues.commonSearch,
      "page": page,
      limit: '50',
      "placementFrom": placementFrom,
    };
    Api('resume/searchPlacement', 'POST', body, token)
      .then((response) => {
        // console.log('Response:---------', response);

        console.log("data is what case in between ===>>", response);
        if (response.status === 401) {
          setLoading(false);
          searchData({ noData: 'noData' });
          // alert("fdf")
        }
        if (response.status === 200) {
          if (response.data.status === 200) { 
            const totalPage = Math.ceil(response?.data?.count / 50);
            searchData(response.data?.data, response.data?.count, totalPage);
            setLoading(false);
            // console.log("response.data.data", response.data.data)
          } else {
            setLoading(false);
            // console.log('Error:', response.data.message);
            // searchData(({ noData: "noData" }))
          }
        }
        else{
                   toast.warn(response?.data?.resmessage);
                   setLoading(false);  
        }
      })
      .catch((error) => {});
  };

  const clearInputField = () => {
    resetSearch();
    setFormValues({
      ...formValues,
      commonSearch: '',
    });
  };

  return (
    <>
      <div className="mob_search">
        <Paper
          component="form"
          sx={{
            // p: '2px 4px',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            border: '1px solid #1E74B3',
            borderRadius: '10px',
            marginTop: -18,
          }}
        >
          <InputBase
            sx={{ flex: 1, color: 'text.primary', border: 'none', outline: 'none', pl: 1 }}
            placeholder=" Placement Id | Candidate Name"
            inputProps={{ 'aria-label': 'search' }}
            value={formValues.commonSearch}
            onChange={(e) => {
              setFormValues({ ...formValues, commonSearch: e.target.value });
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                searchPlace();
              }
            }}
          />
        </Paper>
        {/* <Button style={{ marginLeft: '16px', color: 'white', backgroundColor: '#1E74B3', borderRadius: '10px', marginTop: '4px', height: '41px', width: '130px' }} onClick={fn}>Search</Button> */}
        <Button
          color="custom"
          variant="contained"
          size="small"
          sx={{ ml: 1.6, mt: -18 }}
          // disabled={formValues1.commonSearch === ''}
          disabled={loading}
          onClick={() => {
            searchPlace();
          }}
        >
          {/* Search */}
          {loading ? <CircularProgress size={24} /> : 'Search'}
        </Button>
        {formValues?.commonSearch && (
          <Button
            color="custom"
            variant="contained"
            size="small"
            sx={{ ml: 1.6, mt: -18 }}
            onClick={() => {
              clearInputField();
              func();
            }}
          >
            Close
          </Button>
        )}
      </div>
    </>
  );
}
